<template>
  <div>
    <b-modal
      id="modal-login"
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
      title=""
      size="sm"
    >
      <b-row align-h="center">
        <b-spinner
          class="m-5"
          style="width: 4rem; height: 4rem"
          variant="primary"
          :label="$t('Spinning')"
        ></b-spinner>
      </b-row>
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility1"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Settings") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility1 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <b-col class="d-flex align-items-center mb-1" md="12">
            <b-form-checkbox class="mr-1" v-model="settings.sameDate" />
            <h6 class="mb-0">
              {{ $t("Date of admission same as date of registration") }}
            </h6>
          </b-col>
          <b-col class="d-flex align-items-center mb-1" md="12">
            <b-form-checkbox class="mr-1" v-model="settings.sameClass" />
            <h6 class="mb-0">
              {{
                showHappinessTab
                  ? $t("Current group same as group admitted")
                  : $t("Current class same as class admitted")
              }}
            </h6>
          </b-col>
          <b-col class="d-flex align-items-center mb-1" md="12">
            <b-form-checkbox class="mr-1" v-model="settings.sameSec" />
            <h6 class="mb-0">
              {{
                showHappinessTab
                  ? $t("Current level same as level admitted")
                  : $t("Current section same as section admitted")
              }}
            </h6>
          </b-col>

          <b-col class="mt-1" md="12">
            <b-button variant="success" @click="saveSettings()" block>
              <span> {{ $t("Save") }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Search Student") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col>
            <b-input-group>
              <b-input-group-prepend
                is-text
                @click="loadSearch()"
                class="cursor-pointer"
              >
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                @keyup.enter="loadSearch()"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-form>

      <b-table
        class="mt-1"
        show-empty
        :busy="studentLoading"
        ref="selectableTable"
        :items="studentData"
        :fields="fields"
        responsive
        hover
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>

        <template #cell(details)="data">
          <p>
            <b
              ><span>{{ $t("Name") }}: </span> </b
            >{{ data.item.name }}
          </p>
          <p>
            <b
              ><span>{{ $t("Father") }}: </span></b
            >
            {{ data.item.father_name }}
          </p>
          <p>
            <b
              ><span>{{ $t("Class") }}: </span></b
            >
            {{ data.item.meta_class }}
          </p>
        </template>
      </b-table>
    </b-sidebar>

    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="sessionbar"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Manage Sessions") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="sessionbar = false"
        />
      </div>

      <b-form class="p-2" @submit.prevent>
        <b-row class="d-flex align-items-center">
          <b-col md="10">
            <b-form-group
              :label="$t('Name')"
              :invalid-feedback="$t('Session name is required')"
            >
              <b-form-input
                ref="sess_name"
                v-model="sessionObj.session"
                :placeholder="$t('Enter session name')"
                @focusout="SessName()"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-button
              variant="success"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="saveSession()"
              :disabled="savingacc"
            >
              <b-spinner v-if="savingacc" small type="grow" />
              <feather-icon v-else :icon="accIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="mt-1"
          show-empty
          :items="allSess"
          :fields="sessFields"
          responsive
          hover
          small
        >
          <template #head()="scope">
            <div>
              <span>{{ $t(scope.label) }}</span>
            </div>
          </template>

          <template #head(actions)="data">
            <div class="text-center">
              <span>{{ $t(data.label) }}</span>
            </div>
          </template>

          <template #cell(session)="data">
            <b-badge variant="light-primary" v-if="data.item.isCurrentSession">
              {{ data.item.session }}
            </b-badge>
            <span v-else>{{ data.item.session }}</span>
          </template>

          <template #cell(actions)="data">
            <div class="text-center">
              <b-button
                variant="primary"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="editSess(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>

              <b-button
                variant="outline-danger"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="deleteSess(data.item)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>

              <b-button
                v-if="!data.item.isCurrentSession"
                variant="outline-primary"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="setCurrentSess(data.item.id)"
              >
                <feather-icon icon="CheckCircleIcon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
      width="500px"
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Manage Discount References") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>

      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <b-col md="12">
            <b-form-group
              :label="$t('Name')"
              :invalid-feedback="$t('Name is required')"
              ref="d_name"
            >
              <b-form-input
                v-model.trim="disObj.name"
                :placeholder="$t('Enter name here')"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <template v-if="disSetting && disSetting.valueBool">
            <b-col md="6">
              <b-form-group
                :label="$t('Type')"
                :invalid-feedback="$t('Type is required')"
              >
                <v-select
                  v-model="disObj.discountType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="disTypes"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  label="text"
                  :placeholder="$t('Select type')"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Calculate By')"
                :invalid-feedback="$t('Calculate By is required')"
              >
                <v-select
                  v-model="disObj.calculatedBy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="disOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  label="text"
                  :placeholder="$t('Select')"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="disObj.calculatedBy == 'amount'">
              <b-form-group
                :label="$t('Amount')"
                :invalid-feedback="$t('Amount is required')"
                ref="d_amount"
              >
                <b-form-input
                  type="number"
                  :placeholder="$t('Enter amount')"
                  v-model="disObj.amount"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="disObj.calculatedBy == 'percentage'">
              <b-form-group
                :label="$t('Percentage')"
                :invalid-feedback="$t('Percentage is required')"
                ref="d_perc"
              >
                <b-form-input
                  type="number"
                  :placeholder="$t('Enter percentage')"
                  v-model="disObj.percentage"
                />
              </b-form-group>
            </b-col>
          </template>

          <b-col md="12">
            <b-button
              variant="success"
              class="mt-1"
              block
              @click="saveDis()"
              :disabled="savingDis"
            >
              <b-spinner v-if="savingDis" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="mt-2"
          show-empty
          :items="disData"
          :fields="disFields"
          responsive
          hover
          small
        >
          <template #head()="scope">
            <div>
              <span>{{ $t(scope.label) }}</span>
            </div>
          </template>
          <template #head(actions)="data">
            <div class="text-center">
              <span>{{ $t(data.label) }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="text-center">
              <b-button
                variant="primary"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="editDis(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>

              <!-- <b-button
                variant="outline-danger"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="deleteDis(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button> -->
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="visibility3"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Discount Setting") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility3 = false"
        />
      </div>

      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col
            class="d-flex align-items-center justify-content-between mb-1"
            md="12"
          >
            <label class="bv-no-focus-ring h4 mb-0 p-0 mr-1 text-dark">{{
              $t("Discount")
            }}</label>
            <b-form-checkbox v-model="dCopy.valueBool" switch />
          </b-col>
          <b-col md="12" class="mt-1">
            <b-button
              variant="success"
              :disabled="savingSett"
              block
              @click="saveDSett()"
            >
              <b-spinner v-if="savingSett" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <!-- back button  -->
    <div class="px-2">
      <b-button
        variant="outline-primary"
        size="sm"
        class="back-btn"
        @click="goBack"
      >
        <feather-icon icon="ArrowLeftIcon" class="mr-50" />
        {{ $t("Back") }}
      </b-button>
    </div>

    <form-wizard
      ref="wizard"
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="steps-transparent mb-1"
      @on-complete="shortcutSubmit"
    >
      <tab-content
        :title="$t('Student')"
        icon="feather icon-file-text"
        v-if="showHappinessTab"
      >
        <b-row class="match-height" align-h="center">
          <b-col md="6">
            <b-card>
              <b-row align-h="center">
                <!-- class="ml-3" -->
                <b-col sm="6">
                  <b-form-group
                    class="text-center happiness-photo-group"
                    ref="picture"
                    label="Plain Background"
                    :invalid-feedback="$t('Picture is required')"
                  >
                    <div class="happiness-photo-slot">
                      <div
                        v-if="!plus && logoloading !== true"
                        class="happiness-photo-frame happiness-photo-frame--empty happiness-photo-frame--clickable"
                        @click="$refs.fileProfile.click()"
                      >
                        <feather-icon
                          icon="ImageIcon"
                          size="34"
                          class="text-muted"
                        />
                        <small class="text-muted mt-50 d-block">{{
                          $t("Click to upload")
                        }}</small>
                      </div>

                      <div
                        v-else-if="!plus && logoloading === true"
                        class="happiness-photo-frame happiness-photo-frame--empty"
                      >
                        <b-spinner
                          variant="primary"
                          type="grow"
                          :label="$t('Spinning')"
                        />
                      </div>

                      <div v-else class="happiness-photo-frame">
                        <img
                          class="happiness-photo-img"
                          :src="plainBackgroundPreview"
                          alt="Plain Background"
                          referrerpolicy="no-referrer"
                          @error="onDrivePhotoPreviewError($event, plus)"
                          @click="
                            logoloading !== true && $refs.fileProfile.click()
                          "
                        />
                        <div
                          v-if="logoloading === true"
                          class="happiness-photo-upload-overlay"
                        >
                          <b-spinner variant="primary" type="grow" />
                        </div>
                        <b-button
                          v-if="logoloading !== true"
                          class="happiness-photo-delete-btn"
                          variant="secondary"
                          @click.stop="deleteLogo()"
                        >
                          <feather-icon icon="Trash2Icon" size="20" />
                        </b-button>
                      </div>

                      <input
                        type="file"
                        id="fileProfile"
                        hidden
                        ref="fileProfile"
                        @change="selectlogo()"
                        accept="image/*"
                      />
                    </div>
                  </b-form-group>
                </b-col>

                <b-col sm="6" v-if="otherPhoto">
                  <b-form-group
                    class="text-center happiness-photo-group"
                    :label="otherPhoto.meta_title"
                    :invalid-feedback="
                      $t(otherPhoto.meta_title + ' is required')
                    "
                  >
                    <div class="happiness-photo-slot">
                      <div
                        v-if="!otherPhoto.url && otherPhotoLoading !== true"
                        class="happiness-photo-frame happiness-photo-frame--empty happiness-photo-frame--clickable"
                        @click="$refs.otherProfile.click()"
                      >
                        <feather-icon
                          icon="ImageIcon"
                          size="34"
                          class="text-muted"
                        />
                        <small class="text-muted mt-50 d-block">{{
                          $t("Click to upload")
                        }}</small>
                      </div>

                      <div
                        v-else-if="
                          !otherPhoto.url && otherPhotoLoading === true
                        "
                        class="happiness-photo-frame happiness-photo-frame--empty"
                      >
                        <b-spinner
                          variant="primary"
                          type="grow"
                          :label="$t('Spinning')"
                        />
                      </div>

                      <div v-else class="happiness-photo-frame">
                        <img
                          class="happiness-photo-img"
                          :src="otherPhotoPreview"
                          :alt="otherPhoto.meta_title"
                          referrerpolicy="no-referrer"
                          @error="
                            onDrivePhotoPreviewError($event, otherPhoto.url)
                          "
                          @click="
                            otherPhotoLoading !== true &&
                              $refs.otherProfile.click()
                          "
                        />
                        <div
                          v-if="otherPhotoLoading === true"
                          class="happiness-photo-upload-overlay"
                        >
                          <b-spinner variant="primary" type="grow" />
                        </div>
                        <b-button
                          v-if="otherPhotoLoading !== true"
                          class="happiness-photo-delete-btn"
                          variant="secondary"
                          @click.stop="deleteOtherPhoto()"
                        >
                          <feather-icon icon="Trash2Icon" size="20" />
                        </b-button>
                      </div>

                      <input
                        type="file"
                        id="otherProfile"
                        hidden
                        ref="otherProfile"
                        @change="selectOtherPhoto()"
                        accept="image/*"
                      />
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <div
                style="position: absolute; right: 10px; top: 10px"
                class="d-flex align-items-center"
                v-if="false"
              >
                <b-form-checkbox
                  v-if="selected === 'add'"
                  v-model="addingMsg"
                  switch
                  @input="setMsg()"
                  v-b-tooltip.hover.top
                  :title="$t('Admission Message')"
                />
                <feather-icon
                  v-if="selected === 'add'"
                  icon="SettingsIcon"
                  size="28"
                  @click="visibility1 = true"
                  class="cursor-pointer ml-50"
                  v-b-tooltip.hover.top
                  :title="$t('Settings')"
                />
                <!-- <b-button
                  v-if="myObj && myObj.id > 0"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="myObj.synced ? 'outline-success' : 'outline-danger'"
                  class="btn-icon ml-50"
                  size="sm"
                  v-b-tooltip.hover.top
                  :title="
                    myObj.synced
                      ? $t('Synced Account Details')
                      : $t('Not Synced')
                  "
                  :disabled="syncLoading"
                  @click="showSyncedDetails(myObj.syncedDetails, myObj.id)"
                >
                  <b-spinner v-if="syncLoading" small />
                  <feather-icon v-else icon="SmartphoneIcon" />
                </b-button> -->
              </div>
              <!-- <h3 class="mt-1">Student Information</h3> -->
              <hr />
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Name') + ' *'"
                    :invalid-feedback="$t('Student name is required')"
                  >
                    <b-form-input
                      ref="name"
                      :placeholder="$t('Enter name')"
                      v-model.trim="myObj.name"
                      @focusout="CheckName()"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Nickname')"
                    :invalid-feedback="$t('Nickname is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter nickname')"
                      v-model="myObj.surname"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Gender')"
                    :invalid-feedback="$t('Gender is required')"
                  >
                    <v-select
                      v-model="myObj.gender"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="genders"
                      :clearable="false"
                      :placeholder="$t('Select gender')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Date of Birth')"
                    :invalid-feedback="$t('date of birth is required')"
                    ref="dob"
                  >
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_birth"
                      class="form-control"
                      :placeholder="$t('Select date of birth')"
                      @on-change="formatDate()"
                    />
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group
                    :label="$t('Nationality')"
                    :invalid-feedback="$t('Nationality is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter nationality')"
                      v-model.trim="myObj.nationality"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Religion')"
                    :invalid-feedback="$t('Religion is required')"
                  >
                    <v-select
                      v-model="myObj.religion"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="religions"
                      :clearable="false"
                      :placeholder="$t('Select religion')"
                    />
                  </b-form-group>
                </b-col> -->
                <b-col md="12">
                  <b-form-group
                    :label="$t('Place of birth')"
                    :invalid-feedback="$t('Place of birth is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter place of birth')"
                      v-model.trim="myObj.place_of_birth"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Father name')"
                    :invalid-feedback="$t('Father name is required')"
                  >
                    <b-form-input
                      ref="fname"
                      :placeholder="$t('Enter father name')"
                      v-model.trim="myObj.father_name"
                      @focusout="CheckFName()"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Father\'s Contact')"
                    :invalid-feedback="
                      $t('Please enter correct contact number')
                    "
                  >
                    <vue-tel-input
                      v-model="myObj.contact_father"
                      :inputOptions="vueTelOptions"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      @input="CheckFContact"
                    ></vue-tel-input>
                    <small class="mr-1 text-danger" v-if="fphoneerror">{{
                      $t("Phone number is required")
                    }}</small>
                    <small
                      class="mr-1 text-danger d-block"
                      v-else-if="contactDuplicateError"
                      >{{
                        $t(
                          "This number cannot match father, mother, or student contact."
                        )
                      }}</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Mother Name')"
                    :invalid-feedback="$t('Name is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_name"
                      :placeholder="$t('Enter mother name')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Mother\'s Contact')"
                    :invalid-feedback="$t('Please enter correct phone number')"
                  >
                    <vue-tel-input
                      :inputOptions="vueTelOptions"
                      @input="CheckMContact"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      v-model="myObj.contact_mother"
                    ></vue-tel-input>
                    <small class="mr-1 text-danger" v-if="mphoneerror">{{
                      $t("Phone number is required")
                    }}</small>
                    <small
                      class="mr-1 text-danger d-block"
                      v-else-if="contactDuplicateError"
                      >{{
                        $t(
                          "This number cannot match father, mother, or student contact."
                        )
                      }}</small
                    >
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group
                    :label="$t('Student\'s Contact')"
                    :invalid-feedback="$t('Please enter correct phone number')"
                  >
                    <vue-tel-input
                      :inputOptions="vueTelOptions"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      @input="CheckContact"
                      v-model="myObj.contact_student"
                    ></vue-tel-input>
                    <small class="mr-1 text-danger" v-if="phoneerror">{{
                      $t("Phone number is required")
                    }}</small>
                  </b-form-group>
                </b-col> -->
                <b-col md="6">
                  <b-form-group
                    :label="$t('Guardian\'s Name')"
                    :invalid-feedback="$t('Guardian\'s Name is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter guardian name')"
                      v-model="myObj.guardian_name"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Guardian\'s Contact')"
                    :invalid-feedback="$t('Guardian\'s Contact is required')"
                  >
                    <vue-tel-input
                      :inputOptions="vueTelOptions"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      v-model="myObj.guardian_office_phone"
                    ></vue-tel-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Father\'s Job')"
                    :invalid-feedback="$t('Father\'s Job is required')"
                  >
                    <b-form-input
                      v-model="myObj.father_occupation"
                      :placeholder="$t('Enter job')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Mother\'s Job')"
                    :invalid-feedback="$t('Mother\'s Job is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_occupation"
                      :placeholder="$t('Enter job')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Parent\'s Email')"
                    :invalid-feedback="$t('Email is required')"
                  >
                    <b-form-input
                      ref="fEmail"
                      v-model="myObj.father_email"
                      :placeholder="$t('Enter Email')"
                    />
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group
                    :label="$t('Mother Tongue')"
                    :invalid-feedback="$t('Mother Tongue is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter mother tongue')"
                      v-model.trim="myObj.mother_tongue"
                    />
                  </b-form-group>
                </b-col> -->
                <b-col md="12">
                  <b-form-group
                    :label="$t('Family\'s Address')"
                    :invalid-feedback="$t('Family\'s Address is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter address')"
                      v-model="myObj.address_current"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Family\'s Google Pin')"
                    :invalid-feedback="$t('Family\'s Google Pin is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter google pin')"
                      v-model="myObj.address_permanent"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Current School')"
                    :invalid-feedback="$t('Current School is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter current school')"
                      v-model.trim="myObj.last_institute"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Current Grade')"
                    :invalid-feedback="$t('Current Grade is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter current grade')"
                      v-model="myObj.last_class"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Physical Handicap')"
                    :invalid-feedback="$t('Physical Handicap is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter physical handicap')"
                      v-model="myObj.physical_handicap"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Student Email Address')"
                    :invalid-feedback="$t('Student Email Address is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter student email address')"
                      v-model.trim="myObj.emailAddress"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Allergies')"
                    :invalid-feedback="$t('Allergies is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter allergies')"
                      v-model="myObj.allergies"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <!-- if direct admission or on edit -->
          <b-col
            md="6"
            v-if="
              $route.params.id == 0 ? selected === 'add' : $route.params.id > 0
            "
          >
            <b-card>
              <!-- <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Family Code')"
                    :invalid-feedback="$t('Family code is required')"
                  >
                    <b-form-input
                      type="number"
                      v-model="myObj.family_code"
                      class="form-control"
                      :placeholder="$t('Enter family code')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Gr number') + ' *'"
                    :invalid-feedback="$t('Gr number is required')"
                  >
                    <b-form-input
                      ref="grNo"
                      v-model="myObj.grNo"
                      class="form-control"
                      :placeholder="$t('Enter Gr number')"
                      @focusout="CheckGrNo()"
                    />
                  </b-form-group>
                </b-col>
              </b-row> -->
              <b-row
                v-if="
                  myObj.status == 'registered' ||
                  ($route.query.status == 'registered'
                    ? ['true', true].includes($route.params.readmit)
                    : true)
                "
              >
                <b-col md="6">
                  <b-form-group
                    :label="$t('Date of registration')"
                    :invalid-feedback="$t('Date of registration is required')"
                  >
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_registraion"
                      :disabled="
                        reportDomain == 'myskoolhpgs' && uRights.hideFee
                      "
                      class="form-control"
                      :placeholder="$t('Select date of registration')"
                      @input="setSameFields('date')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Date of Enrollment')"
                    :invalid-feedback="$t('Date of Enrollment is required')"
                  >
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_admission"
                      :disabled="
                        reportDomain == 'myskoolhpgs' && uRights.hideFee
                      "
                      class="form-control"
                      :placeholder="$t('Select date of enrollment')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  md="6"
                  v-if="
                    ['left', 'alumni'].includes(myObj.status.toLowerCase()) ||
                    myObj.date_of_leaving
                  "
                >
                  <b-form-group :label="$t('Leaving Date')">
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_leaving"
                      class="form-control"
                      :placeholder="$t('Select date of leaving')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  v-if="
                    ['left', 'alumni'].includes(myObj.status.toLowerCase()) ||
                    myObj.date_of_readmission
                  "
                >
                  <b-form-group
                    :label="$t('Reenrollment  Date')"
                    :invalid-feedback="$t('Date is required')"
                  >
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_readmission"
                      class="form-control"
                      :placeholder="$t('Select date of reenrollment')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Semester')"
                    :invalid-feedback="$t('Semester is required')"
                    ref="session"
                  >
                    <v-select
                      v-model="myObj.sessionID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="allSess"
                      :reduce="(val) => val.id"
                      label="session"
                      :clearable="false"
                      :placeholder="$t('Select semester')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Group (admitted)') + ' *'"
                    :invalid-feedback="
                      $t('Group at the time of admission is required')
                    "
                    ref="class_admitted"
                  >
                    <v-select
                      v-model="myObj.class_admitted"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="classesOptions"
                      :clearable="false"
                      :reduce="(val) => val.id"
                      label="name"
                      @input="FillSections()"
                      @search:blur="CheckClassAdmit()"
                      :disabled="dataloading"
                      :placeholder="$t('Select group admitted')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Group (current)') + ' *'"
                    :invalid-feedback="$t('Current group is required.')"
                    ref="class_current"
                  >
                    <v-select
                      v-model="myObj.class_current"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="classesOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(val) => val.id"
                      @input="FillSectionsCurrent('select')"
                      @search:blur="CheckClassCurrent()"
                      :disabled="dataloading"
                      :placeholder="$t('Select current group')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Level (admitted)') + ' *'"
                    :invalid-feedback="$t('Level (admitted) is required')"
                    ref="section_admitted"
                  >
                    <v-select
                      v-model="myObj.section_admitted"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="admittedSections"
                      :reduce="(val) => val.id"
                      label="section"
                      :clearable="false"
                      :disabled="dataloading"
                      :placeholder="$t('Select level admitted')"
                      @input="setSameFields('section')"
                      @search:blur="CheckAdmitSec()"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Level (current)') + ' *'"
                    :invalid-feedback="$t('Current level is required')"
                    ref="section_current"
                  >
                    <v-select
                      v-model="myObj.section_current"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="currentSections"
                      :reduce="(val) => val.id"
                      label="section"
                      :clearable="false"
                      :disabled="dataloading"
                      @search:blur="CheckCurrentSec()"
                      :placeholder="$t('Select current level')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :invalid-feedback="$t('Age category is required.')"
                  >
                    <template #label>
                      <div>
                        <span>{{ $t("Age Category") }}</span>
                        <!-- <b-button
                          size="sm"
                          variant="primary"
                          class="btn-icon rounded-circle ml-1 happiness-dropdown-add-btn"
                          v-b-tooltip.hover.top
                          :title="$t('Manage Age Categories')"
                          @click="openDropdownModal('ageCategory')"
                        >
                          <feather-icon icon="PlusIcon" size="14" />
                        </b-button> -->
                      </div>
                    </template>
                    <v-select
                      v-model="myObj.house"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="ageOptions"
                      :clearable="false"
                      label="text"
                      :reduce="(val) => val.value"
                      :disabled="dataloading"
                      :placeholder="$t('Select age category')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :invalid-feedback="$t('Empower Level is required.')"
                  >
                    <template #label>
                      <div>
                        <span>{{ $t("Empower Level") }}</span>
                        <!-- <b-button
                          size="sm"
                          variant="primary"
                          class="btn-icon rounded-circle ml-1 happiness-dropdown-add-btn"
                          v-b-tooltip.hover.top
                          :title="$t('Manage Empower Levels')"
                          @click="openDropdownModal('empowerLevel')"
                        >
                          <feather-icon icon="PlusIcon" size="14" />
                        </b-button> -->
                      </div>
                    </template>
                    <v-select
                      v-model="myObj.last_result"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="empowerOptions"
                      :clearable="false"
                      label="text"
                      :reduce="(val) => val.value"
                      :disabled="dataloading"
                      :placeholder="$t('Select empower level')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <template>
                <b-row class="mt-1">
                  <b-col md="12">
                    <h4
                      class="mb-50 font-weight-bold border-left-primary"
                      style="padding-left: 0.6rem; border-width: 5px"
                    >
                      {{ $t("Sibling Information") }}
                    </h4>
                    <hr />
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      :label="$t('Search Student to add as sibling')"
                      label-for="siblingSearch"
                    >
                      <div class="search-section">
                        <b-form-input
                          id="siblingSearch"
                          v-model="siblingSearchQuery"
                          :placeholder="$t('Search students...')"
                          @input="onSiblingSearchChange"
                          class="search-input"
                        />
                      </div>

                      <div
                        v-if="siblingSearchQuery.length >= 2"
                        class="search-results"
                      >
                        <div
                          v-if="siblingSearchResults.length > 0"
                          class="student-options"
                        >
                          <div
                            v-for="student in siblingSearchResults"
                            :key="student.id"
                            class="student-option"
                            @click="selectSiblingStudent(student)"
                          >
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <div>
                                <strong>{{ student.name }}</strong>
                                <div class="text-muted small">
                                  {{ student.className }}
                                  {{
                                    student.sectionName
                                      ? " - " + student.sectionName
                                      : ""
                                  }}
                                  <span v-if="student.grNo" class="ml-2"
                                    >GR: {{ student.grNo }}</span
                                  >
                                </div>
                              </div>
                              <feather-icon
                                icon="PlusCircleIcon"
                                size="16"
                                class="text-primary"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="
                            siblingSearchResults.length === 0 &&
                            !siblingSearchLoading
                          "
                          class="empty-state"
                        >
                          <feather-icon icon="SearchIcon" size="32" />
                          <p>{{ $t("No students found") }}</p>
                        </div>
                        <div v-if="siblingSearchLoading" class="loading-state">
                          <b-spinner variant="primary" size="sm" />
                          <span>{{ $t("Searching...") }}</span>
                        </div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="siblingInfo.length > 0">
                  <b-col md="12">
                    <div
                      v-for="(sibling, idx) in siblingInfo"
                      :key="idx"
                      class="selected-student mb-50"
                    >
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <strong>{{ sibling.name }}</strong>
                          <div class="text-muted small">
                            {{ sibling.className }}
                            <!-- <span v-if="sibling.schoolName">
                              · {{ sibling.schoolName }}</span
                            > -->
                          </div>
                        </div>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click="removeSiblingStudent(sibling, idx)"
                        >
                          <feather-icon icon="XIcon" size="14" />
                        </b-button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </template>

              <template>
                <b-row class="mt-1">
                  <b-col md="12">
                    <h4
                      class="mb-50 font-weight-bold border-left-primary"
                      style="padding-left: 0.6rem; border-width: 5px"
                    >
                      Additional Notes
                    </h4>
                    <hr />
                    <b-form-textarea
                      id="textarea-default"
                      :placeholder="$t('Enter note')"
                      rows="3"
                      v-model="myObj.remarks"
                    />
                  </b-col>
                </b-row>
              </template>

              <!-- if confirm admission on registered profile, will not show if editing registered profile)-->
              <template
                v-if="
                  myObj.status == 'registered' ||
                  $route.query.status == 'registered'
                    ? ['true', true].includes($route.params.readmit)
                    : true
                "
              >
                <!-- <b-row>
                  <b-col md="6">
                    <b-form-group
                      :label="$t('Monthly Fees') + ' *'"
                      :invalid-feedback="$t('Monthly fees is required')"
                    >
                      <div class="d-flex">
                        <b-form-input
                          :disabled="
                            uRights.hideFee ||
                            (disVisible.includes(reportDomain) &&
                              discountBy !== 'none')
                          "
                          :placeholder="$t('currency')"
                          ref="curr"
                          v-model="myObj.currency"
                          style="flex: 1"
                          class="mr-50"
                        />
    
                        <b-form-input
                          :disabled="
                            uRights.hideFee ||
                            (disVisible.includes(reportDomain) &&
                              discountBy !== 'none')
                          "
                          style="flex: 4"
                          :placeholder="$t('Enter monthly fee')"
                          ref="monthly_fee"
                          type="number"
                          v-model="myObj.monthly_fee"
                          @keyup="CheckFees()"
                        />
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row> -->

                <!-- Donor details -->
                <b-row class="mt-2">
                  <b-col md="12">
                    <h4
                      class="mb-50 font-weight-bold border-left-primary"
                      style="padding-left: 0.6rem; border-width: 5px"
                    >
                      Donor Details
                    </h4>
                    <hr />
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      :label="$t('School Fees Support')"
                      :invalid-feedback="$t('School Fees Support is required')"
                      ref="support"
                    >
                      <v-select
                        v-model="myObj.discountNote"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="supportOptions"
                        label="text"
                        :reduce="(opt) => opt.value"
                        :clearable="false"
                        :placeholder="$t('Select support urgency level')"
                      />
                    </b-form-group>
                    <b-form-group
                      label=" "
                      :invalid-feedback="$t('Donor is required')"
                    >
                      <v-select
                        v-model="selectedDonorID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="[
                          { donor: { id: 0, firstName: 'None' } },
                          ...donorOptions,
                        ]"
                        :filterBy="donorFilter"
                        :clearable="false"
                        :reduce="(val) => val.donor.id"
                        :disabled="donorListLoading"
                        label="donor.name"
                        :placeholder="$t('Select donor')"
                      >
                        <template #option="option">
                          <div class="d-flex align-items-center">
                            <b-img
                              v-if="option.donor.photo"
                              :src="option.donor.photo"
                              rounded
                              width="48"
                              height="48"
                              class="mr-1 object-fit-cover border"
                              alt="Donor photo"
                            />
                            <div
                              v-else
                              class="d-flex align-items-center justify-content-center bg-light rounded mr-1"
                              style="width: 48px; height: 48px; flex-shrink: 0"
                            >
                              <feather-icon
                                icon="UserIcon"
                                size="20"
                                class="text-muted"
                              />
                            </div>
                            <div>
                              <div class="font-weight-bold">
                                {{ option.donor.firstName || "" }}
                                {{ option.donor.surname || "" }}
                              </div>
                              <div class="text-muted small">
                                <feather-icon
                                  icon="PhoneIcon"
                                  size="12"
                                  class="mr-25"
                                />
                                {{ option.donor.whatsappNumber || "-" }}
                              </div>
                              <!-- <div class="text-muted small">
                                <feather-icon
                                  icon="MailIcon"
                                  size="12"
                                  class="mr-25"
                                />
                                {{ option.donor.email || "-" }}
                              </div> -->
                              <div class="text-muted small">
                                <feather-icon
                                  icon="MapPinIcon"
                                  size="12"
                                  class="mr-25"
                                />
                                {{ option.donor.countryOfOrigin || "-" }}
                              </div>
                            </div>
                          </div>
                        </template>
                        <template #selected-option="option">
                          <div class="d-flex align-items-center">
                            <b-img
                              v-if="option.donor.photo"
                              :src="option.donor.photo"
                              rounded
                              width="48"
                              height="48"
                              class="mr-1 object-fit-cover border"
                              alt="Donor photo"
                            />
                            <div
                              v-else
                              class="d-flex align-items-center justify-content-center bg-light rounded mr-1"
                              style="width: 48px; height: 48px; flex-shrink: 0"
                            >
                              <feather-icon
                                icon="UserIcon"
                                size="20"
                                class="text-muted"
                              />
                            </div>
                            <div>
                              <div class="font-weight-bold">
                                {{ option.donor.firstName || "" }}
                                {{ option.donor.surname || "" }}
                              </div>
                              <div class="text-muted small">
                                <feather-icon
                                  icon="PhoneIcon"
                                  size="12"
                                  class="mr-25"
                                />
                                {{ option.donor.whatsappNumber || "-" }}
                              </div>
                              <!-- <div class="text-muted small">
                                <feather-icon
                                  icon="MailIcon"
                                  size="12"
                                  class="mr-25"
                                />
                                {{ option.donor.email || "-" }}
                              </div> -->
                              <div class="text-muted small">
                                <feather-icon
                                  icon="MapPinIcon"
                                  size="12"
                                  class="mr-25"
                                />
                                {{ option.donor.countryOfOrigin || "-" }}
                              </div>
                            </div>
                          </div>
                        </template>
                      </v-select>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col md="12">
                    <div v-if="donorLoading" class="text-center py-1">
                      <b-spinner variant="primary" small />
                    </div>
                    <div
                      v-else-if="donorInfo"
                      class="donor-info-card p-1 rounded border"
                    >
                      <div class="d-flex align-items-center">
                        <b-img
                          v-if="donorInfo.photo"
                          :src="donorInfo.photo"
                          rounded
                          width="48"
                          height="48"
                          class="mr-1 object-fit-cover border"
                          alt="Donor photo"
                        />
                        <div
                          v-else
                          class="d-flex align-items-center justify-content-center bg-light rounded mr-1"
                          style="width: 48px; height: 48px; flex-shrink: 0"
                        >
                          <feather-icon
                            icon="UserIcon"
                            size="20"
                            class="text-muted"
                          />
                        </div>
                        <div>
                          <div class="font-weight-bold">
                            {{ donorInfo.firstName || "" }}
                            {{ donorInfo.surname || "" }}
                          </div>
                          <div class="text-muted small">
                            <feather-icon
                              icon="PhoneIcon"
                              size="12"
                              class="mr-25"
                            />
                            {{ donorInfo.whatsappNumber || "-" }}
                          </div>
                          <div class="text-muted small">
                            <feather-icon
                              icon="MailIcon"
                              size="12"
                              class="mr-25"
                            />
                            {{ donorInfo.email || "-" }}
                          </div>
                          <div class="text-muted small">
                            <feather-icon
                              icon="MapPinIcon"
                              size="12"
                              class="mr-25"
                            />
                            {{ donorInfo.countryOfOrigin || "-" }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-muted small text-center py-50">
                      No donor linked to this student.
                    </div>
                  </b-col> -->
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content :title="$t('Student')" icon="feather icon-file-text" v-else>
        <b-row class="match-height">
          <b-col md="6">
            <b-card class="" body-class="position-relative">
              <b-row align-h="center">
                <!-- <b-col cols="4"> </b-col> -->
                <b-col class="ml-3" cols="4">
                  <b-form-group
                    class="text-center"
                    ref="picture"
                    label=" "
                    label-for="name-input"
                    :invalid-feedback="$t('Picture is required')"
                  >
                    <b-media no-body ref="picture">
                      <b-media-aside>
                        <div class="happiness-photo-slot">
                          <div
                            v-if="!plus && logoloading !== true"
                            class="happiness-photo-frame happiness-photo-frame--empty happiness-photo-frame--clickable"
                            @click="$refs.fileProfile.click()"
                          >
                            <feather-icon
                              icon="ImageIcon"
                              size="34"
                              class="text-muted"
                            />
                            <small class="text-muted mt-50 d-block">{{
                              $t("Click to upload")
                            }}</small>
                          </div>

                          <div
                            v-else-if="!plus && logoloading === true"
                            class="happiness-photo-frame happiness-photo-frame--empty"
                          >
                            <b-spinner
                              variant="primary"
                              type="grow"
                              :label="$t('Spinning')"
                            />
                          </div>

                          <div v-else class="happiness-photo-frame">
                            <img
                              class="happiness-photo-img"
                              :src="plainBackgroundPreview"
                              alt="Student photo"
                              referrerpolicy="no-referrer"
                              @error="onDrivePhotoPreviewError($event, plus)"
                              @click="
                                logoloading !== true &&
                                  $refs.fileProfile.click()
                              "
                            />
                            <div
                              v-if="logoloading === true"
                              class="happiness-photo-upload-overlay"
                            >
                              <b-spinner variant="primary" type="grow" />
                            </div>
                            <b-button
                              v-if="logoloading !== true"
                              class="happiness-photo-delete-btn"
                              variant="danger"
                              @click.stop="deleteLogo()"
                            >
                              <feather-icon icon="Trash2Icon" size="20" />
                            </b-button>
                          </div>
                        </div>
                        <input
                          type="file"
                          id="fileProfile"
                          hidden
                          ref="fileProfile"
                          @change="selectlogo()"
                          accept="image/*"
                        />
                      </b-media-aside>
                    </b-media>
                  </b-form-group>
                </b-col>
              </b-row>
              <div
                style="position: absolute; right: 10px; top: 10px"
                class="d-flex align-items-center"
              >
                <b-form-checkbox
                  v-if="selected === 'add'"
                  v-model="addingMsg"
                  switch
                  @input="setMsg()"
                  v-b-tooltip.hover.top
                  :title="$t('Admission Message')"
                />
                <feather-icon
                  v-if="selected === 'add' || selected === 'reg'"
                  icon="SettingsIcon"
                  size="28"
                  @click="visibility1 = true"
                  class="cursor-pointer ml-50"
                  v-b-tooltip.hover.top
                  :title="$t('Settings')"
                />
                <b-button
                  v-if="myObj && myObj.id > 0"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="myObj.synced ? 'outline-success' : 'outline-danger'"
                  class="btn-icon ml-50"
                  size="sm"
                  v-b-tooltip.hover.top
                  :title="
                    myObj.synced
                      ? $t('Synced Account Details')
                      : $t('Not Synced')
                  "
                  :disabled="syncLoading"
                  @click="showSyncedDetails(myObj.syncedDetails, myObj.id)"
                >
                  <b-spinner v-if="syncLoading" small />
                  <feather-icon v-else icon="SmartphoneIcon" />
                </b-button>
              </div>
              <!-- <h3 class="mt-1">Student Information</h3> -->
              <hr />

              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Name') + ' *'"
                    :invalid-feedback="$t('Student name is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter name')"
                      ref="name"
                      v-model.trim="myObj.name"
                      @focusout="CheckName()"
                    />
                  </b-form-group>
                </b-col>

                <!-- moved here for yakubov -->
                <b-col md="6" v-if="reportDomain == 'myskoolyakubov'">
                  <b-form-group
                    :label="
                      otherObj && otherObj.valueBool
                        ? $t('Caste')
                        : $t('Surname')
                    "
                    :invalid-feedback="
                      $t(
                        (otherObj && otherObj.valueBool ? 'Caste' : 'Surname') +
                          ' is required'
                      )
                    "
                  >
                    <b-form-input
                      :placeholder="
                        $t(
                          'Enter ' +
                            (otherObj && otherObj.valueBool
                              ? 'Caste'
                              : 'Surname')
                        )
                      "
                      v-model="myObj.surname"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    :label="$t('Father name') + ' *'"
                    :invalid-feedback="$t('Father name is required')"
                  >
                    <b-form-input
                      ref="fname"
                      :placeholder="$t('Enter father name')"
                      v-model.trim="myObj.father_name"
                      @focusout="CheckFName()"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Gender')"
                    :invalid-feedback="$t('Gender is required')"
                  >
                    <v-select
                      v-model="myObj.gender"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="genders"
                      :clearable="false"
                      ref="gender"
                      :placeholder="$t('Select gender')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Date of Birth')"
                    :invalid-feedback="$t('date of birth is required')"
                    ref="dob"
                  >
                    <flat-pickr
                      ref="dob"
                      :config="config"
                      v-model="myObj.date_of_birth"
                      class="form-control"
                      :placeholder="$t('Select date of birth')"
                      @on-change="formatDate()"
                    />
                    <!-- @on-change="CheckDob()" -->
                  </b-form-group>
                </b-col>
                <!-- move above for yakubov -->
                <b-col md="6" v-if="reportDomain != 'myskoolyakubov'">
                  <b-form-group
                    :label="
                      otherObj && otherObj.valueBool
                        ? $t('Caste')
                        : $t('Surname')
                    "
                    :invalid-feedback="
                      $t(
                        (otherObj && otherObj.valueBool ? 'Caste' : 'Surname') +
                          ' is required'
                      )
                    "
                  >
                    <b-form-input
                      :placeholder="
                        $t(
                          'Enter ' +
                            (otherObj && otherObj.valueBool
                              ? 'Caste'
                              : 'Surname')
                        )
                      "
                      v-model="myObj.surname"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    :label="$t('Religion')"
                    :invalid-feedback="$t('Religion is required')"
                  >
                    <v-select
                      v-model="myObj.religion"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="religions"
                      :clearable="false"
                      ref="religion"
                      :placeholder="$t('Select religion')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="showCrestMyskoolFields">
                <b-col md="6">
                  <b-form-group
                    :label="$t('Student\'s Contact')"
                    :invalid-feedback="$t('Please enter correct phone number')"
                  >
                    <vue-tel-input
                      :inputOptions="vueTelOptions"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      @input="CheckContact"
                      v-model="myObj.contact_student"
                    ></vue-tel-input>
                    <small class="mr-1 text-danger" v-if="phoneerror">{{
                      $t("Phone number is required")
                    }}</small>
                    <small
                      class="mr-1 text-danger d-block"
                      v-else-if="contactDuplicateError"
                      >{{
                        $t(
                          "This number cannot match father, mother, or student contact."
                        )
                      }}</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group :label="$t('B-Form / CNIC')">
                    <b-form-input
                      :placeholder="$t('Enter B-Form')"
                      v-model.trim="myObj.bform_number"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group :label="$t('Learning difficulties')">
                    <b-form-radio-group
                      v-model="learningDifficultiesHas"
                      :options="yesNoOptions"
                      name="student-learning-difficulties-main"
                    />
                    <b-form-input
                      v-if="learningDifficultiesHas"
                      class="mt-1"
                      v-model.trim="learningDifficultiesDetail"
                      :placeholder="$t('Please provide details')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group :label="$t('Special medical needs')">
                    <b-form-radio-group
                      v-model="specialMedicalNeedsHas"
                      :options="yesNoOptions"
                      name="student-special-medical-needs-main"
                    />
                    <b-form-input
                      v-if="specialMedicalNeedsHas"
                      class="mt-1"
                      v-model.trim="specialMedicalNeedsDetail"
                      :placeholder="$t('Please provide details')"
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="isCrestViewAcademy" md="6">
                  <b-form-group :label="$t('Father\'s occupation')">
                    <b-form-input
                      v-model.trim="myObj.father_occupation"
                      :placeholder="$t('Enter father\'s occupation')"
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="isCrestViewAcademy" md="6">
                  <b-form-group :label="$t('Mother\'s occupation')">
                    <b-form-input
                      v-model.trim="myObj.mother_occupation"
                      :placeholder="$t('Enter mother\'s occupation')"
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="isCrestViewAcademy" md="6">
                  <b-form-group :label="$t('Father\'s CNIC Number')">
                    <b-form-input
                      v-model="myObj.father_cnic"
                      v-mask="'#####-#######-#'"
                      maxlength="15"
                      :placeholder="$t('XXXXX-XXXXXXX-X')"
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="isCrestViewAcademy" md="6">
                  <b-form-group :label="$t('Mother\'s CNIC Number')">
                    <b-form-input
                      v-model="myObj.mother_cnic"
                      v-mask="'#####-#######-#'"
                      maxlength="15"
                      :placeholder="$t('XXXXX-XXXXXXX-X')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Last Institute')"
                    :invalid-feedback="$t('Last Institute is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter last institute')"
                      v-model.trim="myObj.last_institute"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Date of birth in words')"
                    :invalid-feedback="$t('Date of birth in words is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter date of birth in words')"
                      v-model="myObj.date_of_birth_words"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Place of birth')"
                    :invalid-feedback="$t('Place of birth is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter place of birth')"
                      v-model.trim="myObj.place_of_birth"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Mother Tongue')"
                    :invalid-feedback="$t('Mother Tongue is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter mother tongue')"
                      v-model.trim="myObj.mother_tongue"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Nationality')"
                    :invalid-feedback="$t('Nationality is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter nationality')"
                      v-model.trim="myObj.nationality"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Area')"
                    :invalid-feedback="$t('Area is required')"
                  >
                    <v-select
                      v-model="myObj.areaID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="areaOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(opt) => opt.id"
                      :placeholder="$t('Select area')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Current Address')"
                    :invalid-feedback="$t('Address is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter current address')"
                      v-model="myObj.address_current"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Permanent Address')"
                    :invalid-feedback="$t('Address is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter permanent address')"
                      v-model="myObj.address_permanent"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Physical Handicap')"
                    :invalid-feedback="$t('Physical Handicap is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter physical handicap')"
                      v-model="myObj.physical_handicap"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Student Email Address')"
                    :invalid-feedback="$t('Student Email Address is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter student email address')"
                      v-model.trim="myObj.emailAddress"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col md="6">
            <b-card class="">
              <h3 class="d-flex align-items-center justify-content-between">
                {{ $t("Registration Information") }}
                <feather-icon
                  v-if="!disVisible.includes(reportDomain)"
                  size="22"
                  icon="SettingsIcon"
                  class="cursor-pointer"
                  @click="openDSett()"
                  v-b-tooltip.hover.top
                  :title="$t('Settings')"
                />
              </h3>
              <hr />
              <b-row>
                <b-col
                  :md="isShsSchoolGrLocalRegistration ? 12 : 6"
                  v-if="schGr && schGr.valueBool"
                >
                  <b-form-group
                    :label="`${schGr.value}${
                      isShsSchoolGrLocalRegistration ? ' *' : ''
                    }`"
                    :invalid-feedback="`${schGr.value} ` + $t('is required')"
                    ref="gr_local"
                  >
                    <b-form-input
                      :placeholder="$t('Enter') + ` ${schGr.value}`"
                      v-model="myObj.grNoLocal"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="spNo && spNo.valueBool">
                  <b-form-group
                    :label="`${spNo.value}`"
                    :invalid-feedback="`${spNo.value} ` + $t('is required')"
                    ref="recNo"
                  >
                    <b-form-input
                      :placeholder="$t('Enter') + ` ${spNo.value}`"
                      v-model="myObj.receiptNo"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  :md="
                    $store.state.currentBranch.organizationType == 'coaching'
                      ? '4'
                      : '6'
                  "
                >
                  <b-form-group
                    style="position: relative"
                    :label="$t('Family Code')"
                    :invalid-feedback="$t('Family code is required')"
                  >
                    <feather-icon
                      v-if="selected == 'add'"
                      class="cursor-pointer"
                      style="position: absolute; right: 0; top: -25px"
                      icon="SearchIcon"
                      size="18"
                      @click="showSidebar()"
                    />
                    <b-form-input
                      type="number"
                      v-model="myObj.family_code"
                      class="form-control"
                      :placeholder="$t('Enter family code')"
                      @keyup.enter="searchByFamily()"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="!isShsSchoolGrLocalRegistration"
                  :md="
                    $store.state.currentBranch.organizationType == 'coaching'
                      ? '4'
                      : '6'
                  "
                >
                  <b-form-group
                    :label="
                      reportDomain == 'myskoolhpgs' ||
                      reportDomain == 'myskoolprofectus'
                        ? $t('CID') + ' *'
                        : $store.state.userData.studentStatus == 'present'
                        ? $t('Gr number') + ' *'
                        : $t('Reg number') + ' *'
                    "
                    :invalid-feedback="
                      reportDomain == 'myskoolhpgs' ||
                      reportDomain == 'myskoolprofectus'
                        ? $t('CID is required')
                        : $store.state.userData.studentStatus == 'present'
                        ? $t('Gr number is required')
                        : $t('Reg number is required')
                    "
                  >
                    <b-form-input
                      v-model="myObj.grNo"
                      class="form-control"
                      :placeholder="
                        reportDomain == 'myskoolhpgs' ||
                        reportDomain == 'myskoolprofectus'
                          ? $t('Enter CID')
                          : $store.state.userData.studentStatus == 'present'
                          ? $t('Enter Gr number')
                          : $t('Enter reg number')
                      "
                      @focusout="CheckGrNo()"
                      ref="grNo"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  md="4"
                  v-if="
                    this.$store.state.currentBranch.organizationType ==
                    'coaching'
                  "
                >
                  <b-form-group :invalid-feedback="$t('Session is required')">
                    <div class="d-flex justify-content-between">
                      <label class="bv-no-focus-ring col-form-label pt-0">{{
                        $t("Session")
                      }}</label>
                      <feather-icon
                        class="cursor-pointer"
                        icon="SettingsIcon"
                        size="18"
                        v-b-tooltip.hover.top
                        :title="$t('Sessions')"
                        @click="openSession()"
                      />
                    </div>
                    <v-select
                      ref="session"
                      v-model="myObj.sessionID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="allSess"
                      :reduce="(val) => val.id"
                      label="session"
                      :clearable="false"
                      :placeholder="$t('Select session')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  :md="
                    ['left', 'alumni'].includes(myObj.status.toLowerCase())
                      ? '4'
                      : '6'
                  "
                >
                  <b-form-group
                    :label="
                      ['myskooliuss'].includes(reportDomain)
                        ? $t('Date of Enrollment')
                        : $t('Date of registration')
                    "
                    :invalid-feedback="
                      ['myskooliuss'].includes(reportDomain)
                        ? $t('Date of enrollment is required')
                        : $t('Date of registration is required')
                    "
                  >
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_registraion"
                      :disabled="
                        reportDomain == 'myskoolhpgs' && uRights.hideFee
                      "
                      class="form-control"
                      :placeholder="
                        ['myskooliuss'].includes(reportDomain)
                          ? $t('Select date of enrollment')
                          : $t('Select date of registration')
                      "
                      @input="setSameFields('date')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  :md="
                    ['left', 'alumni'].includes(myObj.status.toLowerCase())
                      ? '4'
                      : '6'
                  "
                >
                  <b-form-group
                    :label="$t('Date of Admission')"
                    :invalid-feedback="$t('Date of Admission is required')"
                  >
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_admission"
                      :disabled="
                        reportDomain == 'myskoolhpgs' && uRights.hideFee
                      "
                      class="form-control"
                      :placeholder="$t('Select date of admission')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  md="4"
                  v-if="['left', 'alumni'].includes(myObj.status.toLowerCase())"
                >
                  <b-form-group :label="$t('Leaving Date')">
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_leaving"
                      class="form-control"
                      :placeholder="$t('Select date of leaving')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <template
                  v-if="
                    reportDomain == 'myskoolhpgs' &&
                    $store.state.loggedUser.campusID == 1 &&
                    ['Administrator', 'administrator'].includes(
                      $store.state.loggedUser.meta_role
                    )
                  "
                >
                  <b-col md="12">
                    <b-form-group
                      :label="$t('Admitted Campus')"
                      :invalid-feedback="$t('Campus is required')"
                      ref="adm_camp"
                    >
                      <v-select
                        v-model="myObj.campus_Admitted"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="campuses"
                        :clearable="false"
                        :reduce="(val) => val.id"
                        label="branch"
                        :placeholder="$t('Select campus')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group
                      :label="$t('Current Campus')"
                      :invalid-feedback="$t('Campus is required')"
                      ref="camp"
                    >
                      <v-select
                        v-model="myObj.campusID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="campuses"
                        :clearable="false"
                        :reduce="(val) => val.id"
                        disabled
                        label="branch"
                        :placeholder="$t('Select campus')"
                      />
                    </b-form-group>
                  </b-col>
                </template>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Class (admitted)') + ' *'"
                    :invalid-feedback="
                      $t('Class at the time of admission is required')
                    "
                    ref="class_admitted"
                  >
                    <v-select
                      v-model="myObj.class_admitted"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="classesOptions"
                      :clearable="false"
                      :reduce="(val) => val.id"
                      label="name"
                      ref="class_admitted"
                      @input="FillSections()"
                      @search:blur="CheckClassAdmit()"
                      :disabled="dataloading"
                      :placeholder="$t('Select class admitted')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Section (admitted)') + ' *'"
                    :invalid-feedback="$t('Admission section name is required')"
                    ref="section_admitted"
                  >
                    <v-select
                      v-model="myObj.section_admitted"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="admittedSections"
                      :reduce="(val) => val.id"
                      label="section"
                      :clearable="false"
                      :disabled="dataloading"
                      :placeholder="$t('Select section admitted')"
                      @input="setSameFields('section')"
                      @search:blur="CheckAdmitSec()"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Class (current)') + ' *'"
                    :invalid-feedback="$t('Current class is required.')"
                    ref="class_current"
                  >
                    <v-select
                      v-model="myObj.class_current"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="classesOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(val) => val.id"
                      @input="FillSectionsCurrent('select')"
                      @search:blur="CheckClassCurrent()"
                      :disabled="dataloading"
                      :placeholder="$t('Select current class')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Section (current)') + ' *'"
                    :invalid-feedback="$t('Current section name is required')"
                    ref="section_current"
                  >
                    <v-select
                      v-model="myObj.section_current"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="currentSections"
                      :reduce="(val) => val.id"
                      label="section"
                      :clearable="false"
                      :disabled="dataloading"
                      @search:blur="CheckCurrentSec()"
                      :placeholder="$t('Select current section')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <template v-if="disVisible.includes(reportDomain)">
                  <b-col md="6">
                    <b-form-group
                      :label="$t('Discount by')"
                      :invalid-feedback="$t('Discount selection is required')"
                    >
                      <v-select
                        v-model="discountBy"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="[
                          { value: 'none', text: 'None' },
                          { value: 'percentage', text: 'Percentage' },
                          { value: 'fixed', text: 'Amount' },
                        ]"
                        :clearable="false"
                        :reduce="(val) => val.value"
                        label="text"
                        :placeholder="$t('Select type')"
                        @input="CalculateDiscount()"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6" v-if="discountBy == 'percentage'">
                    <b-form-group
                      :label="$t('Discount') + ' %'"
                      :invalid-feedback="
                        myObj.classFee == 0 && myObj.discount_percentage > 0
                          ? $t('Class fee is not defined')
                          : $t('Invalid value entered')
                      "
                      ref="discount_perc"
                    >
                      <b-form-input
                        :placeholder="$t('Enter discount percentage')"
                        type="number"
                        :disabled="discountBy == 'none'"
                        v-model="myObj.discount_percentage"
                        no-wheel
                        @input="CalculateDiscount()"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6" v-else>
                    <b-form-group
                      :label="$t('Discount Amount')"
                      :invalid-feedback="
                        myObj.classFee == 0 && discountValue > 0
                          ? $t('Class fee is not defined')
                          : $t('Invalid value entered')
                      "
                      ref="discount_amount"
                    >
                      <b-form-input
                        :placeholder="$t('Enter discount amount')"
                        type="number"
                        v-model="discountValue"
                        :disabled="discountBy == 'none'"
                        no-wheel
                        @input="CalculateDiscount()"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      :label="$t('Class Fee')"
                      :invalid-feedback="$t('Class Fee is required')"
                    >
                      <b-form-input
                        type="number"
                        v-model="myObj.classFee"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </template>

                <b-col md="6">
                  <b-form-group
                    :label="$t(isCplc ? 'Contribution' : 'Monthly Fees') + ' *'"
                    :invalid-feedback="
                      $t(
                        isCplc
                          ? 'Contribution is required'
                          : 'Monthly fees is required'
                      )
                    "
                  >
                    <div class="d-flex">
                      <b-form-input
                        :disabled="
                          uRights.hideFee ||
                          (disVisible.includes(reportDomain) &&
                            discountBy !== 'none')
                        "
                        :placeholder="$t('currency')"
                        ref="curr"
                        v-model="myObj.currency"
                        style="flex: 1"
                        class="mr-50"
                      />

                      <b-form-input
                        :disabled="
                          (approvalList.includes('remove-fee') &&
                            myObj.id > 0) ||
                          uRights.hideFee ||
                          (disVisible.includes(reportDomain) &&
                            discountBy !== 'none')
                        "
                        style="flex: 4"
                        :placeholder="
                          $t(
                            isCplc ? 'Enter contribution' : 'Enter monthly fee'
                          )
                        "
                        ref="monthly_fee"
                        type="number"
                        v-model="myObj.monthly_fee"
                        no-wheel
                        @keyup="CheckFees()"
                      />
                    </div>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="joiningDateObj && joiningDateObj.valueBool">
                  <b-form-group :label="$t('Date of joining')">
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_joining"
                      class="form-control"
                      :placeholder="$t('Select date of joining')"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    v-if="
                      ['myskoolaims', 'myskoolaimsc2'].includes(reportDomain)
                    "
                    :label="$t('Timely Discount')"
                    :invalid-feedback="$t('Timely Discount is required')"
                    ref="timely_dis"
                  >
                    <b-form-input
                      :placeholder="$t('Enter timely discount')"
                      type="number"
                      v-model="myObj.timelyDiscount"
                    />
                  </b-form-group>
                </b-col>

                <template
                  v-if="
                    (disSetting && disSetting.valueBool) ||
                    disVisible.includes(reportDomain)
                  "
                >
                  <b-col md="12">
                    <b-form-group
                      :invalid-feedback="$t('Discount Reference is required')"
                      ref="d_ref"
                    >
                      <div class="d-flex">
                        <label class="bv-no-focus-ring col-form-label pt-0">{{
                          $t("Discount Reference")
                        }}</label>
                        <feather-icon
                          class="cursor-pointer ml-50"
                          icon="SettingsIcon"
                          size="18"
                          v-b-tooltip.hover.top
                          :title="$t('Mange References')"
                          @click="openDis()"
                        />
                      </div>
                      <v-select
                        v-model="myObj.discountReferenceID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="[{ id: 0, name: 'None' }, ...disData]"
                        :reduce="(val) => val.id"
                        label="name"
                        :clearable="false"
                        :placeholder="$t('Select discount reference')"
                        @input="setDiscount()"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- only show on setting based -->
                  <template v-if="disSetting && disSetting.valueBool">
                    <b-col md="6">
                      <b-form-group
                        :label="$t('Class Fee')"
                        :invalid-feedback="$t('Class Fee is required')"
                      >
                        <b-form-input
                          type="number"
                          v-model="myObj.classFee"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        :invalid-feedback="$t('Discount is required')"
                        ref="dis"
                      >
                        <div class="d-flex">
                          <label class="bv-no-focus-ring col-form-label pt-0">{{
                            $t("Discount")
                          }}</label>
                          <feather-icon
                            class="cursor-pointer ml-50"
                            icon="RefreshCwIcon"
                            size="18"
                            v-b-tooltip.hover.top
                            :title="$t('Calculate Monthly Fee')"
                            @click="setFee()"
                          />
                        </div>
                        <b-form-input
                          type="number"
                          :placeholder="$t('Enter discount')"
                          v-model="myObj.discount"
                          :disabled="disableDiscount"
                          no-wheel
                          @keyup="checkDis()"
                          @keyup.enter="setFee()"
                        />
                      </b-form-group>
                    </b-col>
                  </template>
                  <b-col md="12">
                    <b-form-group
                      :label="$t('Discount Note')"
                      :invalid-feedback="$t('Note is required')"
                    >
                      <b-form-textarea
                        :placeholder="$t('Enter discount note')"
                        rows="2"
                        v-model="myObj.discountNote"
                      />
                    </b-form-group>
                  </b-col>
                </template>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group
                    :invalid-feedback="$t('Challan due date is required')"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label class="bv-no-focus-ring col-form-label pt-0">{{
                        $t("Challan due date")
                      }}</label>
                      <b-badge
                        variant="primary"
                        class="mb-50 cursor-pointer"
                        @click="myObj.challan_due_date = null"
                        >{{ $t("Clear") }}</b-badge
                      >
                    </div>
                    <flat-pickr
                      :config="config"
                      v-model="myObj.challan_due_date"
                      class="form-control"
                      :placeholder="$t('Select challan due date')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="
                      reportDomain == 'myskoolhpgs'
                        ? $t('B-Form') + ' *'
                        : $t('B-Form')
                    "
                    :invalid-feedback="$t('B-Form is required')"
                    ref="bform"
                  >
                    <b-form-input
                      :placeholder="$t('Enter B-Form')"
                      v-model.trim="myObj.bform_number"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="rfObj && rfObj.valueBool">
                  <b-form-group
                    :label="$t('Biometric ID')"
                    :invalid-feedback="$t('Biometric ID is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter Biometric ID')"
                      v-model="myObj.rfid_number"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Roll No')"
                    :invalid-feedback="$t('Roll No is required')"
                  >
                    <b-form-input
                      type="number"
                      :placeholder="$t('Enter roll number')"
                      v-model="myObj.roll_number"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('House')"
                    :invalid-feedback="$t('House is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter house')"
                      v-model="myObj.house"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <!-- :label="
                      reportDomain == 'myskoolksa'
                        ? 'Date of Confirmation'
                        : 'Re-admission date'
                    " -->
                  <b-form-group
                    :label="$t('Re-admission date')"
                    :invalid-feedback="$t('Date is required')"
                  >
                    <flat-pickr
                      :config="config"
                      v-model="myObj.date_of_readmission"
                      class="form-control"
                      :placeholder="$t('Select date of readmission')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Last class')"
                    :invalid-feedback="$t('Last class is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter last class')"
                      v-model="myObj.last_class"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Last Session')"
                    :invalid-feedback="$t('Monthly fees is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter last session')"
                      v-model="myObj.last_session"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Last Result')"
                    :invalid-feedback="$t('Monthly fees is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter last result')"
                      v-model="myObj.last_result"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="match-height" align-h="center" v-if="false">
          <b-col md="8">
            <b-card class="">
              <h3 class="mt-1">{{ $t("Admission Progress") }}</h3>
              <hr />
              <b-row>
                <b-col md="4" class="p-0">
                  <h5>{{ $t("Test Fee Paid") }}</h5>
                  <div
                    class="d-flex align-items-center pr-50"
                    style="width: 100%"
                  >
                    <b-button
                      :variant="
                        myObj.testPayment ? 'primary' : 'outline-primary'
                      "
                      class="btn-icon rounded-circle mr-50"
                      @click="myObj.testPayment = !myObj.testPayment"
                    >
                      <feather-icon icon="CheckIcon" size="16" />
                    </b-button>
                    <!-- <b-form-checkbox id="checkbox1" v-model="prog.testPayment">
                    </b-form-checkbox> -->
                    <b-progress
                      style="width: 100%"
                      class="progress-bar-dark"
                      height="20px"
                      :value="myObj.testPayment ? '100' : '0'"
                      variant="success"
                    ></b-progress>
                  </div>
                </b-col>
                <b-col md="4" class="p-0">
                  <h5>{{ $t("Test Passed") }}</h5>
                  <div
                    class="d-flex align-items-center pr-50"
                    style="width: 100%"
                  >
                    <b-button
                      :variant="
                        myObj.testPassed ? 'primary' : 'outline-primary'
                      "
                      class="btn-icon rounded-circle mr-50"
                      @click="myObj.testPassed = !myObj.testPassed"
                    >
                      <feather-icon icon="CheckIcon" size="16" />
                    </b-button>
                    <!-- <b-form-checkbox id="checkbox2" v-model="prog.test_passed">
                    </b-form-checkbox> -->
                    <b-progress
                      style="width: 100%"
                      class="progress-bar-dark"
                      height="20px"
                      :value="myObj.testPassed ? '100' : '0'"
                      variant="success"
                    ></b-progress>
                  </div>
                </b-col>
                <b-col md="4" class="p-0">
                  <h5>{{ $t("Admission Confirmed") }}</h5>
                  <div class="d-flex align-items-center" style="width: 100%">
                    <!-- <b-form-checkbox id="checkbox3" v-model="prog.confirmed">
                    </b-form-checkbox> -->
                    <b-button
                      :variant="
                        myObj.testCompleted ? 'primary' : 'outline-primary'
                      "
                      class="btn-icon rounded-circle mr-50"
                      @click="myObj.testCompleted = !myObj.testCompleted"
                    >
                      <feather-icon icon="CheckIcon" size="16" />
                    </b-button>
                    <b-progress
                      class="progress-bar-dark"
                      style="width: 100%"
                      height="20px"
                      :value="myObj.testCompleted ? '100' : '0'"
                      variant="success"
                    ></b-progress>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        v-if="$route.params.id > 0 && showHappinessTab"
        :title="$t('Semester History')"
        icon="feather icon-file-text"
      >
        <b-row align-h="center" class="match-height">
          <b-col lg="8" md="12">
            <div
              class="d-flex align-items-center justify-content-between flex-wrap mb-2"
            >
              <b-button variant="primary" size="sm" @click="openAddLogModal()">
                <feather-icon icon="PlusIcon" class="mr-50" />
                {{ $t("Add") }}
              </b-button>

              <div class="d-flex align-items-center mt-1 mt-sm-0">
                <b-badge
                  variant="light-primary"
                  class="font-weight-bold mr-1 py-50 px-1"
                >
                  {{ classHistoryLogs.length }}
                  {{ classHistoryLogs.length === 1 ? $t("Log") : $t("Logs") }}
                </b-badge>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="btn-icon"
                  :disabled="loadingHistoryLogs"
                  @click="LoadClassHistory()"
                  v-b-tooltip.hover
                  :title="$t('Refresh History Logs')"
                >
                  <feather-icon
                    icon="RefreshCwIcon"
                    :class="{ 'fa-spin': loadingHistoryLogs }"
                  />
                </b-button>
              </div>
            </div>

            <div v-if="loadingHistoryLogs" class="text-center py-4">
              <b-spinner variant="primary" type="grow" />
              <p class="text-muted mt-1 mb-0">
                {{ $t("Loading history logs...") }}
              </p>
            </div>

            <div
              v-else-if="classHistoryLogs.length === 0"
              class="history-empty-state text-center py-4"
            >
              <div class="history-empty-icon mb-1">
                <feather-icon icon="ClockIcon" size="42" class="text-muted" />
              </div>
              <h5 class="text-muted font-weight-bolder mb-50">
                {{ $t("No history logs found") }}
              </h5>
              <p class="text-muted small mb-0">
                {{ $t("No activity logs recorded for this student.") }}
              </p>
            </div>

            <div v-else class="history-timeline-wrap">
              <div
                v-for="(log, idx) in classHistoryLogs"
                :key="log.id || idx"
                class="history-timeline-item"
              >
                <!-- Timeline Icon Circle on the left -->
                <div
                  class="history-timeline-point"
                  :class="getLogThemeClass(log.logCategory, 'point')"
                >
                  <feather-icon
                    :icon="getLogCategoryIcon(log.logCategory)"
                    size="18"
                  />
                </div>

                <!-- Card on the right -->
                <div class="history-log-card">
                  <!-- Top Header Row -->
                  <div class="history-card-header d-flex align-items-center">
                    <div class="history-date-chip">
                      <feather-icon
                        icon="CalendarIcon"
                        size="13"
                        class="mr-50 text-muted"
                      />
                      <span>{{ formatLogDate(log.updatedOn) }}</span>
                    </div>
                  </div>

                  <!-- Main Content Changes Row -->
                  <div class="history-card-body">
                    <template
                      v-if="
                        getParsedLog(log).changes &&
                        getParsedLog(log).changes.length > 0
                      "
                    >
                      <div
                        v-for="(change, cIdx) in getParsedLog(log).changes"
                        :key="'ch-' + cIdx"
                        class="history-change-row d-flex align-items-center flex-wrap"
                      >
                        <span
                          v-if="change.label"
                          class="history-field-label text-muted font-weight-bolder mr-75"
                        >
                          {{ $t(change.label) }}:
                        </span>

                        <div class="d-inline-flex align-items-center flex-wrap">
                          <span
                            class="history-pill history-pill--prev"
                            :class="{
                              'history-pill--muted': !change.isChanged,
                            }"
                          >
                            {{ change.from }}
                          </span>

                          <feather-icon
                            icon="ArrowRightIcon"
                            size="16"
                            class="history-arrow-icon mx-75"
                          />

                          <span
                            class="history-pill history-pill--next"
                            :class="getLogThemeClass(log.logCategory, 'pill')"
                          >
                            {{ change.to }}
                          </span>
                        </div>
                      </div>
                    </template>

                    <template v-else-if="getParsedLog(log).text">
                      <div class="history-plain-text font-weight-bold">
                        {{ getParsedLog(log).text }}
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- Modal: Add History Log -->
        <b-modal
          id="modal-add-history-log"
          v-model="showAddLogModal"
          cancel-variant="outline-secondary"
          centered
          no-close-on-backdrop
          :title="$t('Semester History')"
          @hidden="resetLogForm()"
        >
          <b-row>
            <b-col md="6" class="mb-1">
              <b-form-group :label="$t('Semester')">
                <v-select
                  v-model="logForm.sessionID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="allSess"
                  :reduce="(val) => val.id"
                  label="session"
                  :clearable="false"
                  :placeholder="$t('Select semester')"
                />
              </b-form-group>
            </b-col>

            <b-col md="6" class="mb-1">
              <b-form-group :label="$t('Group')">
                <v-select
                  v-model="logForm.classID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="classesOptions"
                  :reduce="(val) => val.id"
                  label="name"
                  :clearable="false"
                  :placeholder="$t('Select group')"
                  @input="onLogClassChange"
                />
              </b-form-group>
            </b-col>

            <b-col md="6" class="mb-1">
              <b-form-group :label="$t('Level')">
                <v-select
                  v-model="logForm.sectionID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="logSectionOptions"
                  :reduce="(val) => val.id"
                  label="section"
                  :clearable="false"
                  :placeholder="$t('Select level')"
                />
              </b-form-group>
            </b-col>

            <b-col md="6" class="mb-1">
              <b-form-group :label="$t('Age Category')">
                <v-select
                  v-model="logForm.agecategory"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="ageOptions"
                  :reduce="(val) => val.text || val.value"
                  label="text"
                  :clearable="false"
                  :placeholder="$t('Select age category')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12" class="mb-1">
              <b-form-group :label="$t('Empower Level')">
                <v-select
                  v-model="logForm.empoweLevel"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="empowerOptions"
                  :reduce="(val) => val.text || val.value"
                  label="text"
                  :clearable="false"
                  :placeholder="$t('Select empower level')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12" class="mt-50">
              <b-alert show variant="warning" class="mb-0">
                <div class="alert-body font-small-3 d-flex align-items-center">
                  <feather-icon icon="InfoIcon" class="mr-50 flex-shrink-0" />
                  <span>
                    {{
                      $t(
                        "Note: Saving this log will update the current student details."
                      )
                    }}
                  </span>
                </div>
              </b-alert>
            </b-col>
          </b-row>

          <template #modal-footer>
            <b-button
              variant="outline-secondary"
              @click="showAddLogModal = false"
            >
              {{ $t("Cancel") }}
            </b-button>
            <b-button
              variant="success"
              :disabled="savingLog"
              @click="saveHistoryLog()"
            >
              <b-spinner v-if="savingLog" small class="mr-50" />
              {{ $t("Save") }}
            </b-button>
          </template>
        </b-modal>
      </tab-content>

      <!-- personal details -->
      <tab-content
        :title="$t('Family')"
        icon="feather icon-users"
        v-if="!showHappinessTab"
      >
        <b-row v-if="$route.params.id > 0" class="mb-1">
          <b-col>
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="44"
                  :src="studentPicturePreview"
                  variant="light-primary"
                />
              </template>

              <b-link class="font-weight-bold d-block text-nowrap mb-25">
                <b-badge variant="light-primary">
                  {{ myObj.name }}
                </b-badge>
              </b-link>
              <small class="text-muted">
                <b-badge variant="light-primary">
                  GR - {{ myObj.grNo }}
                </b-badge>
                <b-badge variant="light-primary" class="ml-50">
                  F# - {{ myObj.family_code }}
                </b-badge>
              </small>
            </b-media>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-card class="">
              <h3 class="mt-1">{{ $t("Father Information") }}</h3>
              <hr />
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Occupation')"
                    :invalid-feedback="$t('Occupation is required')"
                  >
                    <b-form-input
                      v-model="myObj.father_occupation"
                      :placeholder="$t('Enter Occupation')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('CNIC no')"
                    :invalid-feedback="$t('CNIC is required')"
                  >
                    <b-form-input
                      ref="fCnic"
                      v-model="myObj.father_cnic"
                      v-mask="'#####-#######-#'"
                      maxlength="15"
                      :placeholder="$t('XXXXX-XXXXXXX-X')"
                    />
                    <!-- @focusout="CheckCnic()" -->
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Education')"
                    :invalid-feedback="$t('Education is required')"
                  >
                    <b-form-input
                      v-model="myObj.father_education"
                      :placeholder="$t('Enter Education')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group :label="$t('Monthly income')">
                    <b-form-input
                      type="number"
                      v-model="myObj.monthly_income"
                      :placeholder="$t('Enter monthly income')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Email')"
                    :invalid-feedback="$t('Email is required')"
                  >
                    <b-form-input
                      ref="fEmail"
                      v-model="myObj.father_email"
                      :placeholder="$t('Enter Email')"
                    />
                  </b-form-group>
                  <!-- @focusout="CheckEmail()" -->
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Employer (Firm)')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      v-model="myObj.father_employer"
                      :placeholder="$t('Enter Employer')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Office Contact')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      v-model="myObj.office_phone"
                      :placeholder="$t('Enter office number')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Office Address')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter office address')"
                      v-model="myObj.office_address"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <!-- <b-col md="6">
                  <b-form-group
                    label="Fax"
                    invalid-feedback="Contact number is required"
                  >
                    <b-form-input placeholder="Enter Fax" />
                  </b-form-group>
                </b-col> -->
              </b-row>
            </b-card>
          </b-col>

          <b-col md="6">
            <b-card class="">
              <h3 class="mt-1">{{ $t("Mother Information") }}</h3>
              <hr />
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Name')"
                    :invalid-feedback="$t('Name is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_name"
                      :placeholder="$t('Enter name')"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    :label="$t('Occupation')"
                    :invalid-feedback="$t('Occupation is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_occupation"
                      :placeholder="$t('Enter occupation')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('CNIC no')"
                    :invalid-feedback="$t('CNIC is required')"
                  >
                    <b-form-input
                      ref="mCnic"
                      v-model="myObj.mother_cnic"
                      v-mask="'#####-#######-#'"
                      maxlength="15"
                      :placeholder="$t('XXXXX-XXXXXXX-X')"
                    />
                    <!-- @focusout="CheckMCnic()" -->
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Education')"
                    :invalid-feedback="$t('Education is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_education"
                      :placeholder="$t('Enter education')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Email')"
                    :invalid-feedback="$t('Email is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_email"
                      :placeholder="$t('Enter email address')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Employer')"
                    :invalid-feedback="$t('Employer is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_employer"
                      :placeholder="$t('Enter employer')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Office Contact')"
                    :invalid-feedback="$t('Office Contact is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_office_phone"
                      :placeholder="$t('Enter office contact')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Office Address')"
                    :invalid-feedback="$t('Office Address is required')"
                  >
                    <b-form-input
                      v-model="myObj.mother_office_address"
                      :placeholder="$t('Enter office address')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-card class="">
              <h3 class="mt-1">{{ $t("Emergency Information") }}</h3>
              <hr />
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Name')"
                    :invalid-feedback="$t('Name is required')"
                  >
                    <b-form-input
                      ref="emerName"
                      :placeholder="$t('Enter name')"
                      v-model="myObj.emergency_name"
                    />
                    <!-- @focusout="CheckEmerName()" -->
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Relation')"
                    :invalid-feedback="$t('Relation is required')"
                  >
                    <b-form-input
                      ref="emerRel"
                      :placeholder="$t('Enter relation')"
                      v-model="myObj.emergency_relationship"
                    />
                    <!-- @focusout="CheckEmerRelation()" -->
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Emergency contact')"
                    :invalid-feedback="$t('Emergency Contact is required')"
                  >
                    <vue-tel-input
                      v-model="myObj.emergency_contact"
                      :inputOptions="emerOpt"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      @input="CheckEmerContact"
                    ></vue-tel-input>
                    <small class="mr-1 text-danger" v-if="emerPhoneerror">{{
                      $t("Phone number is required")
                    }}</small>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card class="">
              <h3 class="mt-1">{{ $t("Tutor Information") }}</h3>
              <hr />
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Contact')"
                    :invalid-feedback="$t('Contact is required')"
                  >
                    <b-form-input
                      v-model="myObj.contact_tutor"
                      :placeholder="$t('Enter tutor contact no')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Info')"
        icon="feather icon-users"
        v-if="!showHappinessTab"
      >
        <b-row v-if="$route.params.id > 0" class="mb-1">
          <b-col>
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="44"
                  :src="studentPicturePreview"
                  variant="light-primary"
                />
              </template>

              <b-link class="font-weight-bold d-block text-nowrap mb-25">
                <b-badge variant="light-primary">
                  {{ myObj.name }}
                </b-badge>
              </b-link>
              <small class="text-muted">
                <b-badge variant="light-primary">
                  GR - {{ myObj.grNo }}
                </b-badge>
                <b-badge variant="light-primary" class="ml-50">
                  F# - {{ myObj.family_code }}
                </b-badge>
              </small>
            </b-media>
          </b-col>
        </b-row>
        <b-row class="match-height">
          <b-col md="6">
            <b-card class="">
              <h3 class="mt-1">{{ $t("Guardian Information") }}</h3>
              <hr />
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Name')"
                    :invalid-feedback="$t('Name is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter guardian name')"
                      v-model="myObj.guardian_name"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Relation')"
                    :invalid-feedback="$t('Relation is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter guardian relation')"
                      v-model="myObj.guardian_relationship"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Occupation')"
                    :invalid-feedback="$t('Occupation is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter guardian occupation')"
                      v-model="myObj.guardian_occupation"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('CNIC no')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      ref="gCnic"
                      :placeholder="$t('XXXXX-XXXXXXX-X')"
                      v-model="myObj.guardian_cnic"
                      v-mask="'#####-#######-#'"
                      maxlength="15"
                    />
                    <!-- @focusout="CheckGCnic()" -->
                  </b-form-group>
                </b-col>
                <b-col md="6"> </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Email')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      ref="gEmail"
                      :placeholder="$t('Enter email addresss')"
                      v-model="myObj.guardian_email"
                    />
                    <!-- @focusout="CheckGEMail()" -->
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Employer')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter employer')"
                      v-model="myObj.guardian_employer"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :label="$t('Office Contact')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter office number')"
                      v-model="myObj.guardian_office_phone"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    :label="$t('Education')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter Education')"
                      v-model="myObj.guardian_education"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Office Address')"
                    :invalid-feedback="$t('Contact number is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter office contact number')"
                      v-model="myObj.guardian_office_address"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card class="">
              <h3 class="mt-1">{{ $t("Other Information") }}</h3>
              <hr />
              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Allergies')"
                    :invalid-feedback="$t('Allergies is required')"
                  >
                    <b-form-input
                      :placeholder="$t('Enter allergies')"
                      v-model="myObj.allergies"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Note')"
                    :invalid-feedback="$t('Note is required')"
                  >
                    <b-form-textarea
                      id="textarea-default"
                      :placeholder="$t('Enter note')"
                      rows="3"
                      v-model="myObj.remarks"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    :label="$t('Leaving Reason')"
                    :invalid-feedback="$t('Leaving Reason is required')"
                  >
                    <b-form-textarea
                      id="textarea-default"
                      :placeholder="$t('Enter leaving reason')"
                      rows="3"
                      v-model="myObj.last_note"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Admission')"
        icon="feather icon-alert-circle"
        v-if="!showHappinessTab"
      >
        <b-row align-h="center">
          <b-col md="7">
            <b-row v-if="$route.params.id > 0" class="mb-1">
              <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link class="font-weight-bold d-block text-nowrap mb-25">
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col>
            </b-row>
            <b-card>
              <h3 class="mt-1">{{ $t("Admission Test") }}</h3>
              <hr />
              <b-form-group
                :label="$t('Admission Test Date')"
                :invalid-feedback="$t('Test date is required')"
                ref="testDt"
                class="mb-2"
              >
                <flat-pickr
                  :config="config2"
                  v-model="admObj.testDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>

              <b-button variant="primary" class="mb-50 mr-50">
                {{ $t("Send Admit Card") }}
              </b-button>
              <b-button
                variant="primary"
                class="mb-50 mr-50"
                @click="printAdmit('admit-card')"
              >
                <feather-icon icon="PrinterIcon" />
                {{ $t("Admit Card") }}
              </b-button>
              <b-button
                v-if="reportDomain == 'myskoolksa'"
                variant="primary"
                class="mb-50 mr-50"
                @click="printAdmit('admit-card-final')"
              >
                <feather-icon icon="PrinterIcon" />
                {{ $t("Final Admit Card") }}
              </b-button>

              <b-form-group
                :label="$t('Admission Test Status')"
                :invalid-feedback="$t('Test Status is required')"
                ref="testSt"
                class="mt-1"
              >
                <v-select
                  v-model="admObj.testStatus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  :options="statusOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :placeholder="$t('Select status')"
                />
              </b-form-group>
              <b-form-group
                :label="$t('Admission Test Remarks')"
                :invalid-feedback="$t('Admission Remarks is required')"
              >
                <b-form-textarea
                  :placeholder="$t('Enter remarks')"
                  rows="3"
                  v-model="myObj.remarks"
                />
              </b-form-group>
            </b-card>
            <b-card>
              <h3 class="mt-1">{{ $t("Admission Interview") }}</h3>
              <hr />
              <b-form-group
                :label="$t('Admission Interview Date')"
                :invalid-feedback="$t('Interview date is required')"
                ref="intDt"
              >
                <flat-pickr
                  :config="config"
                  v-model="admObj.interviewDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
              <b-form-group
                :label="$t('Admission Interview Remarks')"
                :invalid-feedback="$t('Interview Remarks is required')"
              >
                <b-form-textarea
                  :placeholder="$t('Enter remarks')"
                  rows="3"
                  v-model="admObj.remarks"
                />
              </b-form-group>
              <b-form-group
                :label="$t('Admission Interview Status')"
                :invalid-feedback="$t('Interview Status is required')"
                ref="intSt"
              >
                <v-select
                  v-model="admObj.interviewStatus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  :options="statusOptions2"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :placeholder="$t('Select status')"
                />
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Documents')"
        icon="feather icon-link"
        v-if="!showHappinessTab"
      >
        <b-row align-h="center">
          <b-col md="7">
            <b-row v-if="$route.params.id > 0" class="mb-1">
              <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link class="font-weight-bold d-block text-nowrap mb-25">
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col>
            </b-row>
            <!-- <div class="file-uploader">
              <h5>
                <b-spinner
                  variant="dark"
                  :label="$t('Spinning')"
                  v-if="uploading"
                ></b-spinner>
                <span v-else> {{ $t("Upload Documents") }} </span>
              </h5>
              <input
                ref="studentdocs"
                type="file"
                class="file_upload"
                @change="uploadDocument()"
                multiple="true"
              />
            </div> -->
            <b-row
              v-for="(dd, ind) in docData"
              :key="ind"
              class="mb-1 align-items-center"
            >
              <b-col md="11">
                <b-card
                  body-class="p-75"
                  class="rounded cursor-pointer mb-0"
                  @click="
                    dd.url ? openFile(dd.url) : $refs['doc' + ind][0].click()
                  "
                >
                  <div class="d-flex align-items-start justify-content-between">
                    <div>
                      <feather-icon
                        class="mr-50"
                        :icon="dd.url ? 'CheckCircleIcon' : 'AlertCircleIcon'"
                        :class="dd.url ? 'text-success' : 'text-warning'"
                        size="20"
                      />
                      <span class="font-weight-bold">{{ dd.meta_title }}</span>
                    </div>

                    <b-spinner
                      v-if="docLoading && currentIndex == ind"
                      small
                      variant="primary"
                    />
                    <feather-icon
                      v-else
                      :icon="dd.url ? 'DownloadIcon' : 'UploadIcon'"
                      size="20"
                    />
                  </div>
                </b-card>
                <input
                  type="file"
                  hidden
                  :ref="'doc' + ind"
                  @change="selectDoc(dd, ind)"
                  accept="image/*,.pdf"
                />
              </b-col>
              <b-col md="1" class="pl-md-0 mt-50 mt-md-0">
                <feather-icon
                  v-if="dd.url"
                  icon="TrashIcon"
                  class="text-danger cursor-pointer"
                  size="20"
                  @click="dd.url = ''"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row align-h="center">
          <b-col md="7">
            <b-row class="mb-1">
              <b-col
                md="11"
                class="d-flex flex-wrap align-items-center justify-content-between"
              >
                <h4 class="mb-0">{{ $t("Additional Docs") }}</h4>
                <b-button
                  @click="$refs.studentdocs.click()"
                  variant="primary"
                  class="btn-icon"
                  :disabled="uploading"
                >
                  <input
                    ref="studentdocs"
                    type="file"
                    class="file_upload"
                    @change="uploadDocument()"
                    multiple="true"
                    accept="image/*,.pdf"
                    hidden
                  />
                  {{ $t("Upload More") }}
                </b-button>
              </b-col>
            </b-row>

            <b-row
              v-for="(file, index) in documents"
              :key="index"
              class="mb-1 align-items-center"
            >
              <b-col md="11">
                <b-card
                  body-class="p-75"
                  class="rounded cursor-pointer mb-0"
                  @click="openFile(file)"
                >
                  <div class="d-flex align-items-start justify-content-between">
                    <div>
                      <feather-icon
                        icon="CheckCircleIcon"
                        class="text-success mr-50"
                        size="20"
                      />
                      <span class="font-weight-bold">
                        {{ file.slice(0, 30) }} ...</span
                      >
                    </div>
                    <feather-icon icon="DownloadIcon" size="20" />
                  </div>
                </b-card>
              </b-col>
              <b-col md="1" class="pl-md-0 mt-50 mt-md-0">
                <feather-icon
                  icon="TrashIcon"
                  class="text-danger cursor-pointer"
                  size="20"
                  @click="deleteDocument(index)"
                />
              </b-col>
            </b-row>

            <!-- <b-row v-for="(file, index) in documents" :key="index" class="mb-1">
              <b-col md="11">
                <div class="d-flex align-items-start justify-content-between">
                  <div>
                    <feather-icon
                      icon="CheckCircleIcon"
                      class="text-success mr-50"
                      size="20"
                    />
                    <b-link :href="file" target="_blank" class="text-dark">
                      {{ file.slice(0, 30) }} ...
                    </b-link>
                  </div>
                  <b-link :href="file" target="_blank" class="text-dark">
                    <feather-icon icon="DownloadIcon" size="20" />
                  </b-link>
                </div>
              </b-col>
              <b-col md="1" class="pl-md-0 mt-50 mt-md-0">
                <feather-icon
                  icon="TrashIcon"
                  class="text-danger cursor-pointer"
                  size="20"
                  @click="deleteDocument(index)"
                />
              </b-col>
            </b-row> -->

            <!-- <template v-for="(file, index) in documents">
              <div class="file">
                <div style="display: flex; align-items: center">
                  <div class="file-type">
                    {{ file.split(".").pop().toUpperCase() }}
                  </div>
                  <b-link :href="file" target="_blank">
                    {{ file }}
                  </b-link>
                </div>
                <div class="file-delete">
                  <i
                    class="fa fa-trash"
                    aria-hidden="true"
                    @click="deleteDocument(index)"
                  ></i>
                </div>
              </div>
            </template> -->
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="
          $store.state.userData.studentStatus.toLowerCase() == 'present'
            ? $t('Contact Number')
            : $t('WhatsApp')
        "
        icon="feather icon-smartphone"
        v-if="!showHappinessTab"
      >
        <b-row class="match-height" align-h="center">
          <b-col md="6">
            <b-row v-if="$route.params.id > 0" class="mb-1">
              <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link class="font-weight-bold d-block text-nowrap mb-25">
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col>
            </b-row>
            <b-card class="">
              <h3 class="mt-1">{{ $t("Application Credentials") }}</h3>
              <hr />
              <b-row>
                <b-col md="8">
                  <b-form-group
                    :label="
                      $t(
                        ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                          ? 'WhatsApp No'
                          : 'Father\'s Contact'
                      )
                    "
                    :invalid-feedback="
                      $t('Please enter correct contact number')
                    "
                  >
                    <vue-tel-input
                      v-model="myObj.contact_father"
                      :inputOptions="vueTelOptions"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      @input="CheckFContact"
                    ></vue-tel-input>
                    <small class="mr-1 text-danger" v-if="fphoneerror">{{
                      $t("Phone number is required")
                    }}</small>
                    <small
                      class="mr-1 text-danger d-block"
                      v-else-if="contactDuplicateError"
                      >{{
                        $t(
                          "This number cannot match father, mother, or student contact."
                        )
                      }}</small
                    >
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="8">
                  <b-form-group
                    :label="
                      $t(
                        ['myskooltcfdemo', 'myskooltcf'].includes(reportDomain)
                          ? 'Parent\'s Contact'
                          : 'Mother\'s Contact'
                      )
                    "
                    :invalid-feedback="$t('Please enter correct phone number')"
                  >
                    <vue-tel-input
                      :inputOptions="vueTelOptions"
                      @input="CheckMContact"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      v-model="myObj.contact_mother"
                    ></vue-tel-input>
                    <small class="mr-1 text-danger" v-if="mphoneerror">{{
                      $t("Phone number is required")
                    }}</small>
                    <small
                      class="mr-1 text-danger d-block"
                      v-else-if="contactDuplicateError"
                      >{{
                        $t(
                          "This number cannot match father, mother, or student contact."
                        )
                      }}</small
                    >
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="8">
                  <b-form-group
                    :label="$t('Student\'s Contact')"
                    :invalid-feedback="$t('Please enter correct phone number')"
                  >
                    <vue-tel-input
                      :inputOptions="vueTelOptions"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                      @input="CheckContact"
                      v-model="myObj.contact_student"
                    ></vue-tel-input>
                    <small class="mr-1 text-danger" v-if="phoneerror">{{
                      $t("Phone number is required")
                    }}</small>
                    <small
                      class="mr-1 text-danger d-block"
                      v-else-if="contactDuplicateError"
                      >{{
                        $t(
                          "This number cannot match father, mother, or student contact."
                        )
                      }}</small
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Custom Fees')"
        icon="feather icon-credit-card"
        v-if="!showHappinessTab"
      >
        <b-row class="match-height" align-h="center">
          <b-col xl="8" lg="10" md="12">
            <b-row v-if="$route.params.id > 0" class="mb-1">
              <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link class="font-weight-bold d-block text-nowrap mb-25">
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col>
            </b-row>
            <b-card>
              <h3 class="mt-1">{{ $t("Custom Fees") }}</h3>
              <hr />
              <div v-if="customObj.length == 0" class="text-center">
                <b-button
                  @click="AddValue()"
                  variant="primary"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
                <p class="mb-0 mt-25">{{ $t("Add Custom Fee") }}</p>
              </div>
              <b-row v-for="(item, ind) in customObj" :key="ind">
                <b-col xl="6" lg="6" md="6" class="pr-md-0">
                  <b-form-group
                    :label="$t('Fee Type')"
                    :invalid-feedback="$t('Fee Type is required')"
                    ref="feetype"
                  >
                    <v-select
                      :id="'feetype' + ind"
                      v-model="item.feeTypeID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :clearable="false"
                      :options="FeeTypes"
                      :reduce="(opt) => opt.id"
                      :selectable="(opt) => !feeIds.includes(opt.id)"
                      label="feeType"
                      :disabled="feeLoading"
                      :placeholder="$t('Select fee type')"
                      @input="changeFeeType(ind)"
                    />
                  </b-form-group>
                </b-col>
                <b-col xl="2" lg="2" md="2" class="pr-md-0">
                  <b-form-group
                    :label="$t('Base Fee')"
                    :invalid-feedback="$t('Base fee is required')"
                  >
                    <b-form-input
                      v-model="item.baseFee"
                      type="number"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  xl="2"
                  lg="2"
                  md="2"
                  class=""
                  v-if="isTaxFee(item.feeTypeID) && taxSetting"
                >
                  <b-form-group
                    :label="$t('Tax') + '%'"
                    :invalid-feedback="$t('Tax percentage is required')"
                  >
                    <b-form-input
                      type="number"
                      placeholder="0"
                      v-model="item.taxPercentage"
                      @input="calculateAmount(ind)"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  xl="2"
                  lg="2"
                  md="2"
                  class="pr-md-0"
                  v-if="!taxSetting || !isTaxFee(item.feeTypeID)"
                >
                  <b-form-group
                    :label="$t('Discount') + '%'"
                    :invalid-feedback="$t('Invalid discount')"
                    :ref="'discount' + ind"
                  >
                    <b-form-input
                      type="number"
                      placeholder="0-100"
                      v-model="item.discount"
                      @input="calculateAmount(ind)"
                    />
                  </b-form-group>
                </b-col>
                <b-col xl="2" lg="2" md="2" class="">
                  <b-form-group
                    :label="$t('Amount')"
                    :invalid-feedback="$t('Amount is required')"
                    ref="amount"
                  >
                    <b-form-input
                      type="number"
                      placeholder=""
                      ref="amount"
                      v-model="item.amount"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12" class="text-center mb-1">
                  <b-button
                    v-if="ind == customObj.length - 1"
                    @click="AddValue()"
                    variant="primary"
                    class="btn-icon rounded-circle mr-1"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                  <b-button
                    @click="removeValue(item, ind)"
                    variant="outline-danger"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Subjects')"
        icon="feather icon-book"
        v-if="!showHappinessTab"
      >
        <b-row class="match-height" align-h="center">
          <b-col :md="isClasswiseEnrollment ? 10 : 8">
            <b-row v-if="$route.params.id > 0" class="mb-1">
              <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link class="font-weight-bold d-block text-nowrap mb-25">
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col>
            </b-row>
            <b-card>
              <h3 class="mt-1">
                {{ $t("Subjects Enrollment") }}
                <!-- <b-button
                  v-if="isClasswiseEnrollment"
                  @click="AddEnItem()"
                  variant="primary"
                  class="btn-icon rounded-circle ml-1"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button> -->
              </h3>
              <hr />
              <template v-if="isClasswiseEnrollment">
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      label=""
                      :invalid-feedback="$t('Enrollment is required')"
                    >
                      <v-select
                        v-model="selectedEnroll"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :filterBy="dropFilter"
                        :clearable="false"
                        :options="enrollOptions"
                        :selectable="(opt) => !isEnSelectedNew(opt)"
                        label="name"
                        :placeholder="$t('Select enrollment')"
                        @input="selectEnrollment()"
                      >
                        <template #option="option">
                          <div>
                            {{ option.clsName }} ({{ option.secName }}) -
                            {{ option.subName }} - {{ option.name }}
                          </div>
                        </template>
                        <template #selected-option="option">
                          <div>
                            {{ option.clsName }} ({{ option.secName }}) -
                            {{ option.subName }} - {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-table
                      class="mt-1"
                      :items="enrollList"
                      :fields="enrollFields"
                      responsive
                      show-empty
                    >
                      <template #head()="scope">
                        <div>
                          <span>{{ $t(scope.label) }}</span>
                        </div>
                      </template>
                      <template #cell(class)="data">
                        <b-badge variant="light-primary">
                          {{ data.item.clsName }} {{ data.item.secName }}
                        </b-badge>
                      </template>
                      <template #cell(subject)="data">
                        <b-badge variant="light-primary">
                          {{ data.item.subName }}
                        </b-badge>
                      </template>
                      <template #cell(teacher)="data">
                        <b-badge variant="light-primary">
                          {{ data.item.name }}
                        </b-badge>
                      </template>
                      <template #cell(actions)="data">
                        <b-button
                          variant="outline-danger"
                          class="btn-icon"
                          @click="removeEnroll(data.item, data.index)"
                        >
                          <feather-icon icon="XIcon" />
                        </b-button>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>

                <b-row
                  v-if="false"
                  v-for="(item, ind) in enrolledData"
                  :key="ind"
                >
                  <b-col md="3">
                    <b-form-group
                      :label="$t('Class')"
                      :invalid-feedback="$t('Class is required')"
                    >
                      <v-select
                        v-model="item.classID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :clearable="false"
                        :options="classesOptions"
                        :reduce="(opt) => opt.id"
                        label="name"
                        :placeholder="$t('Select class')"
                        @input="LoadEnSections(item, true)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('Section')"
                      :invalid-feedback="$t('Section is required')"
                    >
                      <v-select
                        v-model="item.secID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="item.sectionList"
                        :reduce="(val) => val.id"
                        label="section"
                        :clearable="false"
                        :placeholder="$t('Select section')"
                        @input="LoadSubjectByClass(item, true)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('Subject')"
                      :invalid-feedback="$t('Subject is required')"
                    >
                      <v-select
                        v-model="item.subID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :clearable="false"
                        :options="item.subjectList"
                        :reduce="(opt) => opt.id"
                        :selectable="
                          (opt) =>
                            !isEnSelected(opt.id, item.classID, item.secID)
                        "
                        label="subject"
                        :placeholder="$t('Select subject')"
                        :disabled="subLoading"
                        @input="LoadTeachers(item, true)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="$t('Teacher')"
                      :invalid-feedback="$t('Teacher is required')"
                    >
                      <v-select
                        v-model="item.tID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :clearable="false"
                        :options="item.teacherList"
                        :reduce="(opt) => opt.id"
                        label="name"
                        :placeholder="$t('Select teacher')"
                        :disabled="teacherLoading"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <span class="mr-1 font-medium-2"
                      >{{ $t("Enrolled") }}:
                    </span>
                    <b-form-checkbox
                      switch
                      inline
                      :checked="!item.isExcluded"
                      @change="item.isExcluded = !item.isExcluded"
                    />

                    <b-button
                      @click="removeEnItem(item, ind)"
                      variant="outline-danger"
                      class="btn-icon rounded-circle ml-1"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>

                    <hr />
                  </b-col>
                </b-row>
              </template>

              <template v-else-if="subObj && subObj.valueBool">
                <b-row v-for="(item, ind) in subjectData" :key="ind">
                  <b-col md="5">
                    <b-form-group
                      :label="$t('Subject')"
                      :invalid-feedback="$t('Subject is required')"
                      ref="sub"
                    >
                      <v-select
                        v-model="item.subID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :clearable="false"
                        :options="allSubjects"
                        :reduce="(opt) => opt.id"
                        :selectable="(opt) => !isSelectedItem(opt.id)"
                        label="subject"
                        :placeholder="$t('Select subject')"
                        @input="allowSubs(item, ind)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group
                      :label="$t('Teacher')"
                      :invalid-feedback="$t('Teacher is required')"
                      ref="staff"
                    >
                      <v-select
                        v-model="item.tID"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :clearable="false"
                        :options="staffList"
                        :reduce="(opt) => opt.id"
                        label="name"
                        :placeholder="$t('Select teacher')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2" class="mt-2">
                    <b-button
                      v-if="ind == subjectData.length - 1"
                      @click="AddSub()"
                      variant="primary"
                      class="btn-icon rounded-circle mr-50"
                    >
                      <feather-icon icon="PlusIcon" />
                    </b-button>
                    <b-button
                      @click="removeSub(item, ind)"
                      variant="outline-danger"
                      class="btn-icon rounded-circle"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                  </b-col>
                </b-row>
              </template>

              <template v-else>
                <b-row v-if="reportDomain == 'myskoolelixir'">
                  <b-col md="6">
                    <b-form-group :label="$t('Subject Group')">
                      <v-select
                        v-model="selectedGroup"
                        :options="subjectGroups"
                        :clearable="false"
                        label="parentLable"
                        :reduce="(val) => val"
                        :placeholder="$t('Select subject group')"
                        @input="setSubByGroup()"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-table
                  class="mt-1"
                  :items="subjectData"
                  :fields="subFields"
                  responsive
                  show-empty
                >
                  <template #head()="scope">
                    <div>
                      <span>{{ $t(scope.label) }}</span>
                    </div>
                  </template>

                  <template #cell(subjects)="data">
                    <b-badge variant="light-primary">
                      {{ data.item.subName }}
                    </b-badge>
                  </template>
                  <template #cell(status)="data">
                    <b-badge
                      :variant="
                        data.item.isExcluded ? 'light-danger' : 'light-success'
                      "
                    >
                      {{
                        data.item.isExcluded ? $t("Excluded") : $t("Enrolled")
                      }}
                    </b-badge>
                  </template>
                  <template #cell(actions)="data">
                    <b-button
                      v-if="data.item.isExcluded"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-success"
                      v-b-tooltip.hover.left
                      :title="$t('Enroll')"
                      class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                      @click="data.item.isExcluded = false"
                    >
                      <feather-icon icon="CheckIcon" class="" />
                    </b-button>
                    <b-button
                      v-else
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-danger"
                      v-b-tooltip.hover.left
                      :title="$t('Exclude')"
                      class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                      @click="data.item.isExcluded = true"
                    >
                      <feather-icon icon="XIcon" class="" />
                    </b-button>
                  </template>
                </b-table>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Rewards')"
        icon="feather icon-award"
        key="rewards"
        v-if="rewardsSetting && rewardsSetting.valueBool"
      >
        <b-row class="match-height" align-h="center">
          <b-col md="8">
            <b-row class="mb-1">
              <!-- <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link
                    class="font-weight-bold d-block text-nowrap"
                    style="margin-bottom: 4px"
                  >
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col> -->
            </b-row>
            <b-card>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h3 class="mt-1 mb-1">{{ $t("Student Rewards") }}</h3>
                  <h4 class="text-primary font-weight-bold">
                    {{ $t("Total Points") }}: {{ calculateTotalPoints() }}
                  </h4>
                </div>
                <div>
                  <b-button
                    variant="primary"
                    @click="showAddRewardModal = true"
                  >
                    <feather-icon icon="PlusIcon" class="mr-50" />
                    {{ $t("Add Reward") }}
                  </b-button>
                </div>
              </div>
              <hr />

              <b-table
                class="mt-1"
                :items="rewardsData"
                :fields="rewardFields"
                responsive
                show-empty
                :empty-text="$t('No rewards found')"
              >
                <template #head()="scope">
                  <div>
                    <span>{{ $t(scope.label) }}</span>
                  </div>
                </template>

                <template #cell(date)="data">
                  <b-badge variant="light-primary">
                    {{
                      new Date(data.item.date).toLocaleDateString("en-UK", {
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                      })
                    }}
                  </b-badge>
                </template>
                <template #cell(title)="data">
                  <b-badge variant="light-primary">
                    {{ data.item.title }}
                  </b-badge>
                </template>
                <template #cell(points)="data">
                  <b-badge
                    :variant="data.item.points < 0 ? 'danger' : 'light-success'"
                  >
                    {{ data.item.points }} pts
                  </b-badge>
                </template>
                <template #cell(actions)="data">
                  <b-button
                    v-if="data.item.points >= 0"
                    variant="outline-danger"
                    size="sm"
                    @click="removeReward(data.index)"
                    v-b-tooltip.hover
                    :title="$t('Remove Reward')"
                  >
                    <feather-icon icon="XIcon" size="14" />
                  </b-button>
                </template>
              </b-table>

              <!-- Add Reward Modal -->
              <b-modal
                v-model="showAddRewardModal"
                :title="$t('Add New Reward')"
                hide-footer
                size="md"
              >
                <b-form @submit.prevent="addReward">
                  <b-row>
                    <b-col md="12">
                      <b-form-group
                        :label="$t('Title')"
                        label-for="new-reward-title"
                        :invalid-feedback="$t('Title is required')"
                      >
                        <b-form-input
                          id="new-reward-title"
                          v-model="newReward.title"
                          :placeholder="$t('Enter reward title')"
                          required
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <b-form-group
                        :label="$t('Description')"
                        label-for="new-reward-description"
                        :invalid-feedback="$t('Description is required')"
                      >
                        <b-form-textarea
                          id="new-reward-description"
                          v-model="newReward.description"
                          :placeholder="$t('Enter description')"
                          rows="3"
                          required
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <b-form-group
                        :label="$t('Points')"
                        label-for="new-reward-points"
                        :invalid-feedback="$t('Points is required')"
                      >
                        <b-form-input
                          id="new-reward-points"
                          v-model="newReward.points"
                          type="number"
                          :placeholder="$t('Enter points')"
                          step="1"
                          min="1"
                          required
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="mt-3">
                    <b-col md="6">
                      <b-button
                        variant="secondary"
                        block
                        @click="cancelAddReward"
                      >
                        {{ $t("Cancel") }}
                      </b-button>
                    </b-col>
                    <b-col md="6">
                      <b-button
                        variant="primary"
                        type="submit"
                        block
                        :disabled="savingRewards"
                      >
                        <b-spinner v-if="savingRewards" small class="mr-1" />
                        {{ $t("Add Reward") }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-modal>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Driver')"
        icon="feather icon-truck"
        key="driver"
        v-if="$route.params.id >= 0 && showDriverTab"
        @click.native="onDriverTabClick"
        @show="onDriverTabClick"
      >
        <b-row class="match-height" align-h="center">
          <b-col md="8">
            <b-card>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h3 class="mt-1 mb-1">{{ $t("Driver Information") }}</h3>
                </div>
                <div>
                  <b-button
                    variant="primary"
                    @click="openDriverManagementModal"
                  >
                    <feather-icon icon="PlusIcon" class="mr-50" />
                    {{ $t("Manage Drivers") }}
                  </b-button>
                </div>
              </div>

              <!-- Multiple Driver Entries -->
              <div
                v-for="(driverEntry, index) in studentDrivers"
                :key="'driver-' + index"
                class="mb-3"
              >
                <b-row class="align-items-end">
                  <b-col md="4">
                    <b-form-group
                      :label="index === 0 ? $t('Driver') : ''"
                      :label-for="'driver-select-' + index"
                    >
                      <v-select
                        v-model="driverEntry.selectedDriver"
                        :options="driverOptions"
                        :clearable="false"
                        label="name"
                        :reduce="(val) => val"
                        :placeholder="$t('Select driver')"
                        :loading="driverLoading"
                        :disabled="driverLoading"
                        @input="onStudentDriverChange(driverEntry, index)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                      :label="index === 0 ? $t('Vehicle') : ''"
                      :label-for="'vehicle-select-' + index"
                    >
                      <v-select
                        v-model="driverEntry.selectedVehicle"
                        :options="driverEntry.vehicleOptions"
                        :clearable="false"
                        label="vehicleNo"
                        :reduce="(val) => val"
                        :placeholder="$t('Select vehicle')"
                        :disabled="!driverEntry.selectedDriver"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group
                      :label="index === 0 ? $t('Relation') : ''"
                      :label-for="'relation-input-' + index"
                    >
                      <b-form-input
                        v-model="driverEntry.relation"
                        :placeholder="$t('Enter relation')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    md="1"
                    class="d-flex align-items-end justify-content-center"
                  >
                    <b-button
                      variant="danger"
                      size="sm"
                      @click="removeDriverEntry(index)"
                      class="driver-action-btn remove-btn"
                      pill
                    >
                      <feather-icon icon="XIcon" size="14" />
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <!-- Add Driver Plus Icon before last cross -->
              <div class="text-center mt-3">
                <div class="d-flex justify-content-center align-items-center">
                  <!-- Plus Icon -->
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="addDriverEntry"
                    class="driver-action-btn add-btn mr-2"
                    pill
                  >
                    <feather-icon icon="PlusIcon" size="14" />
                  </b-button>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Timings')"
        icon="feather icon-calendar"
        v-if="$route.params.id > 0 && timeObj && timeObj.valueBool"
      >
        <b-row class="match-height" align-h="center">
          <b-col md="8">
            <b-row v-if="$route.params.id > 0" class="mb-1">
              <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link class="font-weight-bold d-block text-nowrap mb-25">
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col>
            </b-row>
            <b-card>
              <div class="d-flex justify-content-between">
                <h3 class="">{{ $t("Timings") }}</h3>
                <div>
                  <b-form-checkbox
                    v-model="sameDays"
                    switch
                    inline
                    v-b-tooltip.hover.bottomright
                    :title="$t('Everyday schedule same as monday')"
                    @input="setDays(timingInfo[0])"
                    class="mr-0"
                  />
                </div>
              </div>
              <hr />
              <b-row align-h="center" v-if="timeLoading">
                <b-spinner
                  class="my-4"
                  style="width: 4rem; height: 4rem"
                  variant="primary"
                  :label="$t('Spinning')"
                ></b-spinner>
              </b-row>
              <template v-else>
                <b-row class="">
                  <div
                    v-for="(item, index) in timingInfo"
                    :key="index"
                    style="display: flex; align-items: center; width: 100%"
                  >
                    <b-col md="4" class="">
                      <b-form-group
                        :label="$t('Day')"
                        :invalid-feedback="$t('Day is required')"
                        ref="day"
                      >
                        <v-select
                          v-model="item.day"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="daysList"
                          :reduce="(op) => op.value"
                          :selectable="(opt) => !currDays.includes(opt.value)"
                          :clearable="false"
                          label="text"
                          @input="changeDay()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="3" class="">
                      <b-form-group
                        :label="$t('Joins at')"
                        :invalid-feedback="$t('Joins at is required')"
                        ref="join"
                      >
                        <flat-pickr
                          v-model="item.timeIn"
                          class="form-control"
                          :config="{
                            enableTime: true,
                            noCalendar: true,
                            altFormat: 'h:i K',
                            altInput: true,
                            dateFormat: 'Y-m-d\\TH:i:S',
                            defaultHour: 8,
                          }"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="3" class="">
                      <b-form-group
                        :label="$t('Leaves at')"
                        :invalid-feedback="$t('Leaves at is required')"
                        ref="leave"
                      >
                        <flat-pickr
                          v-model="item.timeOut"
                          class="form-control"
                          :config="{
                            enableTime: true,
                            noCalendar: true,
                            altFormat: 'h:i K',
                            altInput: true,
                            dateFormat: 'Y-m-d\\TH:i:S',
                            defaultHour: 13,
                          }"
                          @on-close="setDays(item)"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="2" class="pr-md-0">
                      <b-button
                        v-if="index == timingInfo.length - 1"
                        @click="addDay()"
                        variant="primary"
                        class="btn-icon rounded-circle mr-50"
                      >
                        <feather-icon size="18" icon="PlusIcon" />
                      </b-button>
                      <b-button
                        v-if="timingInfo.length > 1"
                        @click="removeDay(item, index)"
                        variant="outline-danger"
                        class="btn-icon rounded-circle"
                      >
                        <feather-icon size="18" icon="XIcon" />
                      </b-button>
                    </b-col>
                  </div>
                </b-row>
                <b-row align-h="center" class="mt-1">
                  <b-col md="3">
                    <b-button
                      variant="success"
                      @click="saveTimings()"
                      :disabled="savingTime"
                      block
                    >
                      <b-spinner v-if="savingTime" small type="grow" />
                      <span v-else> {{ $t("Save") }} </span>
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        :title="$t('Academic History')"
        icon="feather icon-award"
        v-if="$route.params.id > 0 && reportDomain == 'myskoolksa'"
      >
        <!-- myskoolszablc -->
        <b-row class="match-height" align-h="center">
          <b-col md="8">
            <b-row v-if="$route.params.id > 0" class="mb-1">
              <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link class="font-weight-bold d-block text-nowrap mb-25">
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col>
            </b-row>

            <b-card v-if="historyData.length > 1">
              <template v-for="(history, index) in historyData">
                <!-- to show only -->
                <b-row>
                  <b-col md="12">
                    <h4>{{ history.degree }}</h4>
                    <hr />
                    <div class="d-flex align-items-center mb-50">
                      <h5 class="font-weight-bold mb-0 mr-50">
                        {{ $t("Institute") }}:
                      </h5>
                      <span>{{ history.university }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-50">
                      <h5 class="font-weight-bold mb-0 mr-50">
                        {{ $t("Board") }}:
                      </h5>
                      <span>{{ history.board }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-50">
                      <h5 class="font-weight-bold mb-0 mr-50">
                        {{ $t("Passing Year") }}:
                      </h5>
                      <span>{{ history.passingYear }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-50">
                      <h5 class="font-weight-bold mb-0 mr-50">
                        {{ $t("Annual / Supply") }}:
                      </h5>
                      <span>{{ history.examStatus }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-50">
                      <h5 class="font-weight-bold mb-0 mr-50">
                        {{ $t("Division / Grade") }}:
                      </h5>
                      <span>{{ history.division }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-50">
                      <h5 class="font-weight-bold mb-0 mr-50">
                        {{ $t("Discipline") }}:
                      </h5>
                      <span>{{ history.discipline }}</span>
                    </div>
                  </b-col>
                </b-row>

                <!-- input -->
                <b-row v-if="false">
                  <b-col md="6">
                    <b-form-group :label="$t('Institute')">
                      <b-form-input
                        v-model.trim="history.university"
                        :placeholder="$t('Enter institute name')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group :label="$t('Board')">
                      <b-form-input
                        v-model.trim="history.board"
                        :placeholder="$t('Enter board name')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group :label="$t('Passing Year')">
                      <b-form-input
                        v-model.trim="history.passingYear"
                        :placeholder="$t('Enter passing year')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group :label="$t('Seat Number')">
                      <b-form-input
                        v-model.trim="history.seatNo"
                        :placeholder="$t('Enter seat number')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group :label="$t('Annual / Supply')">
                      <v-select
                        v-model="history.examStatus"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="['Annual', 'Supply']"
                        :clearable="false"
                        :placeholder="$t('Select annual / supply')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group :label="$t('Division / Grade')">
                      <b-form-input
                        v-model.trim="history.division"
                        :placeholder="$t('Enter division')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group :label="$t('Discipline')">
                      <b-form-input
                        v-model.trim="history.discipline"
                        :placeholder="$t('Enter discipline')"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr v-if="index !== historyData.length - 1" />
              </template>
            </b-card>
            <b-card v-else>
              <h4 class="text-center">{{ $t("No Record Found") }}</h4>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <tab-content
        title="Face Recognition"
        icon="feather icon-camera"
        v-if="false"
      >
        <b-row class="match-height" align-h="center">
          <b-col xl="8" lg="9" md="10">
            <b-row class="mb-1">
              <b-col>
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                      size="44"
                      :src="studentPicturePreview"
                      variant="light-primary"
                    />
                  </template>

                  <b-link
                    class="font-weight-bold d-block text-nowrap"
                    style="margin-bottom: 4px"
                  >
                    <b-badge variant="light-primary">
                      {{ myObj.name }}
                    </b-badge>
                  </b-link>
                  <small class="text-muted">
                    <b-badge variant="light-primary">
                      GR - {{ myObj.grNo }}
                    </b-badge>
                    <b-badge variant="light-primary" class="ml-50">
                      F# - {{ myObj.family_code }}
                    </b-badge>
                  </small>
                </b-media>
              </b-col>
            </b-row>
            <b-card>
              <h4 class="mb-1">Face Recognition Images</h4>
              <hr />
              <p class="mb-50">
                Upload clear front-facing photos of the student's face for
                attendance recognition. For best results:
              </p>
              <ul class="mb-2">
                <li>Ensure good lighting and a neutral background</li>
                <li>Face should be clearly visible with no obstructions</li>
                <li>Upload multiple angles for better recognition accuracy</li>
              </ul>
              <b-row>
                <b-col md="4" v-for="(face, index) in faceData" :key="index">
                  <div class="d-flex flex-column align-items-center">
                    <div
                      class="border rounded p-50 mb-1"
                      style="width: 150px; height: 150px"
                    >
                      <div
                        v-if="picLoading && picIndex == index"
                        class="d-flex align-items-center justify-content-center h-100 bg-light"
                      >
                        <b-spinner small type="grow" variant="primary" />
                      </div>
                      <img
                        v-else-if="face.picture"
                        :src="getFacePicturePreview(face.picture)"
                        class="img-fluid"
                        style="width: 100%; height: 100%; object-fit: cover"
                        @error="onDrivePhotoPreviewError($event, face.picture)"
                      />
                      <div
                        v-else
                        class="d-flex align-items-center justify-content-center h-100 bg-light"
                      >
                        <feather-icon icon="UserIcon" size="40" />
                      </div>
                    </div>
                    <b-button
                      variant="primary"
                      size="sm"
                      class="mb-1"
                      :disabled="picLoading"
                      @click="$refs[`faceInput${index}`][0].click()"
                    >
                      <feather-icon icon="UploadIcon" size="16" class="mr-50" />
                      <span>Upload Face {{ index + 1 }}</span>
                    </b-button>
                    <input
                      type="file"
                      :ref="`faceInput${index}`"
                      hidden
                      accept="image/*"
                      @change="uploadFacePic($event, index)"
                    />
                    <b-button
                      v-if="face.picture"
                      variant="outline-danger"
                      size="sm"
                      class="mb-1"
                      :disabled="picLoading"
                      @click="removeFace(index)"
                    >
                      <feather-icon icon="TrashIcon" size="16" class="mr-50" />
                      <span>Remove</span>
                    </b-button>
                  </div>
                  <!-- <b-card class="text-center">
                  </b-card> -->
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>
      <!-- next & prev buttons -->
      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left d-none"></div>
        <div class="wizard-footer-right d-none"></div>
      </template>
    </form-wizard>

    <!-- Driver Modal -->
    <b-modal
      id="driver-modal"
      v-model="showDriverModal"
      :title="$t('Driver Information')"
      size="lg"
      :ok-only="false"
      :ok-title="$t('Save')"
      :cancel-title="$t('Cancel')"
      @ok="saveDriverInfo"
      @cancel="cancelDriverModal"
      scrollable
      style="max-height: 90vh"
    >
      <b-form>
        <!-- Driver Information Section -->
        <div class="mb-4">
          <h6 class="mb-3 text-primary">{{ $t("Driver Details") }}</h6>
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('Name') + ' *'" label-for="driver-name">
                <b-form-input
                  id="driver-name"
                  v-model="driverInfo.name"
                  :placeholder="$t('Enter driver name')"
                  :state="driverValidation.name"
                />
                <b-form-invalid-feedback v-if="driverValidation.name === false">
                  {{ $t("Driver name is required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Contact') + ' *'"
                label-for="driver-contact"
              >
                <b-form-input
                  id="driver-contact"
                  v-model="driverInfo.contact"
                  :placeholder="$t('Enter contact number')"
                  :state="driverValidation.contact"
                />
                <b-form-invalid-feedback
                  v-if="driverValidation.contact === false"
                >
                  {{ $t("Contact number is required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('CNIC') + ' *'" label-for="driver-cnic">
                <b-form-input
                  id="driver-cnic"
                  v-model="driverInfo.cnic"
                  :placeholder="$t('Enter CNIC')"
                  :state="driverValidation.cnic"
                />
                <b-form-invalid-feedback v-if="driverValidation.cnic === false">
                  {{ $t("CNIC is required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('License No') + ' *'"
                label-for="driver-license"
              >
                <b-form-input
                  id="driver-license"
                  v-model="driverInfo.licenseNo"
                  :placeholder="$t('Enter license number')"
                  :state="driverValidation.licenseNo"
                />
                <b-form-invalid-feedback
                  v-if="driverValidation.licenseNo === false"
                >
                  {{ $t("License number is required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('Address')" label-for="driver-address">
                <b-form-textarea
                  id="driver-address"
                  v-model="driverInfo.address"
                  :placeholder="$t('Enter address')"
                  rows="2"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('Attachments')"
                label-for="driver-attachments"
              >
                <b-form-file
                  id="driver-attachments"
                  placeholder=""
                  multiple
                  @change="handleDriverAttachmentUpload"
                />
                <small
                  v-if="
                    driverInfo.attachments && driverInfo.attachments.length > 0
                  "
                  class="text-success"
                >
                  {{ driverInfo.attachments.length }}
                  {{ $t("file(s) uploaded") }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <!-- Vehicle Details Section -->
        <div>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0 text-primary">{{ $t("Vehicle Details") }}</h6>
            <b-button
              variant="outline-success"
              size="sm"
              @click="addVehicleDetail"
            >
              <feather-icon icon="PlusIcon" size="14" class="mr-1" />
              {{ $t("Add") }}
            </b-button>
          </div>

          <div
            v-for="(vehicle, index) in vehicleDetails"
            :key="'vehicle-' + index"
            class="mb-3 p-3"
            style="
              border: 1px solid #e9ecef;
              border-radius: 6px;
              background: #f8f9fa;
            "
          >
            <div class="d-flex justify-content-between align-items-center mb-2">
              <small class="text-muted font-weight-bold"
                >{{ $t("Vehicle") }} {{ index + 1 }}</small
              >
              <b-button
                variant="outline-danger"
                size="sm"
                @click="removeVehicleDetail(index)"
                v-if="vehicleDetails.length > 1"
              >
                <feather-icon icon="XIcon" size="14" />
              </b-button>
            </div>

            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$t('Brand') + ' *'"
                  label-for="vehicle-brand"
                >
                  <b-form-input
                    :id="'vehicle-brand-' + index"
                    v-model="vehicle.brand"
                    :placeholder="$t('Enter brand')"
                    :state="
                      vehicleValidation[index] && vehicleValidation[index].brand
                    "
                  />
                  <b-form-invalid-feedback
                    v-if="
                      vehicleValidation[index] &&
                      vehicleValidation[index].brand === false
                    "
                  >
                    {{ $t("Brand is required") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('Vehicle No') + ' *'"
                  label-for="vehicle-number"
                >
                  <b-form-input
                    :id="'vehicle-number-' + index"
                    v-model="vehicle.vehicleNo"
                    :placeholder="$t('Enter vehicle number')"
                    :state="
                      vehicleValidation[index] &&
                      vehicleValidation[index].vehicleNo
                    "
                  />
                  <b-form-invalid-feedback
                    v-if="
                      vehicleValidation[index] &&
                      vehicleValidation[index].vehicleNo === false
                    "
                  >
                    {{ $t("Vehicle number is required") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group :label="$t('Model')" label-for="vehicle-model">
                  <b-form-input
                    :id="'vehicle-model-' + index"
                    v-model="vehicle.model"
                    :placeholder="$t('Enter model')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  :label="$t('Variant')"
                  label-for="vehicle-variant"
                >
                  <b-form-input
                    :id="'vehicle-variant-' + index"
                    v-model="vehicle.variant"
                    :placeholder="$t('Enter variant')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group :label="$t('Color')" label-for="vehicle-color">
                  <b-form-input
                    :id="'vehicle-color-' + index"
                    v-model="vehicle.color"
                    :placeholder="$t('Enter color')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$t('Chassis No')"
                  label-for="vehicle-chassis"
                >
                  <b-form-input
                    :id="'vehicle-chassis-' + index"
                    v-model="vehicle.chassisNo"
                    :placeholder="$t('Enter chassis number')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('Engine No')"
                  label-for="vehicle-engine"
                >
                  <b-form-input
                    :id="'vehicle-engine-' + index"
                    v-model="vehicle.engineNo"
                    :placeholder="$t('Enter engine number')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group :label="$t('Images')" label-for="vehicle-images">
                  <b-form-file
                    :id="'vehicle-images-' + index"
                    placeholder=""
                    multiple
                    accept="image/*"
                    @change="handleVehicleImageUpload($event, index)"
                  />
                  <small
                    v-if="vehicle.images && vehicle.images.length > 0"
                    class="text-success"
                  >
                    {{ vehicle.images.length }} {{ $t("image(s) uploaded") }}
                  </small>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-form>
    </b-modal>

    <!-- Driver Management Modal -->
    <b-modal
      id="driver-management-modal"
      v-model="showDriverManagementModal"
      :title="$t('Manage Drivers')"
      size="lg"
      :ok-only="false"
      :ok-disabled="true"
      :cancel-disabled="true"
      :hide-footer="true"
      @hide="closeDriverManagementModal"
      scrollable
      style="max-height: 90vh"
    >
      <div class="mb-3">
        <b-button variant="outline-success" @click="openAddDriverModal">
          <feather-icon icon="PlusIcon" size="16" />
          {{ $t("Add Driver") }}
        </b-button>
      </div>

      <b-table
        :items="driverOptions"
        :fields="driverTableFields"
        striped
        hover
        responsive
        :busy="driverLoading"
        show-empty
        :empty-text="$t('No drivers found')"
      >
        <template #head()="scope">
          <div>
            <span>{{ $t(scope.label) }}</span>
          </div>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("Loading") }}...</strong>
          </div>
        </template>

        <template #cell(contact)="row">
          {{ row.item.contact }}
        </template>

        <template #cell(vehicles)="row">
          <b-badge
            variant="info"
            v-if="row.item.details && row.item.details.length > 0"
          >
            {{ row.item.details.length }} {{ $t("vehicle(s)") }}
          </b-badge>
          <span v-else class="text-muted">{{ $t("No vehicles") }}</span>
        </template>

        <template #cell(actions)="row">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="editDriverFromTable(row.item)"
            class="mr-1"
          >
            <feather-icon icon="EditIcon" size="14" />
          </b-button>
        </template>
      </b-table>
    </b-modal>

    <!-- Synced Details Modal -->
    <b-modal
      id="modal-synced-details"
      v-model="showSyncedModal"
      :title="$t('App Account Details')"
      centered
      hide-footer
      body-class="p-0"
    >
      <div v-if="selectedSyncedDetails">
        <div
          v-for="(val, key) in selectedSyncedDetails"
          :key="key"
          class="p-2 border-bottom d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="40"
              :variant="val.synced ? 'light-success' : 'light-danger'"
              class="mr-1"
            >
              <feather-icon
                :icon="key === 'student' ? 'UserIcon' : 'UsersIcon'"
              />
            </b-avatar>
            <div>
              <h5 class="text-capitalize font-weight-bolder mb-0">
                {{ $t(key) }}
              </h5>
              <small class="text-muted d-block">
                {{ val.number || $t("No number provided") }}
              </small>
            </div>
          </div>
          <b-badge
            pill
            :variant="val.synced ? 'light-success' : 'light-danger'"
            class="text-uppercase"
            style="padding: 0.5rem 1rem"
          >
            {{ val.synced ? $t("Active") : $t("Inactive") }}
          </b-badge>
        </div>
      </div>
      <div v-else class="p-3 text-center">
        <h5 class="text-muted">
          {{ $t("No synchronization details found.") }}
        </h5>
      </div>
    </b-modal>

    <b-row align-h="center">
      <b-col md="6">
        <b-button block variant="success" @click="shortcutSubmit()">
          {{
            ["registered", "enrolled"].includes(myObj.status.toLowerCase()) &&
            (this.$route.params.readmit == true ||
              this.$route.params.readmit == "true")
              ? $t(showHappinessTab ? "Enroll Now" : "Confirm Admission")
              : ["registered"].includes(myObj.status.toLowerCase()) &&
                $route.params.id == 0
              ? $t("Register Now")
              : $t("Save")
          }}
        </b-button>
        <b-button
          v-if="fObj && fObj.valueBool"
          class="mt-1"
          block
          variant="success"
          @click="shortcutSubmit(true)"
        >
          {{ $t("Save & Update family common data") }}
        </b-button>
      </b-col>
    </b-row>

    <b-modal
      id="modal-happiness-dropdown"
      v-model="dropdownModalVisible"
      hide-footer
      centered
      size="lg"
      modal-class="happiness-dropdown-modal-wrapper"
      header-class="happiness-dropdown-modal-header"
      body-class="happiness-dropdown-modal-body"
      content-class="happiness-dropdown-modal-content"
      @hidden="closeDropdownModal"
    >
      <template #modal-title>
        <div class="happiness-dropdown-modal-title">
          <span class="happiness-dropdown-modal-title-icon">
            <feather-icon icon="ListIcon" size="18" />
          </span>
          <div>
            <h5 class="mb-0">{{ dropdownModalTitle }}</h5>
            <small class="happiness-dropdown-modal-subtitle">
              {{ $t("Add or update items") }}
            </small>
          </div>
        </div>
      </template>

      <div class="happiness-dropdown-modal-add-panel">
        <b-form-input
          :placeholder="$t('Enter name')"
          v-model.trim="dropdownFormTitle"
          class="happiness-dropdown-modal-input"
          @keyup.enter="saveDropdownItem()"
        />
        <b-button
          variant="primary"
          class="happiness-dropdown-modal-add-btn"
          :disabled="dropdownSaving"
          @click="saveDropdownItem()"
        >
          <b-spinner
            v-if="dropdownSaving && !dropdownEditingId"
            small
            type="grow"
          />
          <template v-else>
            <feather-icon icon="PlusIcon" size="16" class="mr-50" />
            {{ $t("Add") }}
          </template>
        </b-button>
      </div>

      <div class="happiness-dropdown-modal-search">
        <feather-icon
          icon="SearchIcon"
          size="16"
          class="happiness-dropdown-modal-search-icon"
        />
        <b-form-input
          v-model="dropdownModalSearch"
          :placeholder="$t('Search') + '...'"
          class="happiness-dropdown-modal-input happiness-dropdown-modal-search-input"
        />
      </div>

      <div class="happiness-dropdown-modal-table-wrap">
        <b-table
          :items="filteredDropdownModalItems"
          :fields="dropdownModalFields"
          :busy="dropdownLoading"
          show-empty
          responsive
          hover
          small
        >
          <template #empty>
            <h5 class="text-center my-2">{{ $t("No records found") }}</h5>
          </template>
          <template #table-busy>
            <div class="d-flex justify-content-center my-2">
              <b-spinner variant="primary" />
            </div>
          </template>
          <template #cell(title)="data">
            <b-form-input
              v-if="dropdownEditingId === data.item.id"
              v-model.trim="dropdownEditingTitle"
              @keyup.enter="saveDropdownEdit()"
            />
            <span v-else>{{ data.item.title }}</span>
          </template>
          <template #cell(actions)="data">
            <div v-if="dropdownEditingId === data.item.id" class="d-flex">
              <b-button
                size="sm"
                variant="primary"
                class="btn-icon mr-50"
                :disabled="dropdownSaving"
                @click="saveDropdownEdit()"
              >
                <b-spinner v-if="dropdownSaving" small />
                <feather-icon v-else icon="CheckIcon" size="16" />
              </b-button>
              <b-button
                size="sm"
                variant="outline-danger"
                class="btn-icon"
                :disabled="dropdownSaving"
                @click="cancelEditDropdownItem()"
              >
                <feather-icon icon="XIcon" size="16" />
              </b-button>
            </div>
            <b-button
              v-else
              size="sm"
              variant="outline-primary"
              class="btn-icon"
              @click="startEditDropdownItem(data.item)"
            >
              <feather-icon icon="EditIcon" size="16" />
            </b-button>
          </template>
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import heic2any from "heic2any";

import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "axios";
import {
  getMediaPreviewUrl,
  getUploadPath,
  getUploadedPaths,
  handleDrivePreviewError,
  uploadToMySkool,
} from "@/utils/gdriveUpload";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BButton,
  BMediaAside,
  BImg,
  BMedia,
  BLink,
  BSpinner,
  BBadge,
  BFormFile,
  BFormTextarea,
  BProgress,
  BProgressBar,
  BFormCheckbox,
  BFormRadioGroup,
  BSidebar,
  BForm,
  BInputGroupPrepend,
  BInputGroup,
  BTable,
  VBTooltip,
  BAvatar,
  BModal,
  BAlert,
} from "bootstrap-vue";
export default {
  props: ["selected", "id", "inqObj"],
  components: {
    BSidebar,
    BForm,
    BInputGroupPrepend,
    BInputGroup,
    BTable,
    BFormCheckbox,
    BFormRadioGroup,
    BProgress,
    BProgressBar,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    flatPickr,
    BCard,
    BButton,
    BMediaAside,
    BImg,
    BMedia,
    BLink,
    BSpinner,
    BBadge,
    BFormFile,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    VBTooltip,
    BAvatar,
    BModal,
    BAlert,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
    mask,
  },
  data() {
    return {
      commonData: false,
      settings: {
        sameDate: false,
        sameClass: false,
        sameSec: false,
      },
      visibility1: false,
      file: [],
      mydocs: [],
      moreloading: false,
      plus: "",
      logoloading: false,
      dataloading: false,
      admittedSections: [],
      currentSections: [],
      classes: [],
      genders: ["Male", "Female"],
      categories: [],
      prog: {
        test_fee: false,
        test_passed: false,
        confirmed: false,
      },
      groups: ["A", "B", "O", "AB"],
      religions: ["ISLAM", "CHRISTIANITY", "HINDUISM", "BUDDHISM", "SIKHISM"],
      areaOptions: [],
      documents: [],
      uploading: false,
      customObj: [],
      allSubjects: [],
      subjectData: [],
      subFields: [
        { label: "subjects", key: "subjects" },
        { label: "status", key: "status" },
        { key: "actions", label: "actions" },
      ],
      subjectData: [],
      sessionbar: false,
      savingacc: false,
      sessFields: [
        { label: "Name", key: "session" },
        { key: "actions", label: "actions" },
      ],
      allSess: [],
      sessionObj: {
        id: 0,
        session: "",
        campusID: this.$store.state.userData.cId,
      },
      accIcon: "",
      visibility2: false,
      disData: [],
      disFields: [
        { label: "Name", key: "name" },
        { key: "actions", label: "actions" },
      ],
      disObj: {},
      disOptions: [
        { text: "Amount", value: "amount" },
        { text: "Percentage", value: "percentage" },
      ],
      disTypes: [
        { text: "Fixed", value: "fixed" },
        { text: "Variable", value: "variable" },
      ],
      disableDiscount: false,
      savingDis: false,
      showSyncedModal: false,
      selectedSyncedDetails: null,
      selectedSyncedStudentID: null,
      syncLoading: false,
      classHistoryLogs: [],
      loadingHistoryLogs: false,
      showAddLogModal: false,
      savingLog: false,
      logSectionOptions: [],
      logForm: {
        sessionID: null,
        classID: null,
        sectionID: null,
        agecategory: null,
        empoweLevel: null,
      },
      allSections: [],
      previousLogDetails: null,
      prevObj: null,
      myObj: {
        id: 0,
        grNo: null,
        grNoLocal: null,
        grValue: null,
        receiptNo: 0,
        family_code: null,
        name: null,
        father_name: null,
        gender: null,
        picture: null,
        date_of_birth: null,
        date_of_birth_words: null,
        date_of_admission: null,
        blood_group: null,
        nationality: null,
        religion:
          this.$store.state.report.replace(/_/g, "") ===
          "myskoolcrestviewacademy"
            ? "ISLAM"
            : null,
        place_of_birth: null,
        mother_tongue: null,
        address_current: null,
        address_permanent: null,
        contact_student: null,
        contact_father: null,
        contact_mother: null,
        contact_home: null,
        contact_tutor: null,
        last_institute: null,
        last_class: null,
        last_session: null,
        last_result: null,
        last_note: null,
        class_admitted: 0,
        cls_admitted: null,
        class_current: 0,
        cls_current: null,
        section_admitted: "",
        section_current: "",
        roll_number: null,
        house: null,
        rfid_number: null,
        bform_number: null,
        date_of_registraion: null,
        date_of_readmission: null,
        date_of_joining: null,
        father_cnic: null,
        father_education: null,
        father_occupation: null,
        monthly_income: null,
        office_phone: null,
        office_address: null,
        father_email: null,
        father_employer: null,
        mother_name: null,
        mother_cnic: null,
        mother_education: null,
        mother_occupation: null,
        mother_office_phone: null,
        mother_office_address: null,
        mother_email: null,
        mother_employer: null,
        guardian_name: null,
        guardian_cnic: null,
        guardian_education: null,
        guardian_occupation: null,
        guardian_office_phone: null,
        guardian_office_address: null,
        guardian_email: null,
        guardian_employer: null,
        guardian_relationship: null,
        emergency_name: null,
        emergency_contact: null,
        emergency_relationship: null,
        learningDifficulties: null,
        specialMedicalNeeds: null,
        physical_handicap: null,
        emailAddress: null,
        allergies: null,
        remarks: null,
        monthly_fee: 0,
        discount_percentage: 0,
        discount: 0,
        challan_due_date: null,
        docs: "",
        status: this.$store.state.userData.studentStatus,
        campusID: this.$store.state.userData.cId,
        campus_Admitted: this.$store.state.userData.cId,
        testPayment: false,
        testPassed: false,
        testCompleted: false,
        sessionID: 0,
        currency: "Rs",
        classFee: 0,
        discountReferenceID: 0,
        discountNote: "",
        timelyDiscount: 0,
      },
      fphoneerror: false,
      mphoneerror: false,
      phoneerror: false,
      contactDuplicateError: false,
      emerPhoneerror: false,
      yesNoOptions: [
        { text: "No", value: false },
        { text: "Yes", value: true },
      ],
      learningDifficultiesHas: false,
      learningDifficultiesDetail: "",
      specialMedicalNeedsHas: false,
      specialMedicalNeedsDetail: "",
      vueTelOptions: { placeholder: "Enter contact number" },
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      emerOpt: { placeholder: "Enter emergency contact" },
      classesOptions: [],
      check: 1,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      config2: {
        enableTime: true,
        altFormat: "j M, Y h:i K",
        altInput: true,
        dateFormat: "Y-m-d\\TH:i:S",
        defaultHour: 9,
      },
      fields: [
        { label: "Family Code", key: "family_code" },
        { label: "father name", key: "father_name" },
        { label: "contact", key: "contact_father" },
      ],
      studentData: [],
      searchQuery: "",
      visibility: false,
      studentLoading: false,
      initData: null,
      feeAmount: null,
      FeeTypes: [],
      feeLoading: false,
      feeIds: [],
      addingMsg: this.$store.state.addMsg,
      uRights: {
        hideFee: false,
      },
      admObj: {
        id: 0,
        sID: this.$route.params.id,
        campusID: this.$store.state.userData.cId,
        testDate: null,
        testStatus: "",
        interviewDate: null,
        interviewStatus: "",
        remarks: "",
        documents: "",
      },
      statusOptions: [
        { text: "Cleared", value: "cleared" },
        { text: "Undertaking", value: "undertaking" },
        { text: "Not Cleared", value: "not cleared" },
      ],
      statusOptions2: [
        { text: "Cleared", value: "cleared" },
        { text: "Not Cleared", value: "not cleared" },
      ],
      docData: [],
      fObj: null,
      otherObj: null,
      disSetting: null,
      dCopy: {},
      visibility3: false,
      savingSett: false,
      schGr: null,
      spNo: null,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      campuses: this.$store.state.branches,
      currentIndex: 0,
      docLoading: false,
      sameDays: this.$store.state.sameTimings,
      currDays: [],
      timeObj: null,
      timingInfo: [],
      timeLoading: false,
      savingTime: false,
      daysList: [
        { text: "Monday", value: "monday" },
        { text: "Tuesday", value: "tuesday" },
        { text: "Wednesday", value: "wednesday" },
        { text: "Thursday", value: "thursday" },
        { text: "Friday", value: "friday" },
        { text: "Saturday", value: "saturday" },
        { text: "Sunday", value: "sunday" },
      ],
      historyData: [],
      faceData: [],
      picLoading: false,
      picIndex: 0,
      discountValue: 0,
      discountBy: "none",
      disVisible: ["myskoolstanmore", "myskooliuss"],
      customFeeDomains: ["myskoolksa"],
      rewardsData: [
        {
          title: "New Student Registration by Parent",
          description:
            "Reward 100 points upon successful registration of a new student by a parent",
          points: 100,
          date: new Date("2024-01-15"),
        },
        {
          title: "Full-Year Fee Payment (One-Time Payment)",
          description:
            "Reward 100 points if the parent pays the full tuition fees in a single payment before the due date",
          points: 100,
          date: new Date("2025-01-10"),
        },
        {
          title: "Installment-Based Payment",
          description:
            "Reward points if the first installment is paid on or before the due date. Points value configurable (e.g., 50 points)",
          points: 50,
          date: new Date("2025-01-05"),
        },
        {
          title: "Purchase of Books or Uniform",
          description:
            "Reward points when the parent purchases books or uniforms through the school's system/store. Points value configurable based on item type or total purchase amount",
          points: 50,
          date: new Date("2025-12-20"),
        },
      ],
      savingRewards: false,
      showAddRewardModal: false,
      newReward: {
        title: "",
        description: "",
        points: 0,
      },
      rewardFields: [
        { key: "date", label: "Date" },
        { key: "title", label: "Title" },
        { key: "points", label: "Points" },
        { key: "actions", label: "Actions" },
      ],
      rewardsSetting: null, // Initialize rewardsSetting
      taxSetting: null, // Initialize taxSetting
      joiningDateObj: null,
      rfObj: null,
      // Driver-related data
      selectedDriver: null,
      selectedVehicle: null,
      driverRelation: "",
      studentDrivers: [
        {
          selectedDriver: null,
          selectedVehicle: null,
          vehicleOptions: [],
          relation: "",
          id: 0,
          sID: 0,
          driverID: 0,
          vehicleID: 0,
          campusID: 0,
        },
      ],
      driverOptions: [],
      vehicleOptions: [],
      driverLoading: false,
      vehicleLoading: false,
      driverDataLoaded: false,
      pendingStudentDrivers: [],
      showDriverModal: false,
      showDriverManagementModal: false,
      isEditMode: false,
      driverTableFields: [
        { key: "name", label: "Driver Name", sortable: true },
        { key: "contact", label: "Contact", sortable: true },
        { key: "cnic", label: "CNIC", sortable: true },
        { key: "licenseNo", label: "License No", sortable: true },
        { key: "vehicles", label: "Vehicles", sortable: false },
        { key: "actions", label: "Actions", sortable: false },
      ],
      driverInfo: {
        id: null,
        name: "",
        contact: "",
        address: "",
        cnic: "",
        licenseNo: "",
        attachments: [],
        campusID: this.$store.state.userData.cId,
      },
      vehicleDetails: [
        {
          id: 0,
          driverID: 0,
          brand: "",
          model: "",
          variant: "",
          color: "",
          vehicleNo: "",
          chassisNo: "",
          engineNo: "",
          images: [],
          campusID: this.$store.state.userData.cId,
        },
      ],
      driverValidation: {
        name: null,
        contact: null,
        cnic: null,
        licenseNo: null,
      },
      vehicleValidation: [
        {
          brand: null,
          vehicleNo: null,
        },
      ],
      subjectGroups: [],
      selectedGroup: "",
      subObj: null,
      staffList: [],
      isClasswiseEnrollment: false,
      enrolledData: [],
      subLoading: false,
      teacherLoading: false,
      enrollOptions: [],
      selectedEnroll: null,
      enrollList: [],
      enrollFields: [
        { label: "class", key: "class" },
        { label: "subject", key: "subject" },
        { label: "teacher", key: "teacher" },
        { label: "actions", key: "actions" },
      ],
      supportOptions: [
        { text: "Very Urgent", value: "very-urgent" },
        { text: "Moderately Urgent", value: "moderately-urgent" },
        { text: "Not Urgent", value: "not-urgent" },
      ],
      donorInfo: null,
      donorLoading: false,
      ageCategoryRaw: [],
      empowerLevelRaw: [],
      dropdownModalVisible: false,
      dropdownModalCategory: "",
      dropdownModalTitle: "",
      dropdownModalItems: [],
      dropdownModalSearch: "",
      dropdownFormTitle: "",
      dropdownEditingId: null,
      dropdownEditingTitle: "",
      dropdownSaving: false,
      dropdownLoading: false,
      dropdownModalFields: [
        {
          label: "Name",
          key: "title",
        },
        {
          key: "actions",
          label: "actions",
          tdClass: "text-center",
        },
      ],
      selectedDonorID: 0,
      donorOptions: [],
      donorListLoading: false,
      regClass: 0,
      regSection: 0,
      siblingInfo: [],
      siblingSearchQuery: "",
      siblingSearchResults: [],
      siblingSearchLoading: false,
      siblingSearchTimer: null,
      otherPhoto: null,
      otherPhotoLoading: false,
      approvalList: [],
    };
  },
  created() {
    // this.$store.state.menu.forEach((el) => {
    //   el.children.forEach((ch) => {
    //     console.log("ch", ch.route, this.$route.name);
    //     if (ch.route == this.$route.name) {
    //       if (this.$route.params.id == 0 && ch.add) console.log("allowed");
    //       else if (this.$route.params.id != 0 && ch.edit)
    //         console.log("allowed edit");
    //       this.$router.go(-1);
    //     }
    //   });
    // });

    // console.log(
    //   "----------",
    //   this.selected,
    //   this.$route.params.readmit,
    //   this.$route.params.id
    // );
    // console.log(this.inqObj);
    if (this.inqObj) {
      this.$route.params.id = parseInt(this.$route.params.id);
      this.applyInquiryDataToStudent(this.inqObj.inquiry);

      this.$store.commit("stdStatus", "registered");
      this.myObj.status = this.$store.state.userData.studentStatus;
      this.LoadData(this.myObj.campusID);
      this.loadSubjects();
      this.loadFeeType();
      this.LoadSession();
      this.settings = { ...this.$store.state.studentSetting };
      this.LoadSettings();
      this.LoadSettingsAll();
      this.LoadAreas();
    } else {
      let st = this.$route.query.status;
      // console.log("query status", st);
      this.$route.params.id = parseInt(this.$route.params.id);

      var right = null;
      if (this.$route.params.id == 0) {
        right = this.$store.state.rights["manage-studentgrid"];
      } else if (st) {
        if (
          ["present", "registered", "left", "enrolled", "alumni"].includes(st)
        ) {
          right = this.$store.state.rights["manage-studentgrid"];
        }
        if (this.reportDomain == "myskoolhpgs") {
          let other = null;
          if (st == "registered") {
            other = this.$store.state.rights["student-registered"];
          } else if (st == "enrolled") {
            other = this.$store.state.rights["student-enrolled"];
          }
          if (right && !right.edit && other) {
            right = other;
          } else if (!right && other) {
            right = other;
          }
        }
      }

      this.uRights = right;
      if (!right) {
        this.$router.replace({
          name: "misc-not-authorized",
        });
      } else {
        if (this.uRights.hideFee == undefined) this.uRights.hideFee = false;
        if (this.$route.params.id > 0 && right.edit) {
          this.LoadSettings();
          this.LoadStudent();
          // move loadfeetype to after loadstudent
          this.LoadSession();
          // this.LoadSettingsAll(); // moved to before loadstudent
          this.LoadAreas();
          // this.LoadFaceData();
          this.LoadSubGroups();
          if (this.reportDomain == "myskoolksa") this.LoadHistory();
          if (this.showHappinessTab) {
            this.loadDonorForStudent();
            this.LoadDonors();
            this.loadHappinessDropdowns();
            this.LoadClassHistory();
          }
        } else if (this.$route.params.id == 0 && right.add) {
          if (this.selected === "add") {
            this.$store.commit("stdStatus", "present");
            // console.log(this.$store.state.userData.studentStatus);
            this.myObj.status = this.$store.state.userData.studentStatus;
            this.LoadData();
            this.LoadInit();
            if (this.showHappinessTab) {
              this.LoadDonors();
              this.loadHappinessDropdowns();
              this.otherPhoto = {
                id: 0,
                docID: 1,
                url: null,
                localID: 1,
                typee: "student",
                meta_title: "Plants/Natural Background",
                campusID: this.$store.state.userData.cId,
              };
            }
          } else if (this.selected === "reg") {
            this.$store.commit("stdStatus", "registered");
            // console.log(this.$store.state.userData.studentStatus);
            this.myObj.status = this.$store.state.userData.studentStatus;
            this.LoadData();
            this.LoadInit();
          } else if (this.selected == undefined) {
            // console.log(this.$store.state.userData.studentStatus);
            this.myObj.status = this.$store.state.userData.studentStatus;
            // console.log(this.myObj);
            this.LoadData();
          }
          this.loadSubjects();
          this.loadFeeType();
          this.LoadSession();
          this.LoadSettings();
          this.LoadSettingsAll();
          this.LoadAreas();
          this.LoadSubGroups();
          this.settings = { ...this.$store.state.studentSetting };
          // console.log(this.settings);
        } else {
          this.$router.replace({
            name: "misc-not-authorized",
          });
        }
      }
    }
  },
  mounted() {
    this.$refs.wizard.activateAll();
    window.addEventListener("keydown", this.handleEvent);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleEvent);
  },
  computed: {
    showDriverTab() {
      return [
        "myskool",
        "myskoolelixir",
        "myskooliqradq",
        "myskoolkentschool",
      ].includes(this.reportDomain);
    },
    showHappinessTab() {
      return this.reportDomain == "myskoolhappinessfoundation";
    },
    isShsSchool() {
      const domain = (this.$store.state.report || "")
        .replace(/_/g, "")
        .toLowerCase();
      const clientId = (this.$store.state.clientID || "")
        .replace(/_/g, "")
        .toLowerCase();
      const hostname =
        typeof window !== "undefined"
          ? window.location.hostname.toLowerCase()
          : "";
      return (
        domain === "shsschool" ||
        domain.includes("shsschool") ||
        clientId === "shsschool" ||
        clientId.includes("shsschool") ||
        hostname === "shsschool.myskool.app" ||
        hostname.startsWith("shsschool.")
      );
    },
    /** SHS: registration uses Gr Local only; GR number is assigned on admission confirm */
    isShsSchoolGrLocalRegistration() {
      if (!this.isShsSchool) return false;

      const studentStatus = (
        this.$store.state.userData.studentStatus || ""
      ).toLowerCase();
      if (studentStatus && studentStatus !== "present") return true;

      const readmit = ["true", true].includes(this.$route.params.readmit);
      const status = (this.myObj.status || "").toLowerCase();
      const queryStatus = (this.$route.query.status || "").toLowerCase();

      if (this.selected === "reg") return true;
      if (status === "registered" || queryStatus === "registered") return true;
      if (status === "enrolled" || queryStatus === "enrolled") return true;
      if (
        readmit &&
        ["registered", "enrolled"].includes(status || queryStatus)
      ) {
        return true;
      }
      return false;
    },
    isCplc: function () {
      return this.reportDomain == "myskoolcplc";
    },
    showCrestMyskoolFields() {
      const d = (this.$store.state.report || "")
        .replace(/_/g, "")
        .toLowerCase();
      return (
        d === "myskool" ||
        d === "myskoolcrestviewacademy" ||
        d.includes("crestview")
      );
    },
    isCrestViewAcademy() {
      return this.reportDomain === "myskoolcrestviewacademy";
    },
    plainBackgroundPreview() {
      if (!this.plus) return "";
      if (String(this.plus).startsWith("blob:")) return this.plus;
      return getMediaPreviewUrl(this.plus, "Image");
    },
    otherPhotoPreview() {
      const url = this.otherPhoto && this.otherPhoto.url;
      if (!url) return "";
      if (String(url).startsWith("blob:")) return url;
      return getMediaPreviewUrl(url, "Image");
    },
    studentPicturePreview() {
      return this.myObj && this.myObj.picture
        ? getMediaPreviewUrl(this.myObj.picture, "Image")
        : "";
    },
    ageOptions() {
      return this.mapDropdownToOptions(this.ageCategoryRaw);
    },
    empowerOptions() {
      return this.mapDropdownToOptions(this.empowerLevelRaw);
    },
    filteredDropdownModalItems() {
      if (!this.dropdownModalSearch) return this.dropdownModalItems;
      const query = this.dropdownModalSearch.toLowerCase();
      return this.dropdownModalItems.filter((item) =>
        (item.title || "").toLowerCase().includes(query)
      );
    },
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    goBack() {
      if (this.$route.params.id > 0) this.$store.commit("setIsBack", true);
      this.$router.go(-1);
    },

    async LoadClassHistory() {
      if (!this.$route.params.id || this.$route.params.id <= 0) {
        this.classHistoryLogs = [];
        return;
      }
      this.loadingHistoryLogs = true;
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "StudentStaffDataLog/GetHistory?db=" +
            this.$store.state.userData.db +
            "&type=student&localID=" +
            this.$route.params.id,
          token: this.$store.state.userData.token,
        };

        const response = await this.get(obj);
        if (Array.isArray(response)) {
          this.classHistoryLogs = response;
        } else if (response && Array.isArray(response.data)) {
          this.classHistoryLogs = response.data;
        } else {
          this.classHistoryLogs = [];
        }
      } catch (e) {
        this.classHistoryLogs = [];
      } finally {
        this.loadingHistoryLogs = false;
      }
    },
    openAddLogModal() {
      const p = this.prevObj || this.myObj || {};

      const prevSessionID = Number(p.sessionID) || 0;
      const prevSessionObj = (this.allSess || []).find(
        (s) => s.id == prevSessionID
      );
      const prevSession = prevSessionObj ? prevSessionObj.session : "";

      const prevClassID = Number(p.class_current) || 0;
      const prevClassObj = (this.classesOptions || []).find(
        (c) => c.id == prevClassID
      );
      const prevClass = prevClassObj ? prevClassObj.name : "";

      const prevSectionID = Number(p.section_current) || 0;
      const prevSectionObj = (this.allSections || []).find(
        (s) => s.id == prevSectionID
      );
      const prevSection = prevSectionObj ? prevSectionObj.section : "";

      const prevAgeCategory = p.house || "";
      const prevEmpowerLevel = p.last_result || "";

      this.previousLogDetails = {
        sessionID: prevSessionID,
        session: prevSession,
        classID: prevClassID,
        class: prevClass,
        sectionID: prevSectionID,
        section: prevSection,
        agecategory: prevAgeCategory,
        empoweLevel: prevEmpowerLevel,
      };

      this.logForm = {
        sessionID: prevSessionID || null,
        classID: prevClassID || null,
        sectionID: prevSectionID || null,
        agecategory: prevAgeCategory || null,
        empoweLevel: prevEmpowerLevel || null,
      };

      if (this.logForm.classID) {
        this.onLogClassChange(this.logForm.classID);
      } else {
        this.logSectionOptions = this.currentSections || [];
      }

      this.showAddLogModal = true;
    },
    resetLogForm() {
      this.logForm = {
        sessionID: null,
        classID: null,
        sectionID: null,
        agecategory: null,
        empoweLevel: null,
      };
      this.previousLogDetails = null;
      this.logSectionOptions = [];
    },
    onLogClassChange(classID) {
      if (!classID) {
        this.logSectionOptions = [];
        this.logForm.sectionID = null;
        return;
      }
      const matched = (this.classes || []).find(
        (c) => c && c.cls && (c.cls.id == classID || c.cls.name === classID)
      );
      if (matched && Array.isArray(matched.sections)) {
        this.logSectionOptions = matched.sections;
      } else {
        this.logSectionOptions = [];
      }
      if (
        this.logForm.sectionID &&
        !this.logSectionOptions.some((s) => s.id == this.logForm.sectionID)
      ) {
        this.logForm.sectionID = null;
      }
    },
    async saveHistoryLog() {
      if (!this.$route.params.id || this.$route.params.id <= 0) return;

      const newSessionID = Number(this.logForm.sessionID) || 0;
      const newClassID = Number(this.logForm.classID) || 0;
      const newSectionID = Number(this.logForm.sectionID) || 0;

      if (newSessionID <= 0 || newClassID <= 0 || newSectionID <= 0) {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Warning"),
          variant: "warning",
          solid: true,
        });
        return;
      }

      const confirmResult = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t(
          "Saving this log will update the current student details."
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes, Save"),
        cancelButtonText: this.$t("Cancel"),
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      });

      if (!confirmResult.isConfirmed) return;

      this.savingLog = true;
      try {
        const payload = {
          studentID: Number(this.$route.params.id),
          campusID: this.myObj.campusID || this.$store.state.userData.cId,
          sessionID: newSessionID,
          classID: newClassID,
          sectionID: newSectionID,
          agecategory: this.logForm.agecategory || "",
          empoweLevel: this.logForm.empoweLevel || "",
          userID: this.$store.state.userData.userID || 0,
          logCategory: "class change",
        };

        const status = await this.post({
          url: `${this.$store.state.domain}StudentStaffDataLog/LogAndUpdateStudent?db=${this.$store.state.userData.db}`,
          body: payload,
          message: this.$t("Log added successfully."),
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.showAddLogModal = false;
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        }
      } catch (err) {
        console.error("Error saving history log:", err);
      } finally {
        this.savingLog = false;
      }
    },
    getParsedLog(log) {
      if (!log || !log.details) {
        return { changes: [], text: "" };
      }

      try {
        const parsed =
          typeof log.details === "string"
            ? JSON.parse(log.details)
            : log.details;

        const previous = parsed.previous || {};
        const current = parsed.new || {};

        if (typeof previous !== "object" || typeof current !== "object") {
          return {
            changes: [
              {
                label: "",
                from: previous || "—",
                to: current || "—",
                isChanged: previous !== current,
              },
            ],
            text: "",
          };
        }

        const labels = {
          session: "Semester",
          class: "Group",
          section: "Level",
          agecategory: "Age Category",
          empoweLevel: "Empower Level",
        };

        const ignoredKeys = [
          "sessionid",
          "classid",
          "sectionid",
          "campusid",
          "id",
        ];

        const keys = Array.from(
          new Set([...Object.keys(previous), ...Object.keys(current)])
        ).filter((key) => !ignoredKeys.includes(key.toLowerCase()));

        const changes = keys.map((key) => {
          const from = previous[key] || "—";
          const to = current[key] || "—";
          return {
            label: labels[key] || key,
            from,
            to,
            isChanged: from !== to,
          };
        });

        return { changes, text: "" };
      } catch (e) {
        return { changes: [], text: log.details };
      }
    },
    getLogCategoryIcon(cat) {
      if (!cat) return "ActivityIcon";
      const c = cat.toLowerCase();
      if (c.includes("transfer") || c.includes("campus")) return "RepeatIcon";
      if (c.includes("class") || c.includes("grade")) return "BookOpenIcon";
      if (c.includes("section")) return "GridIcon";
      if (c.includes("session") || c.includes("year")) return "CalendarIcon";
      if (c.includes("status")) return "UserCheckIcon";
      if (c.includes("promote") || c.includes("promotion"))
        return "TrendingUpIcon";
      if (c.includes("age") || c.includes("empower")) return "AwardIcon";
      return "FileTextIcon";
    },
    getLogThemeClass(cat, type) {
      const c = (cat || "").toLowerCase();
      let theme = "primary";

      if (c.includes("transfer") || c.includes("campus")) {
        theme = "transfer";
      } else if (c.includes("class") || c.includes("grade")) {
        theme = "class";
      } else if (c.includes("section")) {
        theme = "section";
      } else if (c.includes("session") || c.includes("year")) {
        theme = "session";
      } else if (c.includes("status")) {
        theme = "status";
      } else if (c.includes("promote") || c.includes("promotion")) {
        theme = "promote";
      }

      if (type === "point") return `history-timeline-point--${theme}`;
      if (type === "chip") return `history-category-chip--${theme}`;
      if (type === "pill") return `history-pill--next-${theme}`;
      return "";
    },
    formatCategoryLabel(cat) {
      if (!cat) return "Activity";
      return cat
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(" ");
    },
    formatLogDate(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      return d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },
    getCampusNameById(campusID) {
      if (!campusID) return this.$store.state.userData.campusName || "";
      const campuses = this.$store.state.userData.campuses || [];
      const found = campuses.find(
        (c) => c.id == campusID || c.campusID == campusID
      );
      return found
        ? found.campusName || found.name || found.title
        : `Campus #${campusID}`;
    },
    mapDropdownToOptions(items) {
      if (!Array.isArray(items)) return [];
      return items
        .filter((el) => el.title != null && el.title !== "")
        .map((item) => ({
          text: item.title,
          value: item.title,
          id: item.id,
        }));
    },
    async loadDropdownList(category) {
      var obj = {
        url:
          this.$store.state.domain +
          "DropdownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=" +
          category,
        token: this.$store.state.userData.token,
      };
      const res = await this.get(obj);
      return Array.isArray(res) ? res : [];
    },
    async loadAgeCategories() {
      this.ageCategoryRaw = await this.loadDropdownList("ageCategory");
    },
    async loadEmpowerLevels() {
      this.empowerLevelRaw = await this.loadDropdownList("empowerLevel");
    },
    async loadHappinessDropdowns() {
      await Promise.all([this.loadAgeCategories(), this.loadEmpowerLevels()]);
    },
    async openDropdownModal(category) {
      this.dropdownModalCategory = category;
      this.dropdownModalTitle =
        category === "ageCategory"
          ? this.$t("Manage Age Categories")
          : this.$t("Manage Empower Levels");
      this.dropdownModalVisible = true;
      this.dropdownFormTitle = "";
      this.dropdownModalSearch = "";
      this.dropdownEditingId = null;
      this.dropdownEditingTitle = "";
      await this.refreshDropdownModalItems();
    },
    closeDropdownModal() {
      this.dropdownModalVisible = false;
      this.dropdownModalCategory = "";
      this.dropdownFormTitle = "";
      this.dropdownModalSearch = "";
      this.dropdownEditingId = null;
      this.dropdownEditingTitle = "";
    },
    startEditDropdownItem(item) {
      this.dropdownEditingId = item.id;
      this.dropdownEditingTitle = item.title;
    },
    cancelEditDropdownItem() {
      this.dropdownEditingId = null;
      this.dropdownEditingTitle = "";
    },
    async refreshDropdownModalItems() {
      if (!this.dropdownModalCategory) return;
      this.dropdownLoading = true;
      this.dropdownModalItems = await this.loadDropdownList(
        this.dropdownModalCategory
      );
      if (this.dropdownModalCategory === "ageCategory") {
        this.ageCategoryRaw = this.dropdownModalItems;
      } else if (this.dropdownModalCategory === "empowerLevel") {
        this.empowerLevelRaw = this.dropdownModalItems;
      }
      this.dropdownLoading = false;
    },
    async saveDropdownItem() {
      if (this.dropdownFormTitle.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter a name."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      }
      await this.postDropdownSave(0, this.dropdownFormTitle.trim());
    },
    async saveDropdownEdit() {
      if (this.dropdownEditingTitle.trim() === "") {
        return this.$bvToast.toast(this.$t("Please enter a name."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      }
      const previousTitle = this.dropdownModalItems.find(
        (item) => item.id === this.dropdownEditingId
      );
      const status = await this.postDropdownSave(
        this.dropdownEditingId,
        this.dropdownEditingTitle.trim()
      );
      if (status) {
        if (previousTitle) {
          if (
            this.dropdownModalCategory === "ageCategory" &&
            this.myObj.house === previousTitle.title
          ) {
            this.myObj.house = this.dropdownEditingTitle.trim();
          } else if (
            this.dropdownModalCategory === "empowerLevel" &&
            this.myObj.last_result === previousTitle.title
          ) {
            this.myObj.last_result = this.dropdownEditingTitle.trim();
          }
        }
        this.cancelEditDropdownItem();
      }
    },
    async postDropdownSave(id, title) {
      this.dropdownSaving = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "DropdownList/Save?db=" +
          this.$store.state.userData.db,
        body: {
          id: id || 0,
          title: title,
          typee: this.dropdownModalCategory,
          campusID: this.$store.state.userData.cId,
        },
        message: this.$t(id ? "Updated successfully." : "Added successfully."),
        context: this,
        token: this.$store.state.userData.token,
      });
      this.dropdownSaving = false;
      if (status) {
        this.dropdownFormTitle = "";
        await this.refreshDropdownModalItems();
      }
      return status;
    },

    onDrivePhotoPreviewError(event, url) {
      if (url && String(url).startsWith("blob:")) return;
      handleDrivePreviewError(event, url, "image");
    },
    getFacePicturePreview(url) {
      return url ? getMediaPreviewUrl(url, "Image") : "";
    },

    async LoadFaceData() {
      // var obj = {
      //   url:
      //     this.$store.state.domain +
      //     "students/facepics?db=" +
      //     this.$store.state.userData.db +
      //     "&sID=" +
      //     this.$route.params.id,
      //   token: this.$store.state.userData.token,
      // };
      // let res = await this.get(obj);
      if (this.faceData.length == 0) {
        this.faceData = [
          {
            id: 0,
            sID: this.$route.params.id,
            picture: "",
            campusID: this.$store.state.userData.cId,
          },
          {
            id: 0,
            sID: this.$route.params.id,
            picture: "",
            campusID: this.$store.state.userData.cId,
          },
          {
            id: 0,
            sID: this.$route.params.id,
            picture: "",
            campusID: this.$store.state.userData.cId,
          },
        ];
      }
      // else this.faceData = res;
    },
    async uploadFacePic(event, index) {
      const file = event.target.files[0];
      if (!file) return;

      this.picLoading = true;
      this.picIndex = index;
      try {
        const uploaded = await uploadToMySkool([file]);
        this.faceData[index].picture = getUploadPath(uploaded[0]);
        this.saveFacePic(index);
      } catch (err) {
        console.log(err);
      } finally {
        this.picLoading = false;
        this.picIndex = 0;
      }
    },
    async saveFacePic(index) {
      // Save to server
      console.log(this.faceData[index]);
      // const status = await this.post({
      //   url: `${this.$store.state.domain}StudentFaces/Save`,
      //   body: this.faceData[index],
      //   message: "Face image uploaded successfully.",
      //   context: this,
      //   token: this.$store.state.userData.token,
      // });

      // if (status) {
      //   // Optionally refresh face data
      //   this.loadFaceData();
      // }
    },
    removeFace(index) {
      // if (this.faceData[index].id > 0) {
      //   // Delete from server if exists
      //   this.delete({
      //     url: `${this.$store.state.domain}StudentFaces/${this.faceData[index].id}`,
      //     message: "Face image removed successfully.",
      //     context: this,
      //     token: this.$store.state.userData.token,
      //   });
      // }
      this.faceData[index].picture = "";
      this.faceData[index].id = 0;
    },

    async LoadStdEnrollment() {
      var obj = {
        url:
          this.$store.state.domain +
          "Students/LoadClassEnrollment?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          this.$store.state.userData.cId +
          "&sID=" +
          this.$route.params.id,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      // console.log(res);
      this.enrollList = res.map(({ us, ...rest }) => ({
        ...rest,
        ...us,
      }));

      // console.log(this.enrollList);
    },
    async LoadEnSelection() {
      var obj = {
        url:
          this.$store.state.domain +
          "TeacherClasses/LoadDropdown?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.enrollOptions = await this.get(obj);
      // console.log(this.enrollOptions);
    },
    dropFilter(opt, label, search) {
      // console.log(opt, label, search);
      let st = search.toLowerCase();
      return (
        opt.clsName.toLowerCase().match(st) ||
        opt.secName.toLowerCase().match(st) ||
        opt.subName.toLowerCase().match(st) ||
        opt.name.toLowerCase().match(st)
      );
    },
    isEnSelectedNew(obj) {
      return this.enrollList.some(
        (el) =>
          el.classID === obj.us.cID &&
          el.secID === obj.us.section &&
          el.subID === obj.us.subID &&
          el.tID === obj.us.tID
      );
    },
    selectEnrollment() {
      // console.log(this.selectedEnroll);
      if (this.selectedEnroll) {
        this.enrollList.push({
          id: 0,
          sID: parseInt(this.$route.params.id),
          classID: this.selectedEnroll.us.cID,
          secID: this.selectedEnroll.us.section,
          tID: this.selectedEnroll.us.tID,
          subID: this.selectedEnroll.us.subID,
          sessionID: 0,
          isExcluded: false,
          campusID: this.$store.state.userData.cId,
          clsName: this.selectedEnroll.clsName,
          secName: this.selectedEnroll.secName,
          subName: this.selectedEnroll.subName,
          name: this.selectedEnroll.name,
        });
      }
      this.selectedEnroll = null;
    },
    async removeEnroll(item, ind) {
      if (item.id == 0) {
        this.enrollList.splice(ind, 1);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "ClasswiseSubjectsEnrollment/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.enrollList.splice(ind, 1);
        }
      }
    },
    LoadEnSections(item, reset) {
      if (item.classID) {
        item.sectionList = [];
        if (reset) {
          item.secID = 0;
          item.subID = 0;
          item.tID = 0;
          item.subjectList = [];
          item.teacherList = [];
        }

        let cls = this.classes.find((el) => el.cls.id === item.classID);
        if (cls) {
          item.sectionList = cls.sections;
        }
      }
    },
    async LoadSubjectByClass(item, reset) {
      if (item.classID && item.secID) {
        item.subjectList = [];
        if (reset) {
          item.subID = 0;
          item.tID = 0;
          item.teacherList = [];
        }

        this.subLoading = true;
        let myitem = await this.get({
          url:
            this.$store.state.domain +
            "TeacherClasses/LoadSubjectByClass?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&classID=" +
            item.classID +
            "&secID=" +
            item.secID,
          token: this.$store.state.userData.token,
        });
        this.subLoading = false;
        item.subjectList = myitem;
      }
    },
    async LoadTeachers(item, reset) {
      if (item.classID && item.secID && item.subID) {
        item.teacherList = [];
        if (reset) {
          item.tID = 0;
        }

        this.teacherLoading = true;
        let myitem = await this.get({
          url:
            this.$store.state.domain +
            "TeacherClasses/LoadTeachers?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&classID=" +
            item.classID +
            "&secID=" +
            item.secID +
            "&subID=" +
            item.subID,
          token: this.$store.state.userData.token,
        });
        this.teacherLoading = false;
        item.teacherList = myitem;
      }
    },
    isEnSelected(id, classID, secID) {
      return this.enrolledData.some(
        (el) => el.subID === id && el.classID === classID && el.secID === secID
      );
    },
    AddEnItem() {
      this.enrolledData.push({
        id: 0,
        sID: parseInt(this.$route.params.id),
        classID: 0,
        secID: 0,
        tID: 0,
        subID: 0,
        sessionID: 0,
        isExcluded: false,
        campusID: this.$store.state.userData.cId,
        sectionList: [],
        subjectList: [],
        teacherList: [],
      });
    },
    async removeEnItem(item, ind) {
      if (item.id == 0) {
        this.enrolledData.splice(ind, 1);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "ClasswiseSubjectsEnrollment/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.enrolledData.splice(ind, 1);
        }
      }
    },

    async LoadStaff() {
      let myitem = await this.get({
        url:
          this.$store.state.domain +
          "Subjects/LoadTeacherBySubjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&subjectID=0",
        token: this.$store.state.userData.token,
      });
      this.staffList = myitem;
    },
    isSelectedItem(id) {
      return this.subjectData.some((el) => el.subID === id);
    },
    allowSubs(item, ind) {
      if (item.subID > 0) {
        item.tID = 0;
        let subName =
          this.allSubjects.find((el) => el.id == item.subID)?.subject || "";
        item.subName = subName;
      }
    },
    AddSub() {
      this.subjectData.push({
        id: 0,
        sID: parseInt(this.$route.params.id),
        subID: 0,
        tID: 0,
        subjectFee: 0,
        teacherShareAmount: 0,
        subName: "",
        campusID: this.$store.state.userData.cId,
        isExcluded: false,
      });
    },
    async removeSub(item, ind) {
      if (item.id == 0) {
        this.subjectData.splice(ind, 1);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "StudentSubjectsEnrollnment/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.subjectData.splice(ind, 1);
        }
      }
    },

    changeDay() {
      this.currDays = this.timingInfo.reduce((acc, el) => {
        acc.push(el.day);
        return acc;
      }, []);
      // console.log(this.currDays);
    },
    setDays(item) {
      this.$store.commit("setSameTimings", this.sameDays);

      this.$nextTick(() => {
        // console.log(item.timeOut);
        if (
          this.timingInfo.length == 1 &&
          this.sameDays &&
          item.day == "monday" &&
          item.timeIn &&
          item.timeOut
        ) {
          // console.log(item);
          let days = ["tuesday", "wednesday", "thursday", "friday", "saturday"];
          let data = [item];
          days.forEach((el) => {
            data.push({
              id: 0,
              sID: this.$route.params.id,
              day: el,
              timeIn: item.timeIn,
              timeOut: item.timeOut,
              campusID: this.$store.state.userData.cId,
            });
          });
          this.timingInfo = data;
          this.changeDay();
        }
      });
    },
    addDay() {
      this.timingInfo.push({
        id: 0,
        sID: this.$route.params.id,
        day: "",
        timeIn: "",
        timeOut: "",
        campusID: this.$store.state.userData.cId,
      });
      // console.log(this.timingInfo);
    },
    async removeDay(item, ind) {
      if (item.id == 0) {
        this.timingInfo.splice(ind, 1);
        // console.log(this.timingInfo);
        this.currDays = this.currDays.filter((el) => el != item.day);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "studentTimings/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.timingInfo.splice(ind, 1);
          this.currDays = this.currDays.filter((el) => el != item.day);
        }
        // console.log(this.timingInfo);
      }
    },
    CheckTimings() {
      let state = true;
      this.timingInfo = this.timingInfo.filter(
        (el) => el.day != "" && el.timeIn != "" && el.timeOut != ""
      );
      this.timingInfo.forEach((el) => {
        if (!el.timeIn || !el.timeOut) {
          state = false;
        }
      });
      // console.log(state);
      return state;
    },
    async saveTimings() {
      if (this.CheckTimings() == true) {
        this.savingTime = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "studentTimings/SaveData?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.timingInfo,
          message: "Timings saved successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.savingTime = false;
        if (status) {
          this.LoadTimings();
        }
      } else {
        this.$bvToast.toast(this.$t("Please enter the timings correctly!"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      }
    },

    openFile(url) {
      window.open(url, "_blank");
    },
    showSyncedDetails(details, id) {
      if (!details) {
        this.$bvToast.toast(this.$t("No synchronization details found."), {
          title: this.$t("Wait!"),
          variant: "warning",
          solid: true,
        });
        return;
      }
      this.selectedSyncedStudentID = id;

      if (typeof details === "string") {
        try {
          this.selectedSyncedDetails = JSON.parse(details);
        } catch (e) {
          this.selectedSyncedDetails = null;
        }
      } else {
        this.selectedSyncedDetails = details;
      }
      this.showSyncedModal = true;
    },

    numberToWords(number) {
      const words = [
        "Zero",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];
      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      if (number < 20) return words[number];
      if (number < 100)
        return (
          tens[Math.floor(number / 10)] +
          (number % 10 === 0 ? "" : " " + words[number % 10])
        );
      if (number < 1000)
        return (
          this.numberToWords(Math.floor(number / 100)) +
          " Hundred" +
          (number % 100 === 0 ? "" : " and " + this.numberToWords(number % 100))
        );

      // For this specific use case, we assume the year is always in the 2000s
      return (
        "Two Thousand" +
        (number % 1000 !== 0 ? " " + this.numberToWords(number % 1000) : "")
      );
    },
    formatDate() {
      if (this.myObj.date_of_birth) {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        const dayNames = [
          "",
          "First",
          "Second",
          "Third",
          "Fourth",
          "Fifth",
          "Sixth",
          "Seventh",
          "Eighth",
          "Ninth",
          "Tenth",
          "Eleventh",
          "Twelfth",
          "Thirteenth",
          "Fourteenth",
          "Fifteenth",
          "Sixteenth",
          "Seventeenth",
          "Eighteenth",
          "Nineteenth",
          "Twentieth",
          "Twenty First",
          "Twenty Second",
          "Twenty Third",
          "Twenty Fourth",
          "Twenty Fifth",
          "Twenty Sixth",
          "Twenty Seventh",
          "Twenty Eighth",
          "Twenty Ninth",
          "Thirtieth",
          "Thirty First",
        ];

        const [yearStr, monthStr, dayStr] = this.myObj.date_of_birth.split("-");
        const day = parseInt(dayStr, 10);
        const year = parseInt(yearStr, 10);
        const monthIndex = parseInt(monthStr, 10) - 1;

        this.myObj.date_of_birth_words = `${dayNames[day]} ${
          months[monthIndex]
        } ${this.numberToWords(year)}`;
      }
    },

    printAdmit(val) {
      if (this.myObj.id > 0) {
        let dt = new Date().toJSON().split("T")[0];
        if (this.reportDomain == "myskoolhpgs") {
          let testDt = "";
          let testtm = "";
          if (this.admObj.testDate) {
            testDt = new Date(this.admObj.testDate).toLocaleDateString(
              "en-UK",
              {
                year: "numeric",
                day: "numeric",
                month: "short",
              }
            );
            testtm = new Intl.DateTimeFormat("en-US", {
              hour: "numeric",
              minute: "numeric",
            }).format(new Date(this.admObj.testDate));
          }

          let url =
            `https://${this.reportDomain}.myskool.app/Certificate/ShowAdmit?type=${val}` +
            "&dbb=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&sID=" +
            this.myObj.id +
            "&exam=Admission Test&session=&date=" +
            dt +
            "&tDate=" +
            testDt +
            "&tTime=" +
            testtm;

          window.open(url, "_blank");
        } else {
          let url =
            `https://${this.reportDomain}.myskool.app/Certificate/Show?type=${val}` +
            "&dbb=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&sID=" +
            this.myObj.id +
            "&exam=Admission Test&session=&date=" +
            dt;

          window.open(url, "_blank");
        }
      }
    },
    setMsg() {
      this.$store.commit("setAddMsg", this.addingMsg);
    },

    handleEvent(event) {
      // console.log(event.key);
      if (event.ctrlKey && event.keyCode === 83) {
        event.preventDefault();
        if (this.check == 1) {
          this.check = 0;
          // console.log(this.check);
          this.shortcutSubmit();
        }
      }
    },
    setSameFields(field) {
      if (this.selected === "add" || this.selected === "reg") {
        if (field == "date" && this.settings.sameDate) {
          this.myObj.date_of_admission = this.myObj.date_of_registraion;
        } else if (field == "class" && this.settings.sameClass) {
          this.myObj.class_current = this.myObj.class_admitted;
          this.FillSectionsCurrent("select");
        } else if (field == "section" && this.settings.sameSec) {
          let sec = this.currentSections.find(
            (el) => el.id == this.myObj.section_admitted
          );
          if (sec) {
            this.myObj.section_current = this.myObj.section_admitted;
          }
        }
      }
    },
    async saveSettings() {
      // console.log(this.settings);
      this.$store.commit("setStdSetting", this.settings);
      this.visibility1 = false;
      // this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //      title: this.$t("Notification"),
      //     icon: "CheckIcon",
      //     text: "Settings saved successfully!",
      //     variant: "success",
      //   },
      // });
    },
    async LoadTimings() {
      this.timeLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "studentTimings/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&sID=" +
          this.$route.params.id,
        token: this.$store.state.userData.token,
      };
      this.timingInfo = await this.get(obj);
      this.timeLoading = false;

      if (this.timingInfo.length == 0) {
        this.timingInfo = [
          {
            id: 0,
            sID: this.$route.params.id,
            day: "monday",
            timeIn: "",
            timeOut: "",
            campusID: this.$store.state.userData.cId,
          },
        ];
      }
      this.changeDay();
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },
    async LoadSubGroups() {
      var obj = {
        url:
          this.$store.state.domain +
          "SubjectGroups/LoadData?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.subjectGroups = await this.get(obj);
    },
    setSubByGroup() {
      // console.log(this.selectedGroup);

      if (!this.subjectData || this.subjectData.length == 0) {
        this.subjectData = this.allSubjects.map((el) => {
          return {
            id: 0,
            sID: this.$route.params.id,
            subID: el.id,
            subName: el.subject,
            isExcluded: !this.selectedGroup.subSubjects.includes(el.id),
            campusID: this.$store.state.userData.cId,
          };
        });
      } else {
        this.subjectData = this.subjectData.map((el) => {
          return {
            ...el,
            subName: this.getSubjectName(el.subID) || el.subName,
            isExcluded: !this.selectedGroup.subSubjects.includes(el.subID),
          };
        });
      }
    },
    getSubjectName(id) {
      return this.allSubjects.find((el) => el.id == id)?.subject || "";
    },
    async loadSubjects() {
      var obj2 = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.allSubjects = await this.get(obj2);
      // console.log(this.allSubjects);
      if (this.$route.params.id == 0) this.setSubs();
    },
    setSubs() {
      this.subjectData = this.allSubjects.map((el) => {
        return {
          id: 0,
          sID: this.$route.params.id,
          subID: el.id,
          subName: el.subject,
          isExcluded: false,
          campusID: this.$store.state.userData.cId,
        };
      });
      // console.log(this.subjectData);
      this.sortSubjects();
    },
    sortSubjects() {
      if (!this.subjectData || !this.subjectData.length) return;
      this.subjectData.sort((a, b) =>
        String(a.subName || "").localeCompare(
          String(b.subName || ""),
          undefined,
          {
            numeric: true,
            sensitivity: "base",
          }
        )
      );
    },
    async LoadSession() {
      var obj2 = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.allSess = await this.get(obj2);
      // console.log("Session", this.allSess);
      if (this.selected == "add" || this.selected == "reg") {
        let obj = this.allSess.find((el) => el.isCurrentSession == true);
        if (this.showHappinessTab) {
          obj = this.allSess.find((el) => el.status == "active");
        }
        if (!obj) this.myObj.sessionID = 0;
        else this.myObj.sessionID = obj.id;
      }
    },
    openSession() {
      this.accIcon = "PlusIcon";
      this.sessionbar = true;

      this.sessionObj = {
        id: 0,
        session: "",
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["sess_name"];
      elem.state = undefined;
    },
    SessName() {
      var elem = this.$refs["sess_name"];
      if (this.sessionObj.session.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async setCurrentSess(id) {
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Sessions/SetCurrentSession?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&sessionID=" +
          id,
        body: this.sessionObj,
        message: "Session marked as current",
        context: this,
        token: this.$store.state.userData.token,
      });

      if (status) {
        this.LoadSession();
      }
    },
    async saveSession() {
      if (this.SessName() == true) {
        this.savingacc = true;
        if (this.sessionObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Sessions?db=" +
              this.$store.state.userData.db,
            body: this.sessionObj,
            message: "Session added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "Sessions/" +
              this.sessionObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Session updated successfully.",
            context: this,
            body: this.sessionObj,
            token: this.$store.state.userData.token,
          });
        }
        this.savingacc = false;
        if (status) {
          this.LoadSession();
          var elem = this.$refs["sess_name"];
          elem.state = undefined;
          this.sessionObj = {
            id: 0,
            session: "",
            campusID: this.$store.state.userData.cId,
          };
        }
      }
    },
    async editSess(item) {
      this.sessionObj = { ...item };
      this.accIcon = "Edit2Icon";
      var elem = this.$refs["sess_name"];
      elem.state = undefined;
      // console.log(this.sessionObj);
    },
    async deleteSess(item) {
      // console.log(acc);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Sessions/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Session removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadSession();
      }
    },

    openDSett() {
      if (this.disSetting) {
        this.dCopy = { ...this.disSetting };
      } else {
        this.dCopy = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "discount_ref",
          value: "discount_ref",
          valueBool: false,
          valueNumber: null,
        };
      }
      this.visibility3 = true;
    },
    async saveDSett() {
      this.savingSett = true;
      var status = await this.post({
        url:
          this.$store.state.domain +
          "Settings/SaveNew?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [this.dCopy],
        message: "Settings saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.savingSett = false;
      if (status) {
        this.LoadSettingsAll();
        this.visibility3 = false;
      }
    },

    async LoadDis(text) {
      var obj2 = {
        url:
          this.$store.state.domain +
          "DiscountReference?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.disData = await this.get(obj2);
      if (text == "filled" && this.$route.params.id > 0) {
        if (this.myObj.discountReferenceID > 0) {
          let obj = this.disData.find(
            (el) => el.id == this.myObj.discountReferenceID
          );
          if (obj) {
            if (obj.discountType == "fixed") this.disableDiscount = true;
            else this.disableDiscount = false;
          }
        } else this.disableDiscount = false;
      }
      if (this.$route.params.id == 0) {
        this.applyAbaHouseFromDiscount();
      }
    },
    openDis() {
      this.visibility2 = true;

      this.disObj = {
        id: 0,
        name: "",
        calculatedBy: "amount",
        discountType: "fixed",
        amount: 0,
        percentage: 0,
        campusID: this.$store.state.userData.cId,
      };
      var elem = this.$refs["d_name"];
      elem.state = undefined;
      // var elem = this.$refs["d_amount"];
      // elem.state = undefined;
    },
    CheckDName() {
      var elem = this.$refs["d_name"];
      if (this.disObj.name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDAmount() {
      // only on setting based
      const setting = this.disSetting && this.disSetting.valueBool;
      if (this.disObj.calculatedBy == "amount" && setting) {
        var elem = this.$refs["d_amount"];
        let x = parseInt(this.disObj.amount);
        if (isNaN(x) || x <= 0) {
          return (elem.state = false);
        } else {
          this.disObj.amount = x;
          this.disObj.percentage = 0;
          return (elem.state = true);
        }
      } else return true;
    },
    CheckDPerc() {
      const setting = this.disSetting && this.disSetting.valueBool;
      if (this.disObj.calculatedBy == "percentage" && setting) {
        var elem = this.$refs["d_perc"];
        let x = parseFloat(this.disObj.percentage);
        if (isNaN(x) || x <= 0 || x > 100) {
          return (elem.state = false);
        } else {
          this.disObj.percentage = x;
          this.disObjamount = 0;
          return (elem.state = true);
        }
      } else return true;
    },
    async saveDis() {
      this.CheckDName();
      this.CheckDAmount();
      this.CheckDPerc();
      if (
        this.CheckDName() == true &&
        this.CheckDAmount() == true &&
        this.CheckDPerc() == true
      ) {
        // console.log(this.disObj);
        this.savingDis = true;
        if (this.disObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "DiscountReference?db=" +
              this.$store.state.userData.db,
            body: this.disObj,
            message: "Discount Reference added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "DiscountReference/" +
              this.disObj.id +
              "?db=" +
              this.$store.state.userData.db,
            message: "Discount Reference updated successfully.",
            context: this,
            body: this.disObj,
            token: this.$store.state.userData.token,
          });
        }
        this.savingDis = false;
        if (status) {
          this.LoadDis();

          this.disObj = {
            id: 0,
            name: "",
            calculatedBy: "amount",
            discountType: "fixed",
            amount: 0,
            percentage: 0,
            campusID: this.$store.state.userData.cId,
          };
          var elem = this.$refs["d_name"];
          elem.state = undefined;
          var elem = this.$refs["d_amount"];
          elem.state = undefined;
        }
      }
    },
    async editDis(item) {
      this.disObj = { ...item };
      var elem = this.$refs["d_name"];
      elem.state = undefined;
    },
    async deleteDis(id) {
      // console.log(acc);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "DiscountReference/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          message: "Discount Reference removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadDis();
      }
    },
    applyAbaHouseFromDiscount() {
      if (
        this.reportDomain === "myskoolaba" &&
        !this.myObj.discountReferenceID
      ) {
        this.myObj.house = "FULL FEE";
      }
    },
    setDiscount() {
      // only on setting based
      if (this.disSetting && this.disSetting.valueBool) {
        if (this.myObj.discountReferenceID > 0) {
          let obj = this.disData.find(
            (el) => el.id == this.myObj.discountReferenceID
          );
          if (obj) {
            if (obj.discountType == "fixed") this.disableDiscount = true;
            else this.disableDiscount = false;
            if (obj.calculatedBy == "amount") this.myObj.discount = obj.amount;
            else {
              this.myObj.discount = parseInt(
                (obj.percentage / 100) * this.myObj.classFee
              );
            }
          }
        } else this.disableDiscount = false;
      }
      this.applyAbaHouseFromDiscount();
    },
    checkDis() {
      var elem = this.$refs["dis"];
      let x = parseInt(this.myObj.discount);
      // || x > this.myObj.classFee
      if (isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        this.myObj.discount = x;
        return (elem.state = true);
      }
    },
    setFee() {
      if (this.checkDis() == true) {
        let res = this.myObj.classFee - this.myObj.discount;
        this.myObj.monthly_fee = res < 0 ? 0 : res;
      }
    },

    async loadFeeType() {
      this.feeLoading = true;
      this.FeeTypes = [];
      var obj = {
        url:
          this.$store.state.domain +
          "FeeType/LoadAll?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.FeeTypes = await this.get(obj);
      this.feeLoading = false;

      // do not filter default for custom fee domains
      if (!this.customFeeDomains.includes(this.reportDomain)) {
        this.FeeTypes = this.FeeTypes.filter(
          (el) => el.recurrence != "default"
        );
      }

      // Set up customObj with specific fee types in order: Admission Fee, Monthly, Quarterly, Semester
      // on admission
      if (
        this.$route.params.id == 0 &&
        this.selected === "add" &&
        this.customFeeDomains.includes(this.reportDomain)
      ) {
        // Initialize empty customObj if needed
        this.customObj = [];
        this.setCustomFee();
        // console.log(this.customObj);
      }

      // on edit
      if (this.$route.params.id > 0) {
        // if no custom fee
        if (!this.customObj || this.customObj.length == 0) {
          if (
            (this.$route.params.readmit == true ||
              this.$route.params.readmit == "true") &&
            this.myObj.status.toLowerCase() == "registered" &&
            this.customFeeDomains.includes(this.reportDomain)
          ) {
            // console.log("confirm admission");
            this.customObj = [];
            this.setCustomFee();
          } else if (
            this.customFeeDomains.includes(this.reportDomain) &&
            this.myObj.status.toLowerCase() == "present"
          ) {
            // console.log("present");
            this.customObj = [];
            this.setCustomFee();
          } else {
            // console.log("normal");
            this.customObj = [
              {
                id: 0,
                sID: this.$route.params.id,
                feeTypeID: 0,
                amount: 0,
                baseFee: 0,
                discount: 0,
                campusID: this.$store.state.userData.cId,
              },
            ];
          }
        } else {
          this.changeOptions();
          this.setBaseFee();
        }
        // console.log(this.customObj);
      }
    },
    setCustomFee() {
      const studentId = this.$route.params.id;

      // Add fees in the required order
      this.addFeesToCustomObj("name", "admission fee", studentId);
      this.addFeesToCustomObj("recurrence", "default", studentId);
      this.addFeesToCustomObj("recurrence", "quarterly", studentId);
      this.addFeesToCustomObj("recurrence", "semester", studentId);

      // Update feeIds for tracking
      this.changeOptions();
    },
    // Generic function to add fees based on filter criteria
    addFeesToCustomObj(filterType, filterValue, studentId) {
      // console.log(filterType, filterValue, studentId);

      const fees = this.FeeTypes.filter((fee) => {
        if (filterType === "name") {
          return fee.feeType.toLowerCase() === filterValue.toLowerCase();
        } else if (filterType === "recurrence") {
          return fee.recurrence === filterValue;
        }
        return false;
      });

      fees.forEach((fee) => {
        this.customObj.push({
          id: 0,
          sID: studentId || this.$route.params.id,
          feeTypeID: fee.id,
          baseFee: fee.defaultAmount || 0,
          discount: 0,
          amount: fee.defaultAmount || 0,
          campusID: this.$store.state.userData.cId,
        });
      });
    },

    changeOptions() {
      this.feeIds = this.customObj.reduce((acc, el) => {
        acc.push(el.feeTypeID);
        return acc;
      }, []);
      // console.log(this.feeIds);
    },
    async loadBaseFee(item, val) {
      let res = await this.get({
        url:
          this.$store.state.domain +
          "FeeType/loadselectedclass?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&feeTypeID=" +
          item.feeTypeID +
          "&clsID=" +
          this.myObj.class_current,
        token: this.$store.state.userData.token,
        context: this,
      });
      if (val) {
        item.baseFee = res ? res.amount || 0 : 0;
      }
      return res;
    },
    async UpdateTaxBaseFee() {
      this.customObj.forEach(async (el, ind) => {
        if (this.isTaxFee(el.feeTypeID)) {
          el.baseFee = this.myObj.monthly_fee || 0;
          this.calculateAmount(ind);
        }
      });
    },
    async setBaseFee() {
      this.customObj.forEach(async (el, ind) => {
        if (el.feeTypeID) {
          const response = await this.loadBaseFee(el, false);
          el.baseFee = response ? response.amount || 0 : 0;

          // use monthly fee if tax fee
          if (this.isTaxFee(el.feeTypeID)) {
            el.baseFee = this.myObj.monthly_fee || 0;
            el.taxPercentage = this.taxSetting.valueNumber;
            this.calculateAmount(ind);
          }
        } else {
          el.baseFee = 0;
        }
      });
    },
    async changeFeeType(ind) {
      const item = this.customObj[ind];
      if (item.feeTypeID) {
        // Get base fee for selected fee type
        let response = null;
        if (this.myObj.class_current) {
          this.feeLoading = true;
          response = await this.loadBaseFee(item, false);
          this.feeLoading = false;
          // console.log(response);
        }

        item.baseFee = response ? response.amount || 0 : 0;

        // use monthly fee if tax fee
        if (this.isTaxFee(item.feeTypeID)) {
          item.baseFee = this.myObj.monthly_fee || 0;
          item.taxPercentage = this.taxSetting.valueNumber;
        }

        this.calculateAmount(ind);
      }
      this.changeOptions(); // Keep existing fee type tracking
    },
    calculateAmount(ind) {
      const item = this.customObj[ind];
      if (item.baseFee) {
        // Check if this is a tax fee then tax amount
        if (this.isTaxFee(item.feeTypeID)) {
          let x = parseFloat(item.taxPercentage);
          if (isNaN(x) || x < 0 || x > 100) {
            x = 0;
          }
          const taxAmount = (item.baseFee * x) / 100;
          item.amount = parseInt(taxAmount);
        } else {
          // Only calculate amount if discount is valid
          const discount = this.checkCustomDiscount(item.discount, ind)
            ? parseFloat(item.discount)
            : 0;

          // Calculate amount after discount
          item.amount = item.baseFee - (item.baseFee * discount) / 100;
        }
      }
    },
    checkCustomDiscount(val, ind) {
      const discount = parseFloat(val);
      if (isNaN(discount) || discount < 0 || discount > 100) {
        return false;
      }
      return true;
    },
    AddValue() {
      this.customObj.push({
        id: 0,
        sID: this.$route.params.id,
        feeTypeID: 0,
        baseFee: 0,
        discount: 0,
        amount: 0,
        taxPercentage: 0,
        campusID: this.$store.state.userData.cId,
      });
      // console.log(this.customObj);
    },
    async removeValue(item, ind) {
      if (item.id == 0) {
        this.customObj.splice(ind, 1);
        this.feeIds = this.feeIds.filter((el) => el != item.feeTypeID);
        // console.log(this.feeIds,this.customObj);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "StudentsCustomFee/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.customObj.splice(ind, 1);
          this.feeIds = this.feeIds.filter((el) => el != item.feeTypeID);
        }
        // console.log(this.customObj);
      }
    },
    CheckValues() {
      let state = true;
      this.customObj = this.customObj.filter((el) => el.feeTypeID != 0);
      this.customObj.forEach((el) => {
        el.sID = parseInt(el.sID);
        el.amount = parseInt(el.amount);
        if (el.feeTypeID !== 0 && (isNaN(el.amount) || el.amount < 0)) {
          state = false;
        }
      });
      return state;
    },

    showSidebar() {
      this.visibility = true;
    },
    hideSideBar() {
      this.visibility = false;
    },
    onRowSelected(row, val) {
      // console.log(row, val);
      let std = {};
      if (row) std = row[0];
      else std = val;
      this.myObj.family_code = std.family_code;

      this.myObj.contact_father = std.contact_father;
      this.myObj.father_cnic = std.father_cnic;
      this.myObj.father_education = std.father_education;
      this.myObj.father_email = std.father_email;
      this.myObj.father_employer = std.father_employer;
      this.myObj.father_name = std.father_name;
      this.myObj.father_occupation = std.father_occupation;
      this.myObj.office_address = std.office_address;
      this.myObj.office_phone = std.office_phone;
      this.myObj.monthly_income = std.monthly_income;

      this.myObj.guardian_cnic = std.guardian_cnic;
      this.myObj.guardian_education = std.guardian_education;
      this.myObj.guardian_email = std.guardian_email;
      this.myObj.guardian_employer = std.guardian_employer;
      this.myObj.guardian_name = std.guardian_name;
      this.myObj.guardian_occupation = std.guardian_occupation;
      this.myObj.guardian_office_address = std.guardian_office_address;
      this.myObj.guardian_office_phone = std.guardian_office_phone;
      this.myObj.guardian_relationship = std.guardian_relationship;

      this.myObj.contact_mother = std.contact_mother;
      this.myObj.mother_cnic = std.mother_cnic;
      this.myObj.mother_education = std.mother_education;
      this.myObj.mother_email = std.mother_email;
      this.myObj.mother_employer = std.mother_employer;
      this.myObj.mother_name = std.mother_name;
      this.myObj.mother_occupation = std.mother_occupation;
      this.myObj.mother_office_address = std.mother_office_address;
      this.myObj.mother_office_phone = std.mother_office_phone;

      this.myObj.emergency_contact = std.emergency_contact;
      this.myObj.emergency_name = std.emergency_name;
      this.myObj.emergency_relationship = std.emergency_relationship;

      this.myObj.address_permanent = std.address_permanent;
      this.myObj.address_current = std.address_current;

      // console.log(this.myObj);
      this.visibility = false;
    },
    async searchByFamily() {
      if (
        (this.selected == "add" || this.$route.params.id > 0) &&
        this.myObj.family_code != null &&
        this.myObj.family_code != ""
      ) {
        // console.log(this.myObj.family_code);
        let myitem = await this.get({
          url:
            this.$store.state.domain +
            "Students/LoadFamilyData?fCode=" +
            this.myObj.family_code +
            "&campusId=" +
            this.$store.state.userData.cId +
            "&db=" +
            this.$store.state.userData.db,
          token: this.$store.state.userData.token,
        });
        // console.log("data", myitem);
        if (myitem) this.onRowSelected(null, myitem);
        // else console.log("not found");
      }
    },
    async loadSearch() {
      //  this.items =[];
      this.studentLoading = true;
      let myitem = await this.get({
        url:
          this.$store.state.domain +
          "Students/SearchFamilies?keyword=" +
          this.searchQuery +
          "&campusId=" +
          this.$store.state.userData.cId +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      });
      this.studentData = myitem;
      // console.log("stud", this.studentData);
      this.studentLoading = false;
    },

    async uploadDocument(e) {
      let docs = this.$refs.studentdocs.files;
      if (docs.length != 0) {
        this.uploading = true;
        try {
          const uploaded = await uploadToMySkool(docs);
          getUploadedPaths(uploaded).forEach((path) => {
            this.documents.push(path);
          });
          this.myObj.docs = this.documents.join(",");
        } catch (err) {
          console.error(err);
        } finally {
          this.uploading = false;
        }
      }
    },
    deleteDocument(index) {
      // console.log(index);
      this.documents.splice(index, 1);
      this.myObj.docs = this.documents.join(",");
      // console.log(this.myObj.docs);
    },
    async selectDoc(item, ind) {
      let obj = this.$refs["doc" + ind][0].files;

      if (obj.length > 0) {
        this.currentIndex = ind;
        this.docLoading = true;
        try {
          const uploaded = await uploadToMySkool([obj[0]]);
          item.url = getUploadPath(uploaded[0]);
        } catch (err) {
          console.log(err);
        } finally {
          this.docLoading = false;
        }
      }
    },
    async shortcutSubmit(val) {
      if (this.showHappinessTab && this.selected === "reg") {
        this.myObj.date_of_registraion = new Date().toJSON();
        // console.log("regClass", this.regClass, this.regSection);
        if (this.regClass == 0) {
          let firstCls = this.classes[0];
          this.regClass = firstCls?.cls?.id || 0;
          this.regSection = firstCls?.sections[0]?.id || 0;
        }

        this.myObj.class_admitted = this.regClass;
        this.myObj.section_admitted = this.regSection;
        this.myObj.class_current = this.regClass;
        this.myObj.section_current = this.regSection;
      }
      // console.log(val);
      // console.log("obj", this.myObj);
      this.check = 0; // due to save button click
      this.CheckName();
      this.CheckFName();
      // this.CheckDob();
      this.CheckClassAdmit();
      this.CheckClassCurrent();
      this.CheckCurrentSec();
      this.CheckAdmitSec();
      this.CheckGrNo();
      await this.CheckFees();
      this.CheckBForm();
      this.CheckReceipt();
      this.CheckTimelyDis();

      const classLabel = this.showHappinessTab ? "group" : "class";
      const sectionLabel = this.showHappinessTab ? "level" : "section";

      if (this.CheckName() == false) {
        this.$bvToast.toast(this.$t("Please enter the name"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckFName() == false) {
        this.$bvToast.toast(this.$t("Please enter the father name"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckGrNo() == false) {
        this.$bvToast.toast(this.$t("Please enter the gr number"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckClassAdmit() == false) {
        this.$bvToast.toast(this.$t(`Please enter ${classLabel} (admitted)`), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckAdmitSec() == false) {
        this.$bvToast.toast(
          this.$t(`Please enter ${sectionLabel} (admitted)`),
          {
            title: this.$t("Error!"),
            variant: "danger",
            solid: true,
          }
        );
        this.check = 1;
      } else if (this.CheckClassCurrent() == false) {
        this.$bvToast.toast(this.$t(`Please enter ${classLabel} (current)`), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckCurrentSec() == false) {
        this.$bvToast.toast(this.$t(`Please enter ${sectionLabel} (current)`), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if ((await this.CheckFees()) == false) {
        this.$bvToast.toast(this.$t("Please enter the monthly fees"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckDiscount() == false) {
        this.$bvToast.toast(this.$t("Invalid discount entered"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckBForm() == false) {
        this.$bvToast.toast(this.$t("Please enter the B-Form number"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckGrLocal() == false) {
        this.$bvToast.toast(this.$t(`Please enter the ${this.schGr.value}`), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckReceipt() == false) {
        this.$bvToast.toast(this.$t("Please enter the receipt number"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckTimelyDis() == false) {
        this.$bvToast.toast(this.$t("Invalid timely discount entered"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.CheckValues() == false) {
        this.$bvToast.toast(this.$t("Invalid custom fee entered"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (this.fphoneerror || this.mphoneerror || this.phoneerror) {
        this.$bvToast.toast(this.$t("Invalid contact details entered"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else if (!this.validateUniqueContacts()) {
        this.$bvToast.toast(
          this.$t(
            "Father, mother, and student contact numbers must be different."
          ),
          {
            title: this.$t("Error!"),
            variant: "danger",
            solid: true,
          }
        );
        this.check = 1;
      } else if (this.emerPhoneerror) {
        this.$bvToast.toast(this.$t("Invalid emergency contact entered"), {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
        this.check = 1;
      } else {
        this.$bvModal.show("modal-login");

        // set discount value
        if (this.discountBy == "fixed") {
          let df = parseInt(this.discountValue);
          this.myObj.discount = df;
          this.myObj.discount_percentage = 0;
        }

        let confirmAdmission = false;
        let qStatus = this.$route.query.status
          ? this.$route.query.status.toLowerCase()
          : "";

        if (
          (qStatus == "registered" || qStatus == "enrolled") &&
          (this.$route.params.readmit == true ||
            this.$route.params.readmit == "true")
        ) {
          confirmAdmission = true;
        }

        if (
          ["left", "registered", "enrolled"].includes(
            this.myObj.status.toLowerCase()
          ) &&
          (this.$route.params.readmit == true ||
            this.$route.params.readmit == "true")
        ) {
          confirmAdmission = true;
          this.myObj.status = "present";
        }
        if (this.myObj.date_of_admission == "") {
          this.myObj.date_of_admission = null;
        }
        if (this.myObj.date_of_readmission == "") {
          this.myObj.date_of_readmission = null;
        }
        if (this.myObj.date_of_joining == "") {
          this.myObj.date_of_joining = null;
        }
        if (this.myObj.date_of_registraion == "") {
          this.myObj.date_of_registraion = null;
        }
        if (this.myObj.date_of_leaving == "") {
          this.myObj.date_of_leaving = null;
        }
        if (this.myObj.challan_due_date == "") {
          this.myObj.challan_due_date = null;
        }
        if (this.myObj.date_of_birth == "") {
          this.myObj.date_of_birth = null;
        }
        if (this.admObj.testDate == "") {
          this.admObj.testDate = null;
        }
        if (this.admObj.interviewDate == "") {
          this.admObj.interviewDate = null;
        }
        if (this.myObj.grNoLocal == "") {
          this.myObj.grNoLocal = null;
        }
        if (this.myObj.receiptNo) {
          this.myObj.receiptNo = parseInt(this.myObj.receiptNo);
        } else this.myObj.receiptNo = 0;

        if (this.isShsSchool) {
          if (confirmAdmission) {
            const initData = await this.get({
              url:
                this.$store.state.domain +
                "Students/AddInit?campusId=" +
                this.$store.state.userData.cId +
                "&db=" +
                this.$store.state.userData.db,
              token: this.$store.state.userData.token,
            });
            this.myObj.grNo = initData.newG;
          } else if (this.isShsSchoolGrLocalRegistration) {
            this.myObj.grNo = this.formatShsSchoolGrNo(this.myObj.grNoLocal);
            this.myObj.grValue = 0;
          }
        }

        this.myObj.grNo =
          this.myObj.grNo != null ? this.myObj.grNo.toString() : "";
        this.myObj.monthly_fee = parseInt(this.myObj.monthly_fee);
        this.myObj.roll_number = parseInt(this.myObj.roll_number);
        this.myObj.family_code = parseInt(this.myObj.family_code);
        this.myObj.monthly_income = parseInt(this.myObj.monthly_income);

        this.admObj.sID = parseInt(this.admObj.sID);
        // Prepare drivers data from multiple entries
        const driversData = [];
        this.studentDrivers.forEach((driverEntry, index) => {
          if (
            driverEntry.selectedDriver &&
            driverEntry.selectedVehicle &&
            driverEntry.relation
          ) {
            driversData.push({
              id: driverEntry.id || 0,
              sID: this.$route.params.id || 0,
              driverID: driverEntry.selectedDriver.id,
              vehicleID: driverEntry.selectedVehicle.id,
              relation: driverEntry.relation,
              campusID: this.$store.state.userData.cId,
            });
          }
        });

        let clsEnList = [];
        if (this.isClasswiseEnrollment) {
          clsEnList = this.enrollList.filter(
            (el) => el.classID > 0 && el.secID > 0 && el.subID > 0 && el.tID > 0
          );
        }
        if (this.subObj && this.subObj.valueBool) {
          this.subjectData = this.subjectData.filter(
            (el) => el.subID > 0 && el.tID > 0
          );
        }

        if (this.showHappinessTab) {
          this.docData = this.otherPhoto ? [this.otherPhoto] : [];
        }

        this.applyCrestMyskoolFieldsBeforeSave();

        let data = {
          student: this.myObj,
          customFee: this.customObj,
          subjectsEnrollnment: this.subjectData,
          admissionTestData: this.admObj,
          docs: this.docData,
          classEnrollments: clsEnList,
          siblings: this.siblingInfo,
          donorID: this.selectedDonorID,
        };

        // Only add drivers if there's driver data to send
        if (driversData.length > 0) {
          data.drivers = driversData;
        }

        let smsvalue = false;
        if (this.selected === "add") smsvalue = this.addingMsg;

        let familyUpdate = val ? true : false;

        // "students/SaveStudent?db=" +
        // "students/SaveStudentWithData?db=" +
        var status = await this.post({
          url:
            this.$store.state.domain +
            "students/SaveStudentWithDocsData?db=" +
            this.$store.state.userData.db +
            "&sms=" +
            smsvalue +
            "&familyUpdate=" +
            familyUpdate +
            (confirmAdmission ? "&confirmAdmission=true" : "") +
            "&userID=" +
            this.$store.state.userData.userID,
          body: data,
          message: this.$t("Student saved successfully."),
          context: this,
          token: this.$store.state.userData.token,
          savingStudent: true,
        });
        if (status) {
          const class_admitted = this.myObj.class_admitted;
          const cls_admitted = this.myObj.cls_admitted;
          const class_current = this.myObj.class_current;
          const cls_current = this.myObj.cls_current;
          const section_admitted = this.myObj.section_admitted;
          const section_current = this.myObj.section_current;

          this.myObj = {
            id: 0,
            grNo: null,
            family_code: null,
            name: null,
            father_name: null,
            gender: null,
            picture: null,
            date_of_birth: null,
            date_of_birth_words: null,
            date_of_admission: null,
            blood_group: null,
            nationality: null,
            religion: this.isCrestViewAcademy ? "ISLAM" : null,
            place_of_birth: null,
            mother_tongue: null,
            address_current: null,
            address_permanent: null,
            contact_student: null,
            contact_father: null,
            contact_mother: null,
            contact_home: null,
            contact_tutor: null,
            last_institute: null,
            last_class: null,
            last_session: null,
            last_result: null,
            last_note: null,
            class_admitted: class_admitted,
            cls_admitted: cls_admitted,
            class_current: class_current,
            cls_current: cls_current,
            section_admitted: section_admitted,
            section_current: section_current,
            roll_number: null,
            house: null,
            surname: null,
            rfid_number: null,
            bform_number: null,
            date_of_registraion: null,
            date_of_readmission: null,
            date_of_joining: null,
            father_cnic: null,
            father_education: null,
            father_occupation: null,
            monthly_income: null,
            office_phone: null,
            office_address: null,
            father_email: null,
            father_employer: null,
            mother_name: null,
            mother_cnic: null,
            mother_education: null,
            mother_occupation: null,
            mother_office_phone: null,
            mother_office_address: null,
            mother_email: null,
            mother_employer: null,
            guardian_name: null,
            guardian_cnic: null,
            guardian_education: null,
            guardian_occupation: null,
            guardian_office_phone: null,
            guardian_office_address: null,
            guardian_email: null,
            guardian_employer: null,
            guardian_relationship: null,
            emergency_name: null,
            emergency_contact: null,
            emergency_relationship: null,
            learningDifficulties: null,
            specialMedicalNeeds: null,
            physical_handicap: null,
            emailAddress: null,
            allergies: null,
            remarks: null,
            monthly_fee: 0,
            discount_percentage: 0,
            discount: 0,
            discountReferenceID: 0,
            challan_due_date: null,
            docs: "",
            status: this.$store.state.userData.studentStatus,
            campusID: this.$store.state.userData.cId,
            campus_Admitted: this.$store.state.userData.cId,
            testPayment: false,
            testPassed: false,
            testCompleted: false,
            sessionID: 0,
            currency: "Rs",
          };
          this.learningDifficultiesHas = false;
          this.learningDifficultiesDetail = "";
          this.specialMedicalNeedsHas = false;
          this.specialMedicalNeedsDetail = "";
          this.documents = [];
          this.$bvModal.hide("modal-login");
          this.check = 1;
          this.$refs.wizard.reset();
          // this.$router.push("/manage-student");
          this.$router.go(-1);
        } else {
          // this.$bvToast.toast(this.$t("Something went wrong!"), {
          //   title: this.$t("Error!"),
          //   variant: "danger",
          //   solid: true,
          // });
          this.$bvModal.hide("modal-login");
          this.check = 1;
        }
      }
    },
    async selectMoreFile() {
      if (this.$refs.mfile.files.length !== 0) {
        this.moreloading = true;
        try {
          const uploaded = await uploadToMySkool(this.$refs.mfile.files);
          uploaded.forEach((item) => {
            this.mydocs.push({
              path: getUploadPath(item),
              orginal: item.originalname,
            });
          });
        } catch (error) {
          console.log("error", error);
        } finally {
          this.moreloading = false;
        }
      }
    },
    async convertHeicToJpeg(file) {
      const isHeic =
        /\.(heic|heif)$/i.test(file.name) ||
        ["image/heic", "image/heif"].includes(
          (file.type || "").toLowerCase()
        );

      if (!isHeic) {
        return file;
      }

      try {
        const result = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.9
        });
  
        const jpegBlob = Array.isArray(result) ? result[0] : result;
  
        const jpegName = file.name.replace(/\.(heic|heif)$/i, ".jpg");
  
        return new File([jpegBlob], jpegName, {
          type: "image/jpeg",
          lastModified: Date.now()
        });
      }
      catch(err) {
        console.log(err);
        return file;
      }
    },
    deleteLogo() {
      this.myObj.picture = null;
      this.plus = "";
      this.logoloading = false;
      if (this.$refs.fileProfile) {
        this.$refs.fileProfile.value = null;
      }
    },
    async selectlogo() {
      const file = this.$refs.fileProfile.files[0];
      if (!file) return;

      this.logoloading = true;
      // Convert HEIC to JPEG; other files remain unchanged.
      const fileToUpload = await this.convertHeicToJpeg(file);
      // console.log(fileToUpload);

      const localPreview = URL.createObjectURL(fileToUpload);
      this.plus = localPreview;

      try {
        const uploaded = await uploadToMySkool([fileToUpload]);
        const fn1 = getUploadPath(uploaded[0]);
        URL.revokeObjectURL(localPreview);
        this.plus = fn1;
        this.myObj.picture = fn1;
        this.logoloading = "loaded";
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.plus = "";
        this.logoloading = false;
        console.log(err);
      } finally {
        if (this.$refs.fileProfile) this.$refs.fileProfile.value = "";
      }
    },
    async selectOtherPhoto() {
      const file = this.$refs.otherProfile.files[0];
      if (!file) return;

      this.otherPhotoLoading = true;
       // Convert HEIC to JPEG; other files remain unchanged.
      const fileToUpload = await this.convertHeicToJpeg(file);
      
      const localPreview = URL.createObjectURL(fileToUpload);
      this.otherPhoto.url = localPreview;

      try {
        const uploaded = await uploadToMySkool([fileToUpload]);
        const storedUrl = getUploadPath(uploaded[0]);
        URL.revokeObjectURL(localPreview);
        this.otherPhoto.url = storedUrl;
        this.otherPhotoLoading = "loaded";
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.otherPhoto.url = null;
        this.otherPhotoLoading = false;
        console.log(err);
      } finally {
        if (this.$refs.otherProfile) this.$refs.otherProfile.value = "";
      }
    },
    deleteOtherPhoto() {
      this.otherPhoto.url = null;
      this.otherPhotoLoading = false;
      this.$refs.otherProfile.value = null;
    },

    cleanStates() {
      var elem = this.$refs["name"];
      elem.state = undefined;
      var elem = this.$refs["fname"];
      elem.state = undefined;
      var elem = this.$refs["dob"];
      elem.state = undefined;
      var elem = this.$refs["grNo"];
      elem.state = undefined;
      var elem = this.$refs["monthly_fee"];
      elem.state = undefined;
      // var elem = this.$refs["class_admitted"];
      // elem.state = undefined;
      // var elem = this.$refs["section_admitted"];
      // elem.state = undefined;
      // var elem = this.$refs["class_current"];
      // elem.state = undefined;
      // var elem = this.$refs["section_current"];
      // elem.state = undefined;
      // this.admittedSections = [];
      // this.currentSections = [];
    },
    CheckAdmitSec() {
      if (this.showHappinessTab && this.selected === "reg") return true;

      var elem = this.$refs["section_admitted"];
      if (this.myObj.section_admitted == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckCurrentSec() {
      if (this.showHappinessTab && this.selected === "reg") return true;

      var elem = this.$refs["section_current"];
      if (this.myObj.section_current == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckClassAdmit() {
      if (this.showHappinessTab && this.selected === "reg") return true;

      var elem = this.$refs["class_admitted"];
      if (this.myObj.class_admitted == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckClassCurrent() {
      if (this.showHappinessTab && this.selected === "reg") return true;

      var elem = this.$refs["class_current"];
      if (this.myObj.class_current == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.name == "" || this.myObj.name < 3) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckFName() {
      if (this.showHappinessTab) return true;
      var elem = this.$refs["fname"];
      if (this.myObj.father_name == "" || this.myObj.father_name < 3) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDob() {
      var elem = this.$refs["dob"];
      if (this.myObj.date_of_birth == "" || this.myObj.date_of_birth == null) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    normalizeContactNumber(val) {
      if (val == null || val === "") return "";
      return String(val).replace(/\D/g, "");
    },
    validateUniqueContacts() {
      const father = this.normalizeContactNumber(this.myObj.contact_father);
      const mother = this.normalizeContactNumber(this.myObj.contact_mother);
      const student = this.normalizeContactNumber(this.myObj.contact_student);
      const minLen = 7;
      const duplicate =
        (father.length >= minLen &&
          mother.length >= minLen &&
          father === mother) ||
        (father.length >= minLen &&
          student.length >= minLen &&
          father === student) ||
        (mother.length >= minLen &&
          student.length >= minLen &&
          mother === student);
      this.contactDuplicateError = duplicate;
      return !duplicate;
    },
    CheckFContact(s, e) {
      // console.log(this.myObj.contact_father);
      if (this.myObj.contact_father) {
        if (e.valid) {
          this.fphoneerror = false;
          this.myObj.contact_father = e.number;
          // console.log(this.myObj.contact_father);
        } else {
          this.fphoneerror = true;
        }
      } else {
        this.fphoneerror = false;
      }
      this.validateUniqueContacts();
    },
    CheckMContact(s, e) {
      // console.log(this.myObj.contact_mother);
      if (this.myObj.contact_mother) {
        if (e.valid) {
          this.mphoneerror = false;
          this.myObj.contact_mother = e.number;
          // console.log(this.myObj.contact_mother);
        } else {
          this.mphoneerror = true;
        }
      } else {
        this.mphoneerror = false;
      }
      this.validateUniqueContacts();
    },
    CheckContact(s, e) {
      // console.log(this.myObj.contact_student);
      if (this.myObj.contact_student) {
        if (e.valid) {
          this.phoneerror = false;
          this.myObj.contact_student = e.number;
          // console.log(this.myObj.contact_student);
        } else {
          this.phoneerror = true;
        }
      } else {
        this.phoneerror = false;
      }
      this.validateUniqueContacts();
    },
    CheckCnic() {
      var elem = this.$refs["fCnic"];
      if (this.myObj.father_cnic == null || this.myObj.father_cnic == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckMCnic() {
      var elem = this.$refs["mCnic"];
      if (this.myObj.mother_cnic == null || this.myObj.mother_cnic == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmail() {
      var elem = this.$refs["fEmail"];
      if (this.myObj.father_email == null || this.myObj.father_email == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckGCnic() {
      var elem = this.$refs["gCnic"];
      if (this.myObj.guardian_cnic == null || this.myObj.guardian_cnic == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckGEmail() {
      var elem = this.$refs["gEmail"];
      if (
        this.myObj.guardian_email == null ||
        this.myObj.guardian_email == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerName() {
      var elem = this.$refs["emerName"];
      if (
        this.myObj.emergency_name == null ||
        this.myObj.emergency_name == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerRelation() {
      var elem = this.$refs["emerRel"];
      if (
        this.myObj.emergency_relationship == null ||
        this.myObj.emergency_relationship == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerContact(s, e) {
      // console.log(e);
      if (this.myObj.emergency_contact != "") {
        // console.log(e);
        if (e.valid) {
          this.emerPhoneerror = false;
          this.myObj.emergency_contact = e.number;
          // console.log(this.myObj.emergency_contact);
        } else {
          this.emerPhoneerror = true;
        }
      } else {
        this.emerPhoneerror = false;
      }
    },
    applyInquiryDataToStudent(data) {
      if (!data) return;

      this.myObj.name = data.name;
      this.myObj.father_name = data.father_name;
      this.myObj.class_admitted = data.cls;
      this.myObj.class_current = data.cls;
      this.myObj.contact_father = data.contact;
      this.myObj.father_cnic = data.father_cnic || data.cnic || null;
      this.myObj.father_email = data.email;
      this.myObj.last_institute = data.lastSchool;
      this.myObj.address_current = data.residentialArea;
      this.myObj.address_permanent = data.residentialArea;
      this.myObj.campusID = data.campusID;

      if (data.father_occupation) {
        this.myObj.father_occupation = data.father_occupation;
      }
      if (data.mother_occupation) {
        this.myObj.mother_occupation = data.mother_occupation;
      }
      if (data.mother_cnic) {
        this.myObj.mother_cnic = data.mother_cnic;
      }
      if (data.dob) {
        this.myObj.date_of_birth = data.dob;
      }
      if (data.currentClass) {
        this.myObj.last_class = data.currentClass;
      }
      if (data.learningDifficulties) {
        this.myObj.learningDifficulties = data.learningDifficulties;
      }
      if (data.specialMedicalNeeds) {
        this.myObj.specialMedicalNeeds = data.specialMedicalNeeds;
      }

      this.myObj.docs = data.attachments;
      if (data.attachments !== null && data.attachments !== "") {
        this.documents = data.attachments.split(",");
      } else this.documents = [];

      this.syncCrestMyskoolFieldsFromStudent();
    },
    applyCrestMyskoolFieldsBeforeSave() {
      if (!this.showCrestMyskoolFields) return;
      this.myObj.learningDifficulties = this.learningDifficultiesHas
        ? this.learningDifficultiesDetail || "Yes"
        : "No";
      this.myObj.specialMedicalNeeds = this.specialMedicalNeedsHas
        ? this.specialMedicalNeedsDetail || "Yes"
        : "No";
    },
    syncCrestMyskoolFieldsFromStudent() {
      if (!this.showCrestMyskoolFields) return;
      const ld = String(this.myObj.learningDifficulties || "").trim();
      if (!ld || ld.toLowerCase() === "no") {
        this.learningDifficultiesHas = false;
        this.learningDifficultiesDetail = "";
      } else {
        this.learningDifficultiesHas = true;
        this.learningDifficultiesDetail = ld.toLowerCase() === "yes" ? "" : ld;
      }
      const sm = String(this.myObj.specialMedicalNeeds || "").trim();
      if (!sm || sm.toLowerCase() === "no") {
        this.specialMedicalNeedsHas = false;
        this.specialMedicalNeedsDetail = "";
      } else {
        this.specialMedicalNeedsHas = true;
        this.specialMedicalNeedsDetail = sm.toLowerCase() === "yes" ? "" : sm;
      }
      // if (this.myObj.emergency_contact.length == 12) {
      //   // console.log(this.myObj.emergency_contact.length);
      //   this.emerPhoneerror = false;
      //   return true;
      // } else {
      //   this.emerPhoneerror = true;
      //   return false;
      // }
    },
    async CheckFees() {
      if (this.showHappinessTab) return true;

      // console.log(this.myObj.monthly_fee);
      const regex = /^(\d*([.,](?=\d{3}))?\d+)+((?!\2)[.,]\d\d)?$/;
      var elem = this.$refs["monthly_fee"];
      if (regex.test(this.myObj.monthly_fee)) {
        if (this.myObj.monthly_fee < 0) {
          return (elem.state = false);
        } else {
          // Update custom fees base amounts for tax fees when monthly fee changes
          this.UpdateTaxBaseFee();
          return (elem.state = true);
        }
      } else {
        return (elem.state = false);
      }
    },
    CheckGrNo() {
      if (this.showHappinessTab) return true;
      if (this.isShsSchoolGrLocalRegistration) return true;

      var elem = this.$refs["grNo"];
      if (this.myObj.grNo == null || this.myObj.grNo.toString().trim() == "") {
        return (elem.state = false);
      } else {
        if (this.reportDomain == "myskoolhpgs") {
          let x = this.myObj.grNo.toString().replace(/\s+/g, "");
          if (x) {
            this.myObj.grNo = x;
            return (elem.state = true);
          }
          return (elem.state = false);
        }
        return (elem.state = true);
      }
    },
    CheckBForm() {
      if (this.reportDomain == "myskoolhpgs") {
        var elem = this.$refs["bform"];
        if (!this.myObj.bform_number) {
          return (elem.state = false);
        } else return (elem.state = true);
      } else return true;
    },
    CheckReceipt() {
      if (
        this.reportDomain == "myskoolhpgs" &&
        this.spNo &&
        this.spNo.valueBool
      ) {
        var elem = this.$refs["recNo"];
        let x = parseInt(this.myObj.receiptNo);
        if (isNaN(x) || x < 0) {
          return (elem.state = false);
        } else return (elem.state = true);
      } else return true;
    },
    CheckTimelyDis() {
      if (["myskoolaims", "myskoolaimsc2"].includes(this.reportDomain)) {
        var elem = this.$refs["timely_dis"];
        let x = parseInt(this.myObj.timelyDiscount);
        if (isNaN(x) || x < 0) {
          return (elem.state = false);
        } else {
          this.myObj.timelyDiscount = x;
          return (elem.state = true);
        }
      } else return true;
    },
    normalizeShsSchoolGrNoLocal(value) {
      const raw = String(value || "").trim();
      if (!raw) return "";
      const wrapped = raw.match(/^SHS\s*\((.+)\)\s*$/i);
      if (wrapped) return wrapped[1].trim();
      return raw
        .replace(/^SHS\s*/i, "")
        .replace(/[()]/g, "")
        .trim();
    },
    formatShsSchoolGrNo(grNoLocal) {
      const local = this.normalizeShsSchoolGrNoLocal(grNoLocal);
      return local ? `SHS${local}` : "";
    },
    syncShsSchoolGrNoLocalFromGrNo() {
      if (!this.isShsSchool || !this.isShsSchoolGrLocalRegistration) return;
      const localFromGrNo = this.normalizeShsSchoolGrNoLocal(this.myObj.grNo);
      if (!this.myObj.grNoLocal && localFromGrNo) {
        this.myObj.grNoLocal = localFromGrNo;
      } else if (this.myObj.grNoLocal) {
        this.myObj.grNoLocal = this.normalizeShsSchoolGrNoLocal(
          this.myObj.grNoLocal
        );
      }
    },
    CheckGrLocal() {
      if (
        (this.reportDomain == "myskoolhpgs" || this.isShsSchool) &&
        this.schGr &&
        this.schGr.valueBool
      ) {
        var elem = this.$refs["gr_local"];
        if (!this.myObj.grNoLocal) {
          return (elem.state = false);
        } else return (elem.state = true);
      } else return true;
    },
    CheckDiscount() {
      // only on discount visible
      if (this.disVisible.includes(this.reportDomain)) {
        if (this.discountBy == "percentage") {
          var elem = this.$refs["discount_perc"];
          let x = parseFloat(this.myObj.discount_percentage);
          if (isNaN(x) || x < 0 || x > 100) {
            return (elem.state = false);
          } else {
            this.myObj.discount_percentage = x;
            if (this.myObj.classFee == 0 && x > 0) {
              return (elem.state = false);
            }
            return (elem.state = true);
          }
        } else if (this.discountBy == "fixed") {
          var elem = this.$refs["discount_amount"];
          let x = parseInt(this.discountValue);
          if (isNaN(x) || x < 0 || x > this.myObj.classFee) {
            return (elem.state = false);
          } else {
            this.discountValue = x;
            if (this.myObj.classFee == 0 && x > 0) {
              return (elem.state = false);
            }
            return (elem.state = true);
          }
        } else return true;
      } else return true;
    },
    resetStates() {
      const elem1 = this.$refs["discount_amount"];
      if (elem1) elem1.state = true;
      const elem2 = this.$refs["discount_perc"];
      if (elem2) elem2.state = true;
    },
    CalculateDiscount() {
      setTimeout(() => {
        if (this.discountBy == "none") {
          this.discountValue = 0;
          this.myObj.discount = 0;
          this.myObj.discount_percentage = 0;
          this.resetStates();
        } else {
          if (this.CheckDiscount() == true) {
            if (this.discountBy == "percentage") {
              let percent = this.myObj.discount_percentage / 100;
              let discount = parseInt(percent * this.myObj.classFee);
              // console.log(discount);
              this.myObj.monthly_fee = this.myObj.classFee - discount;
              this.myObj.discount = discount;
            } else if (this.discountBy == "fixed") {
              let diff = this.myObj.classFee - this.discountValue;
              this.myObj.monthly_fee = diff < 0 ? 0 : diff;
              // this.myObj.discount_percentage = 0;
            }
          } else {
            this.myObj.monthly_fee =
              this.myObj.classFee > 0
                ? this.myObj.classFee
                : this.myObj.monthly_fee;
          }
        }
      }, 500);
    },
    FillSections(text) {
      //return console.log(this.classes);
      // console.log(this.myObj.class_admitted);

      this.classes.forEach((elem) => {
        if (elem.cls.id === this.myObj.class_admitted) {
          if (elem.sections.length != 0) {
            this.admittedSections = elem.sections;
          } else {
            // console.log("null");
            this.admittedSections = [];
          }
        }
      });
      if (text !== "filled") this.myObj.section_admitted = 0;
      this.setSameFields("class");
      // console.log("Thisis", this.admittedSections);
    },
    async FillSectionsCurrent(text) {
      this.classes.forEach((elem) => {
        if (elem.cls.id === this.myObj.class_current) {
          if (elem.sections.length != 0) {
            this.currentSections = elem.sections;
          } else {
            this.currentSections = [];
          }
        }
      });
      if (text !== "filled") this.myObj.section_current = 0;

      // api for monthly fee acc to class
      if (
        text == "select" &&
        (this.selected === "add" || this.selected === "reg")
      ) {
        let res = await this.getClsFee();
        if (!isNaN(res)) {
          this.myObj.monthly_fee = res;
          this.myObj.classFee = res;
          if (this.disVisible.includes(this.reportDomain)) {
            this.CalculateDiscount();
          }
        }
      } else if (this.myObj.id > 0) {
        // only on discount visible
        if (text == "select" && this.disVisible.includes(this.reportDomain)) {
          await this.checkAndApplyDiscount();
        }
        // on discount setting ,set class fee on class change or classes load student edit
        else if (
          (text == "select" && this.disSetting && this.disSetting.valueBool) ||
          (text == "filled" && this.myObj.classFee == 0)
        ) {
          let res = await this.getClsFee();
          if (!isNaN(res)) {
            this.myObj.classFee = res;
          }
        }
      }
    },
    async getClsFee() {
      var obj = {
        url:
          this.$store.state.domain +
          "Students/LoadClassFee?clsID=" +
          this.myObj.class_current +
          "&campusId=" +
          this.myObj.campusID +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      return res;
    },

    async checkAndApplyDiscount() {
      // Only proceed if student already exists
      if (this.myObj.id <= 0) return;

      // Get class fee
      const newClassFee = await this.getClsFee();
      // console.log(newClassFee);
      if (isNaN(newClassFee) || newClassFee < 0) return;

      const oldClassFee = this.myObj.classFee;

      // Check validations
      let hasDiscount = false; // for none discount
      if (this.discountBy == "percentage") {
        var elem = this.$refs["discount_perc"];
        let dp = parseFloat(this.myObj.discount_percentage);
        if (isNaN(dp) || dp < 0 || dp > 100) {
          hasDiscount = false;
        } else {
          this.myObj.discount_percentage = dp;
          if (newClassFee == 0 || (newClassFee == 0 && dp > 0)) {
            hasDiscount = false;
          } else {
            hasDiscount = true;
          }
        }
        // dont show invalid if discount is 0
        elem.state = dp == 0 ? true : hasDiscount;
      } else if (this.discountBy == "fixed") {
        var elem = this.$refs["discount_amount"];
        let df = parseInt(this.discountValue);
        if (isNaN(df) || df < 0 || df > newClassFee) {
          hasDiscount = false;
        } else {
          this.discountValue = df;
          if (newClassFee == 0 || (newClassFee == 0 && df > 0)) {
            hasDiscount = false;
          } else {
            hasDiscount = true;
          }
        }
        // dont show invalid if discount is 0
        elem.state = df == 0 ? true : hasDiscount;
      }

      // oldClassFee !== newClassFee &&
      if (hasDiscount) {
        this.myObj.classFee = newClassFee;

        // Create discount information
        let discountInfo = "";
        let discountAmount = 0;
        let newMonthlyFee = 0;
        if (this.discountBy === "percentage") {
          const percent = this.myObj.discount_percentage / 100;
          discountAmount = parseInt(percent * newClassFee);
          newMonthlyFee = newClassFee - discountAmount;
          discountInfo = `Current discount: <b>${this.myObj.discount_percentage}%</b>`;

          this.myObj.discount = discountAmount;
        } else {
          const diff = newClassFee - this.discountValue;
          newMonthlyFee = diff < 0 ? 0 : diff;
          discountInfo = `Current discount: <b>${this.discountValue}</b>`;
        }
        this.myObj.monthly_fee = newMonthlyFee;

        const clsObj = this.classes.find(
          (el) => el.cls.id == this.myObj.class_current
        );
        const clsName = clsObj ? `Class ${clsObj.cls.name}` : "Class";

        const htmlContent = `
          <div class="text-left">
            <p class="mb-0">${clsName} fee: <b>${newClassFee}</b></p>
            <p class="mb-0">${discountInfo}</p>
            <p class="mb-0">Monthly Fee: <b class="text-success">${newMonthlyFee}</b></p>
          </div>
        `;

        Swal.fire({
          title: "Discount Applied",
          html: htmlContent,
          icon: "success",
          showCancelButton: false,
          confirmButtonText: "Ok",
          confirmButtonColor: "#7367F0",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } else {
        // No discount applied or same class fee, just update the classFee
        this.myObj.classFee = newClassFee;
      }
    },

    onSiblingSearchChange() {
      if (this.siblingSearchTimer) clearTimeout(this.siblingSearchTimer);
      this.siblingSearchTimer = setTimeout(() => {
        this.performSiblingSearch();
      }, 700);
    },

    async performSiblingSearch() {
      const term = (this.siblingSearchQuery || "").trim();
      if (term.length < 2) {
        this.siblingSearchResults = [];
        return;
      }
      this.siblingSearchLoading = true;
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Students/Search?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&keyword=" +
            encodeURIComponent(term) +
            "&type=",
          token: this.$store.state.userData.token,
        };
        const response = await this.get(obj);
        let data = [];
        if (response && response.data && Array.isArray(response.data)) {
          data = response.data;
        } else if (Array.isArray(response)) {
          data = response;
        }
        this.siblingSearchResults = data.map((s) => {
          let className = "";
          let sectionName = "";
          if (s.meta_class) {
            const parts = s.meta_class.split(" - ");
            className = parts[0] ? parts[0].trim() : "";
            sectionName = parts[1] ? parts[1].trim() : "";
          }
          return {
            id: s.id,
            name: s.name || "",
            className,
            sectionName,
            grNo: s.grNo || "",
            campusID: s.campusID || this.myObj.campusID,
          };
        });
      } catch (e) {
        this.siblingSearchResults = [];
      } finally {
        this.siblingSearchLoading = false;
      }
    },

    selectSiblingStudent(student) {
      const alreadyAdded = this.siblingInfo.some(
        (s) => s.relation == student.id.toString()
      );
      if (!alreadyAdded) {
        this.siblingInfo.push({
          id: 0,
          localID: this.myObj.id,
          type: "student",
          name: student.name,
          relation: student.id.toString(),
          schoolName: "",
          age: "",
          className:
            student.className +
            (student.sectionName ? " - " + student.sectionName : ""),
          campusID: student.campusID || this.myObj.campusID,
        });
      }
      this.siblingSearchQuery = "";
      this.siblingSearchResults = [];
      // console.log(this.siblingInfo);
    },

    async removeSiblingStudent(item, idx) {
      if (item.id == 0) {
        this.siblingInfo.splice(idx, 1);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "SiblingDetails/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.siblingInfo.splice(idx, 1);
      }
    },

    async loadDonorForStudent() {
      this.donorLoading = true;
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "donors/GetDonorForStudent?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&sID=" +
            this.$route.params.id,
          token: this.$store.state.userData.token,
        };
        const res = await this.get(obj);
        this.donorInfo = res || null;
        if (this.donorInfo) this.selectedDonorID = this.donorInfo.id;
        // console.log(res);
      } catch (e) {
        this.donorInfo = null;
      } finally {
        this.donorLoading = false;
      }
    },
    async LoadDonors() {
      this.donorListLoading = true;
      const obj = {
        url:
          this.$store.state.domain +
          "Donors/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&page=1&pageSize=1000",
        token: this.$store.state.userData.token,
        returnData: true,
      };
      const response = await this.get(obj);
      if (response === false) this.donorOptions = [];
      else if (Array.isArray(response.data)) {
        this.donorOptions = response.data;
      }
      this.donorListLoading = false;
    },
    donorFilter(opt, label, search) {
      // console.log(opt, label, search);
      let st = search.toLowerCase();
      return (
        (opt.donor.firstName && opt.donor.firstName.toLowerCase().match(st)) ||
        (opt.donor.surname && opt.donor.surname.toLowerCase().match(st))
      );
    },

    async LoadAreas() {
      var obj = {
        url:
          this.$store.state.domain +
          "StudentArea?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.areaOptions = await this.get(obj);
      // console.log(this.areaOptions);
    },
    async LoadStudent() {
      await this.LoadSettingsAll();

      var obj = {
        url:
          // "Students/LoadStudentData?db=" +
          this.$store.state.domain +
          "Students/LoadStudentDataWithDocs?db=" +
          this.$store.state.userData.db +
          "&sID=" +
          this.$route.params.id,
        token: this.$store.state.userData.token,
      };

      let result = await this.get(obj);
      this.myObj = result.student;
      this.prevObj = { ...result.student };

      // current date if confirming enrollment
      if (this.showHappinessTab) {
        const forEnroll =
          this.myObj.status == "registered" ||
          this.$route.query.status == "registered"
            ? ["true", true].includes(this.$route.params.readmit)
            : false;
        if (forEnroll && !this.myObj.date_of_admission) {
          this.myObj.date_of_admission = new Date().toJSON();
        }
      }

      if (this.myObj.currency == null) this.myObj.currency = "Rs";
      this.syncShsSchoolGrNoLocalFromGrNo();
      this.syncCrestMyskoolFieldsFromStudent();

      const joining =
        this.myObj.date_of_joining ?? this.myObj.dateOfJoining ?? null;
      this.$set(this.myObj, "date_of_joining", joining);

      if (this.disVisible.includes(this.reportDomain)) {
        if (this.myObj.discount_percentage > 0) {
          this.discountBy = "percentage";
        } else if (this.myObj.discount > 0) {
          this.discountBy = "fixed";
        } else this.discountBy = "none";
        this.discountValue = this.myObj.discount;
      }

      if (this.myObj.receiptNo > 0) {
        this.myObj.receiptNo = this.myObj.receiptNo.toString().padStart(4, "0");
      }
      // console.log("obj:", this.myObj);
      this.customObj = result.customFee;

      // on edit load feetype after student to set custom fee
      this.loadFeeType();

      // moved below code to loadfeetype
      // if (!this.customObj || this.customObj.length == 0) {
      //   this.customObj = [
      //     {
      //       id: 0,
      //       sID: this.$route.params.id,
      //       feeTypeID: 0,
      //       amount: 0,
      //       baseFee: 0,
      //       discount: 0,
      //       campusID: this.$store.state.userData.cId,
      //     },
      //   ];
      // } else {
      //   this.changeOptions();
      //   this.setBaseFee();
      // }
      // console.log(this.customObj);

      if (!result.admissionTestData) {
        this.admObj = {
          id: 0,
          sID: this.$route.params.id,
          campusID: this.$store.state.userData.cId,
          testDate: null,
          testStatus: "",
          interviewDate: null,
          interviewStatus: "",
          remarks: "",
          documents: "",
        };
      } else {
        this.admObj = result.admissionTestData;
      }

      // console.log(result.docs);
      if (!result.docs) {
        this.docData = [];
      } else {
        this.docData = result.docs;
        if (this.showHappinessTab) {
          this.otherPhoto = this.docData.find((el) => el.docID == 1);
          this.otherPhotoLoading = this.otherPhoto.url ? "loaded" : false;
        }
      }

      if (!result.siblings) {
        this.siblingInfo = [];
      } else {
        this.siblingInfo = result.siblings;
      }

      this.subjectData = result.subjectsEnrollnment;
      await this.loadSubjects();
      if (!this.subjectData || this.subjectData.length == 0) {
        this.setSubs();
      } else {
        let ids = this.subjectData.map((el) => el.subID);
        // Update existing subject names and add new subjects
        let updatedSubjectData = this.subjectData.map((subject) => {
          // Find matching subject in allSubjects to get latest name
          const matchingSubject = this.allSubjects.find(
            (s) => s.id === subject.subID
          );
          if (matchingSubject) {
            return {
              ...subject,
              subName: matchingSubject.subject, // Update to latest subject name
            };
          }
          return subject;
        });

        // Add new subjects that don't exist in subjectData
        let newSubjects = this.allSubjects.reduce((acc, el) => {
          if (!ids.includes(el.id)) {
            acc.push({
              id: 0,
              sID: this.$route.params.id,
              subID: el.id,
              subName: el.subject,
              isExcluded: false,
              campusID: this.$store.state.userData.cId,
            });
          }
          return acc;
        }, []);

        this.subjectData = [...updatedSubjectData, ...newSubjects];
        // console.log(data, this.subjectData);
        this.sortSubjects();
      }

      if (result.classEnrollments && result.classEnrollments.length > 0) {
        this.LoadStdEnrollment();
        // this.enrolledData = result.classEnrollments.map((item) => ({
        //   ...item,
        //   sectionList: [],
        //   subjectList: [],
        //   teacherList: [],
        // }));
      } else this.enrolledData = [];

      if (this.myObj.picture !== null && this.myObj.picture !== "") {
        this.plus = this.myObj.picture;
        this.logoloading = "loaded";
      }
      if (this.myObj.docs !== null && this.myObj.docs !== "") {
        this.documents = this.myObj.docs.split(",");
        // console.log(this.documents);
      }
      if (
        !["left", "enrolled", "alumni"].includes(
          this.myObj.status.toLowerCase()
        )
      ) {
        this.$store.commit("stdStatus", this.myObj.status.toLowerCase());
      }
      // Load driver options first, then populate driver data (only if drivers tab is visible)
      if (this.$route.params.id >= 0 && this.showDriverTab) {
        const driverCampusId =
          Number(this.myObj.campusID) ||
          Number(this.$store.state.userData.cId) ||
          0;
        await this.loadDriverOptions(driverCampusId);

        const driversList =
          (Array.isArray(result.drivers) && result.drivers) ||
          (Array.isArray(result.Drivers) && result.Drivers) ||
          (Array.isArray(result.studentDrivers) && result.studentDrivers) ||
          (Array.isArray(this.myObj?.drivers) && this.myObj.drivers) ||
          [];

        this.pendingStudentDrivers = driversList;
        this.populateStudentDrivers(driversList);
      }

      this.LoadData(this.myObj.campusID);
    },
    LoadData(id) {
      this.dataloading = true;
      let cID = this.$store.state.userData.cId;
      if (id) cID = id;
      var axios = require("axios");
      var config = {
        method: "get",
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          cID +
          "&dID=0",
        headers: {
          Authorization: "bearer " + this.$store.state.userData.token,
        },
      };

      axios(config)
        .then((response) => {
          // console.log(response.data.data);
          this.classes = [];
          this.classes = response.data.data;
          this.classesOptions = [];
          this.classes.forEach((el) => this.classesOptions.push(el.cls));
          this.allSections = (this.classes || []).reduce((acc, el) => {
            if (Array.isArray(el.sections)) {
              acc.push(...el.sections);
            }
            return acc;
          }, []);
          this.FillSections("filled");
          this.FillSectionsCurrent("filled");
          this.dataloading = false;

          // load dropdown options after classes load on edit
          // if (this.isClasswiseEnrollment && this.$route.params.id > 0) {
          //   this.enrolledData.forEach((item) => {
          //     this.LoadEnSections(item, false);
          //     this.LoadSubjectByClass(item, false);
          //     this.LoadTeachers(item, false);
          //   });
          // }
        })
        .catch(function (error) {
          console.log(error);
          this.dataloading = false;
        });
    },
    async LoadHistory() {
      var obj = {
        url:
          this.$store.state.domain +
          "EducationHistory/LoadData?db=" +
          this.$store.state.userData.db +
          "&id=" +
          this.$route.params.id +
          "&role=student",
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);

      this.historyData = Array.isArray(res) ? res : [];

      // this.historyData = [
      //     {
      //       id: 0,
      //       localID: this.$route.params.id,
      //       role: "student",
      //       degree: "Matriculation",
      //       board: "",
      //       university: "",
      //       passingYear: "",
      //       seatNo: "",
      //       examStatus: "",
      //       division: "",
      //       discipline: "",
      //       affiliatedCollege: "",
      //       campusID: this.$store.state.userData.cId,
      //     },
      //     {
      //       id: 0,
      //       localID: this.$route.params.id,
      //       role: "student",
      //       degree: "Intermediate",
      //       board: "",
      //       university: "",
      //       passingYear: "",
      //       seatNo: "",
      //       examStatus: "",
      //       division: "",
      //       discipline: "",
      //       affiliatedCollege: "",
      //       campusID: this.$store.state.userData.cId,
      //     },
      //   ];
    },
    async LoadInit() {
      var obj = {
        url:
          this.$store.state.domain +
          "Students/AddInit?campusId=" +
          this.$store.state.userData.cId +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      let initData = await this.get(obj);
      // console.log("data:", initData);
      this.myObj.grNo = initData.newG;
      this.myObj.family_code = initData.fCode;
    },
    async LoadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "family_update",
          "receipt_number",
          "studentTimings",
          "subject_teacher_enrollment",
          "classwise_enrollment",
          "registration_class",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.fObj = res.find((el) => el.key == "family_update");
      if (!["myskoolhpgs", "myskooliuss"].includes(this.reportDomain)) {
        this.spNo = res.find((el) => el.key == "receipt_number");
      }
      this.timeObj = res.find((el) => el.key == "studentTimings");
      if (this.$route.params.id > 0 && this.timeObj && this.timeObj.valueBool) {
        this.LoadTimings();
        this.$nextTick(() => {
          this.$refs.wizard.activateAll();
        });
      }
      this.subObj = res.find((el) => el.key == "subject_teacher_enrollment");
      if (this.subObj && this.subObj.valueBool) {
        this.LoadStaff();
      }
      let enrollObj = res.find((el) => el.key == "classwise_enrollment");
      this.isClasswiseEnrollment = enrollObj && enrollObj.valueBool;
      if (this.isClasswiseEnrollment) this.LoadEnSelection();

      let rObj = res.find((el) => el.key == "registration_class");
      if (rObj && rObj.value) {
        // value -> classID,sectionID
        let regValues = rObj.value.split(",");
        this.regClass = Number(regValues[0]) || 0;
        this.regSection = Number(regValues[1]) || 0;
      }
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: [
          "local_gr",
          "other_fields",
          "discount_ref",
          "discountBy",
          "receipt_number",
          "students-rewards",
          "tax-fee",
          "manage-std-rfID",
          "date_of_joining",
          "admin-approval",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.schGr = res.find((el) => el.key == "local_gr");
      this.otherObj = res.find((el) => el.key == "other_fields");
      this.disSetting = res.find((el) => el.key == "discount_ref");

      this.disBy = res.find((el) => el.key == "discountBy");
      if (this.disBy?.valueBool) this.disVisible = [this.reportDomain];

      // either discount visible or discount setting
      if (this.disVisible.includes(this.reportDomain)) this.disSetting = null;
      let text = this.disVisible.includes(this.reportDomain)
        ? "-"
        : this.disSetting && this.disSetting.valueBool
        ? "filled"
        : "";
      if (text) this.LoadDis(text);
      if (["myskoolhpgs", "myskooliuss"].includes(this.reportDomain)) {
        this.spNo = res.find((el) => el.key == "receipt_number");
      }

      this.rewardsSetting = res.find((el) => el.key == "students-rewards");
      // console.log("Rewards setting:", this.rewardsSetting);

      this.taxSetting = res.find((el) => el.key == "tax-fee");
      this.rfObj = res.find((el) => el.key == "manage-std-rfID");
      this.joiningDateObj = res.find((el) => el.key == "date_of_joining");

      // admin approval
      const obj = res.find((el) => el.key == "admin-approval");
      if (obj && obj.valueBool && obj.value) {
        this.approvalList = obj.value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      }

      // Force FormWizard to recalculate tabs after rewardsSetting is loaded
      this.$nextTick(() => {
        if (this.$refs.wizard) {
          this.$refs.wizard.activateAll();
        }
      });
    },
    isTaxFee(feeTypeID) {
      // Check if tax-fee setting is enabled and the fee type ID matches
      if (
        !this.taxSetting ||
        !this.taxSetting.valueBool ||
        !this.taxSetting.value
      ) {
        return false;
      }

      // Split the comma-separated values and check if the feeTypeID matches any of them
      const taxFeeIds = this.taxSetting.value
        .split(",")
        .map((id) => parseInt(id.trim()))
        .filter((id) => !isNaN(id));
      return taxFeeIds.includes(feeTypeID);
    },
    addReward() {
      this.rewardsData.push({ title: "", description: "", points: 0 });
    },
    removeReward(index) {
      this.rewardsData.splice(index, 1);
    },
    saveRewards() {
      this.savingRewards = true;
      // Add your logic to save rewards
      this.savingRewards = false;
    },
    cancelAddReward() {
      this.showAddRewardModal = false;
      this.newReward = {
        title: "",
        description: "",
        points: 0,
      };
    },
    addReward() {
      this.rewardsData.push({
        title: this.newReward.title,
        description: this.newReward.description,
        points: this.newReward.points,
        date: new Date(),
      });
      this.showAddRewardModal = false;
      this.newReward = {
        title: "",
        description: "",
        points: 0,
      };
    },
    calculateTotalPoints() {
      return this.rewardsData.reduce(
        (total, reward) => total + reward.points,
        0
      );
    },

    // Driver-related methods
    async onDriverTabClick() {
      if (!this.driverDataLoaded) {
        const driverCampusId =
          Number(this.myObj?.campusID) ||
          Number(this.$store.state.userData.cId) ||
          0;
        await this.loadDriverOptions(driverCampusId);
      }
      // Re-apply saved assignments if selects are still empty (e.g. options loaded late)
      if (
        this.pendingStudentDrivers &&
        this.pendingStudentDrivers.length &&
        (!this.studentDrivers.length ||
          !this.studentDrivers.some((d) => d.selectedDriver))
      ) {
        this.populateStudentDrivers(this.pendingStudentDrivers);
      }
    },

    emptyDriverEntry() {
      return {
        selectedDriver: null,
        selectedVehicle: null,
        vehicleOptions: [],
        relation: "",
        id: 0,
        sID: 0,
        driverID: 0,
        vehicleID: 0,
        campusID:
          Number(this.myObj?.campusID) ||
          Number(this.$store.state.userData.cId) ||
          0,
      };
    },

    populateStudentDrivers(driversList = []) {
      const list = Array.isArray(driversList) ? driversList : [];
      if (!list.length) {
        this.studentDrivers = [this.emptyDriverEntry()];
        return;
      }

      this.studentDrivers = list.map((driverData, index) => {
        const driverEntry = {
          selectedDriver: null,
          selectedVehicle: null,
          vehicleOptions: [],
          relation: driverData.relation || "",
          id: Number(driverData.id) || 0,
          sID: Number(driverData.sID) || Number(this.$route.params.id) || 0,
          driverID: Number(driverData.driverID) || 0,
          vehicleID: Number(driverData.vehicleID) || 0,
          campusID:
            Number(driverData.campusID) ||
            Number(this.myObj?.campusID) ||
            Number(this.$store.state.userData.cId) ||
            0,
        };

        driverEntry.selectedDriver =
          this.driverOptions.find(
            (driver) => Number(driver.id) === Number(driverData.driverID)
          ) || null;

        if (driverEntry.selectedDriver) {
          this.onStudentDriverChange(driverEntry, index);
          driverEntry.selectedVehicle =
            (driverEntry.vehicleOptions || []).find(
              (vehicle) => Number(vehicle.id) === Number(driverData.vehicleID)
            ) || null;
        }

        return driverEntry;
      });
    },

    async loadDriverOptions(campusID = null) {
      this.driverLoading = true;
      try {
        const cID =
          Number(campusID) ||
          Number(this.myObj?.campusID) ||
          Number(this.$store.state.userData.cId) ||
          0;
        const obj = {
          url:
            this.$store.state.domain +
            "Driver/loadData?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            cID,
          token: this.$store.state.userData.token,
        };
        // console.log("API URL:", obj.url);
        const response = await this.get(obj);
        // console.log("API Response:", response);

        // Handle the API response structure - response is directly an array
        if (response && Array.isArray(response)) {
          this.driverOptions = response.map((driver) => ({
            id: driver.driver.id,
            name: driver.driver.name,
            contact: driver.driver.contact,
            address: driver.driver.address,
            cnic: driver.driver.cnic,
            licenseNo: driver.driver.licenseNo,
            attachments: driver.driver.attachments,
            campusID: driver.driver.campusID,
            details: driver.details || [],
          }));
          // console.log("Driver options loaded:", this.driverOptions);
          // console.log("First driver name:", this.driverOptions[0]?.name);
          this.driverDataLoaded = true;
        } else if (
          response &&
          response.status === "success" &&
          response.data &&
          Array.isArray(response.data)
        ) {
          // Fallback for wrapped response structure
          this.driverOptions = response.data.map((driver) => ({
            id: driver.driver.id,
            name: driver.driver.name,
            contact: driver.driver.contact,
            address: driver.driver.address,
            cnic: driver.driver.cnic,
            licenseNo: driver.driver.licenseNo,
            attachments: driver.driver.attachments,
            campusID: driver.driver.campusID,
            details: driver.details || [],
          }));
          // console.log("Driver options loaded (wrapped):", this.driverOptions);
          // console.log("First driver name:", this.driverOptions[0]?.name);
          this.driverDataLoaded = true;
        } else {
          this.driverOptions = [];
          // console.log("No driver data found");
        }
      } catch (error) {
        console.error("Error loading driver options:", error);
        this.driverOptions = [];
      } finally {
        this.driverLoading = false;
      }
    },

    onDriverChange(selectedDriver) {
      // console.log("Driver changed:", selectedDriver);
      this.selectedVehicle = null;
      if (
        selectedDriver &&
        selectedDriver.details &&
        Array.isArray(selectedDriver.details)
      ) {
        this.vehicleOptions = selectedDriver.details.map((vehicle) => ({
          id: vehicle.id,
          driverID: vehicle.driverID,
          brand: vehicle.brand,
          model: vehicle.model,
          variant: vehicle.variant,
          color: vehicle.color,
          vehicleNo: vehicle.vehicleNo,
          chassisNo: vehicle.chassisNo,
          engineNo: vehicle.engineNo,
          images: vehicle.images,
          campusID: vehicle.campusID,
        }));
        // console.log(
        //   "Vehicle options loaded for driver:",
        //   selectedDriver.name,
        //   this.vehicleOptions
        // );
        // console.log("First vehicle:", this.vehicleOptions[0]);
      } else {
        this.vehicleOptions = [];
        // console.log("No vehicle data found for driver:", selectedDriver?.name);
      }
    },
    onStudentDriverChange(driverEntry, index) {
      // console.log("Student driver changed:", driverEntry.selectedDriver);
      driverEntry.selectedVehicle = null;
      if (
        driverEntry.selectedDriver &&
        driverEntry.selectedDriver.details &&
        Array.isArray(driverEntry.selectedDriver.details)
      ) {
        driverEntry.vehicleOptions = driverEntry.selectedDriver.details.map(
          (vehicle) => ({
            id: vehicle.id,
            driverID: vehicle.driverID,
            brand: vehicle.brand,
            model: vehicle.model,
            variant: vehicle.variant,
            color: vehicle.color,
            vehicleNo: vehicle.vehicleNo,
            chassisNo: vehicle.chassisNo,
            engineNo: vehicle.engineNo,
            images: vehicle.images,
            campusID: vehicle.campusID,
          })
        );
        // console.log(
        //   "Vehicle options loaded for student driver:",
        //   driverEntry.selectedDriver.name,
        //   driverEntry.vehicleOptions
        // );
        // console.log("First vehicle in options:", driverEntry.vehicleOptions[0]);
      } else {
        driverEntry.vehicleOptions = [];
        // console.log(
        //   "No vehicle data found for student driver:",
        //   driverEntry.selectedDriver?.name
        // );
      }
    },
    addDriverEntry() {
      this.studentDrivers.push({
        selectedDriver: null,
        selectedVehicle: null,
        vehicleOptions: [],
        relation: "",
        id: 0,
        sID: 0,
        driverID: 0,
        vehicleID: 0,
        campusID: this.$store.state.userData.cId,
      });
    },
    removeDriverEntry(index) {
      if (this.studentDrivers.length > 1) {
        this.studentDrivers.splice(index, 1);
      }
    },

    async loadVehicleOptions() {
      // Vehicle options are loaded when driver is selected
      this.vehicleLoading = false;
      this.vehicleOptions = [];
    },

    openDriverManagementModal() {
      this.showDriverManagementModal = true;
      // Load driver data if not already loaded
      if (!this.driverDataLoaded) {
        this.loadDriverOptions();
      }
    },

    closeDriverManagementModal() {
      this.showDriverManagementModal = false;
    },

    openAddDriverModal() {
      this.isEditMode = false;
      this.resetDriverForm();
      this.showDriverModal = true;
      this.showDriverManagementModal = false; // Close management modal
      this.loadVehicleOptions();
      this.resetDriverValidation();
    },

    async openEditDriverModal() {
      this.isEditMode = true;
      this.resetDriverForm();
      this.showDriverModal = true;
      this.loadVehicleOptions();
      this.resetDriverValidation();
      await this.loadDriverData();

      // Set the selected driver and vehicle in the main form
      if (this.driverInfo && this.driverInfo.id) {
        const driverOption = this.driverOptions.find(
          (driver) => driver.id === this.driverInfo.id
        );
        if (driverOption) {
          this.selectedDriver = driverOption;
          this.onDriverChange(driverOption);

          // Set the first vehicle as selected if available
          if (this.vehicleOptions.length > 0) {
            this.selectedVehicle = this.vehicleOptions[0];
          }
        }
      }
    },

    editDriverFromTable(driver) {
      this.isEditMode = true;
      this.resetDriverForm();
      this.showDriverModal = true;
      this.showDriverManagementModal = false; // Close management modal
      this.loadVehicleOptions();
      this.resetDriverValidation();

      // Populate the form with the selected driver's data
      this.driverInfo = {
        id: driver.id,
        name: driver.name,
        contact: driver.contact,
        address: driver.address,
        cnic: driver.cnic,
        licenseNo: driver.licenseNo,
        attachments: driver.attachments ? driver.attachments.split(",") : [],
        campusID: driver.campusID,
      };

      // Populate vehicle details
      if (driver.details && Array.isArray(driver.details)) {
        this.vehicleDetails = driver.details.map((vehicle) => ({
          id: vehicle.id,
          driverID: vehicle.driverID,
          brand: vehicle.brand || "",
          model: vehicle.model || "",
          variant: vehicle.variant || "",
          color: vehicle.color || "",
          vehicleNo: vehicle.vehicleNo || "",
          chassisNo: vehicle.chassisNo || "",
          engineNo: vehicle.engineNo || "",
          images: vehicle.images ? vehicle.images.split(",") : [],
          campusID: vehicle.campusID,
        }));
      }
    },

    async loadDriverData() {
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Driver/loadData?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        };
        const response = await this.get(obj);
        console.log("Driver data loaded:", response);

        // Handle the API response structure - response is directly an array
        let driverData = null;
        if (response && Array.isArray(response) && response.length > 0) {
          driverData = response[0]; // Get first driver data
        } else if (
          response &&
          response.status === "success" &&
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          driverData = response.data[0]; // Get first driver data
        } else if (response && response.driver) {
          driverData = response;
        }

        if (driverData && driverData.driver) {
          this.driverInfo = {
            id: driverData.driver.id,
            name: driverData.driver.name || "",
            contact: driverData.driver.contact || "",
            address: driverData.driver.address || "",
            cnic: driverData.driver.cnic || "",
            licenseNo: driverData.driver.licenseNo || "",
            attachments: driverData.driver.attachments
              ? driverData.driver.attachments.split(",")
              : [],
            campusID: driverData.driver.campusID,
          };
        }

        if (
          driverData &&
          driverData.details &&
          Array.isArray(driverData.details)
        ) {
          this.vehicleDetails = driverData.details.map((vehicle) => ({
            id: vehicle.id,
            driverID: vehicle.driverID,
            brand: vehicle.brand || "",
            model: vehicle.model || "",
            variant: vehicle.variant || "",
            color: vehicle.color || "",
            vehicleNo: vehicle.vehicleNo || "",
            chassisNo: vehicle.chassisNo || "",
            engineNo: vehicle.engineNo || "",
            images: vehicle.images ? vehicle.images.split(",") : [],
            campusID: vehicle.campusID,
          }));
        }
      } catch (error) {
        console.error("Error loading driver data:", error);
        this.$bvToast.toast(this.$t("Error loading driver data"), {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      }
    },

    cancelDriverModal() {
      this.showDriverModal = false;
      this.resetDriverForm();
    },

    resetDriverForm() {
      this.driverInfo = {
        id: null,
        name: "",
        contact: "",
        address: "",
        cnic: "",
        licenseNo: "",
        attachments: [],
        campusID: this.$store.state.userData.cId,
      };
      this.vehicleDetails = [
        {
          id: 0,
          driverID: 0,
          brand: "",
          model: "",
          variant: "",
          color: "",
          vehicleNo: "",
          chassisNo: "",
          engineNo: "",
          images: [],
          campusID: this.$store.state.userData.cId,
        },
      ];
      this.resetDriverValidation();
    },

    resetDriverValidation() {
      this.driverValidation = {
        name: null,
        contact: null,
        cnic: null,
        licenseNo: null,
      };
      this.vehicleValidation = this.vehicleDetails.map(() => ({
        brand: null,
        vehicleNo: null,
      }));
    },

    validateDriverForm() {
      let isValid = true;

      // Validate driver info
      if (!this.driverInfo.name || this.driverInfo.name.trim() === "") {
        this.driverValidation.name = false;
        isValid = false;
      } else {
        this.driverValidation.name = true;
      }

      if (!this.driverInfo.contact || this.driverInfo.contact.trim() === "") {
        this.driverValidation.contact = false;
        isValid = false;
      } else {
        this.driverValidation.contact = true;
      }

      if (!this.driverInfo.cnic || this.driverInfo.cnic.trim() === "") {
        this.driverValidation.cnic = false;
        isValid = false;
      } else {
        this.driverValidation.cnic = true;
      }

      if (
        !this.driverInfo.licenseNo ||
        this.driverInfo.licenseNo.trim() === ""
      ) {
        this.driverValidation.licenseNo = false;
        isValid = false;
      } else {
        this.driverValidation.licenseNo = true;
      }

      // Validate vehicle details - at least one vehicle required
      if (this.vehicleDetails.length === 0) {
        isValid = false;
      }

      this.vehicleDetails.forEach((vehicle, index) => {
        if (!this.vehicleValidation[index]) {
          this.vehicleValidation[index] = {};
        }

        if (!vehicle.brand || vehicle.brand.trim() === "") {
          this.vehicleValidation[index].brand = false;
          isValid = false;
        } else {
          this.vehicleValidation[index].brand = true;
        }

        if (!vehicle.vehicleNo || vehicle.vehicleNo.trim() === "") {
          this.vehicleValidation[index].vehicleNo = false;
          isValid = false;
        } else {
          this.vehicleValidation[index].vehicleNo = true;
        }
      });

      return isValid;
    },

    async saveDriverInfo() {
      if (!this.validateDriverForm()) {
        this.$bvToast.toast(this.$t("Please fill in all required fields"), {
          title: this.$t("Validation Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      try {
        // Create payload with exact structure you specified
        const payload = {
          driver: {
            id: this.isEditMode ? this.driverInfo.id : 0,
            name: this.driverInfo.name,
            contact: this.driverInfo.contact,
            address: this.driverInfo.address,
            cnic: this.driverInfo.cnic,
            licenseNo: this.driverInfo.licenseNo,
            attachments: this.driverInfo.attachments.join(","),
            campusID: this.$store.state.userData.cId,
          },
          details: this.vehicleDetails.map((vehicle) => ({
            id: this.isEditMode ? vehicle.id : 0,
            driverID: vehicle.driverID,
            brand: vehicle.brand,
            model: vehicle.model,
            variant: vehicle.variant,
            color: vehicle.color,
            vehicleNo: vehicle.vehicleNo,
            chassisNo: vehicle.chassisNo,
            engineNo: vehicle.engineNo,
            images: vehicle.images.join(","),
            campusID: this.$store.state.userData.cId,
          })),
        };

        const driverObj = {
          url:
            this.$store.state.domain +
            "Driver/save?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
          body: payload,
          message: "Driver information saved successfully.",
          context: this,
        };

        console.log("Saving driver with payload:", payload);
        const success = await this.post(driverObj);
        console.log("Driver saved:", success);

        if (success) {
          this.showDriverModal = false;
          this.resetDriverForm();
          this.loadVehicleOptions();

          // Always refresh driver data after save
          await this.loadDriverOptions();
        }
      } catch (error) {
        console.error("Error saving driver info:", error);
        this.$bvToast.toast(this.$t("Error saving driver information"), {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      }
    },

    addVehicleDetail() {
      this.vehicleDetails.push({
        id: 0,
        driverID: 0,
        brand: "",
        model: "",
        variant: "",
        color: "",
        vehicleNo: "",
        chassisNo: "",
        engineNo: "",
        images: [],
        campusID: this.$store.state.userData.cId,
      });
      this.vehicleValidation.push({
        brand: null,
        vehicleNo: null,
      });
    },

    removeVehicleDetail(index) {
      if (this.vehicleDetails.length > 1) {
        this.vehicleDetails.splice(index, 1);
        this.vehicleValidation.splice(index, 1);
      } else {
        this.$bvToast.toast(
          this.$t("At least one vehicle detail is required"),
          {
            title: this.$t("Validation Error"),
            variant: "warning",
            solid: true,
          }
        );
      }
    },

    async handleDriverAttachmentUpload(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;

      if (!this.driverInfo.attachments) {
        this.driverInfo.attachments = [];
      }

      for (let file of files) {
        try {
          const uploaded = await uploadToMySkool([file]);
          const filePath = getUploadPath(uploaded[0]);
          if (filePath) {
            this.driverInfo.attachments.push(filePath);
          }
        } catch (error) {
          console.error("Error uploading driver attachment:", error);
          this.$bvToast.toast(this.$t("Error uploading attachment"), {
            title: this.$t("Upload Error"),
            variant: "danger",
            solid: true,
          });
        }
      }

      // Clear the file input
      event.target.value = "";
    },

    async handleVehicleImageUpload(event, index) {
      const files = event.target.files;
      if (!files || files.length === 0) return;

      const vehicle = this.vehicleDetails[index];
      if (!vehicle.images) {
        vehicle.images = [];
      }

      for (let file of files) {
        if (file.type.startsWith("image/")) {
          try {
            const uploaded = await uploadToMySkool([file]);
            const filePath = getUploadPath(uploaded[0]);
            if (filePath) {
              vehicle.images.push(filePath);
            }
          } catch (error) {
            console.error("Error uploading vehicle image:", error);
            this.$bvToast.toast(this.$t("Error uploading image"), {
              title: this.$t("Upload Error"),
              variant: "danger",
              solid: true,
            });
          }
        }
      }

      // Clear the file input
      event.target.value = "";
    },
  },
};
</script>
<style>
.wizard-tab-content {
  padding-top: 10px !important;
}

.heading {
  padding: 0;
  margin: 2.171303074670571vw 0;
  /* text-shadow: -4px 0 5px white, 0 4px 5px white, 4px 0 5px white,
    0 -4px 5px white; */
}

.input-form {
  margin: 0 70px;
  background: #fff;
}

#fileInput .custom-file-label {
  color: #707070;
  border: 1px dashed #33312f;
  text-align: center;
  padding: 2.5rem 1.5rem;
  width: 100%;
}

#fileInput input {
  display: none;
}

#imgInput input {
  display: none;
}

#imgInput {
  /* height: 8rem; */
  width: 50%;
}

#imgInput div {
  height: 8vw;
}

#imgInput .custom-file-label {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.type {
  background-color: red;
  border-radius: 10px;
  font-size: 0.8rem;
  padding: 10px;
  color: white;
}

.filename {
  padding-left: 25px;
}

.delete {
  margin: 0 0 0 auto;
  color: red;
}

#checkbox-1 {
  margin-right: 10px !important;
}

.submit {
  background-color: #00c192;
  color: #fff;
  width: 16.5vw;
  height: 4vw;
  font-weight: bold;
  border-color: #00c192;
}

.form-file-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 20px;
}

/* Driver Action Buttons Styling */
.driver-action-btn {
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease !important;
  min-width: 32px !important;
  min-height: 32px !important;
}

.driver-action-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.add-btn {
  background-color: #6f42c1 !important;
  /* Purple background */
  color: white !important;
  border-color: #6f42c1 !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  box-shadow: 0 2px 6px rgba(111, 66, 193, 0.3) !important;
}

.add-btn:hover {
  background-color: #5a32a3 !important;
  border-color: #5a32a3 !important;
  color: white !important;
  box-shadow: 0 4px 8px rgba(111, 66, 193, 0.4) !important;
}

.remove-btn {
  background-color: #dc3545 !important;
  /* Solid red background */
  color: white !important;
  border-color: #dc3545 !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.3) !important;
}

.remove-btn:hover {
  background-color: #c82333 !important;
  /* Darker red on hover */
  color: white !important;
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.4) !important;
}

/* #prop-det, #prop-det div {
  height: 100%;
} */

.item-group {
  width: 50%;
  /* margin-top: 2.269399707174231vw; */
}

.inputfields,
.inputfields:focus {
  border: 1px solid #33312f;
  border-radius: 0.5856515373352855vw;
  height: 2.562225475841874vw;
  outline: none !important;
  resize: none;
}

textarea.form-control {
  height: 8vw !important;
}

@media only screen and (max-width: 990px) {
  .mob-setting {
    padding: 0 1rem !important;
    width: 100vw !important;
    margin: 0 auto !important;
  }

  .mobile-view {
    margin: 0 !important;
  }

  /* .col-form-label,
  .form-file-text,
  .custom-control-label {
    font-size: 3vw;
  } */
  .item-group {
    margin-top: 0;
  }

  .margin-top-mobile {
    margin-top: 5vw;
  }

  /* .col-form-label {
    display: none;
  } */
  .form-input-mobile-text {
    width: 92vw;
    margin: 10px auto;
    border-radius: 2.8301610541727673vw;
    height: 12.781844802342606vw;
    font-size: 5.171303074670571vw;
    background-color: #f2f2f2 !important;
    border: 1px solid #33312f;
  }

  textarea.form-control {
    height: 12.781844802342606vw !important;
  }

  .form-input-mobile-text:focus {
    background-color: #00c192 !important;
    color: #fff !important;
  }

  .form-input-mobile-text::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(190, 190, 190);
    opacity: 1;
    /* Firefox */
    font-family: DINNextRoundedLTW01-Regular;
  }

  .form-input-mobile-text:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgb(190, 190, 190);
  }

  .form-input-mobile-text::-ms-input-placeholder {
    /* Microsoft Edge */
    color: rgb(190, 190, 190);
  }

  .form-input-mobile-text:focus::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #fff;
  }

  .form-file-input-mobile {
    border-radius: 2.8301610541727673vw;
    height: 12.781844802342606vw;
    background-color: #f2f2f2 !important;
    color: #fff !important;
  }

  .custom-file-label {
    border-radius: 2.8301610541727673vw !important;
    height: 12.781844802342606vw;
    background-color: #f2f2f2 !important;
    color: #000 !important;
    height: 40vw;
    border: 1px solid #33312f;
  }

  .submit {
    width: 50vw;
    height: 10vw;
  }

  .filename {
    font-size: 3vw;
  }

  .shadowHead {
    font-size: 8vw !important;
  }

  #imgInput div {
    height: 29vw !important;
  }

  .item-group {
    height: 30vw !important;
  }
}

@media only screen and (min-width: 1366px) {
  .submit {
    width: 15.5vw;
    height: 7.8vh;
  }
}

@media only screen and (min-width: 1440px) {
  .submit {
    width: 14.7vw;
    height: 6.7vh;
  }
}

@media only screen and (min-width: 1536px) {
  .submit {
    width: 13.8vw;
    height: 6.9vh;
  }
}

@media only screen and (min-width: 1920px) {
  .submit {
    width: 11vw;
    height: 5.5vh;
  }
}

#overlay {
  position: fixed;
  /* Sit on top of the page content */
  display: none;
  /* Hidden by default */
  width: 100%;
  /* Full width (cover the whole page) */
  height: 100%;
  /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  /* Black background with opacity */
  z-index: 2;
  /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer;
  /* Add a pointer on hover */
}
</style>
<style scoped>
.rcorners2 {
  border-radius: 100px;
  border: 4px solid var(--primary);
  padding: 2px;
}

.happiness-photo-group {
  margin-bottom: 0;
}

.happiness-photo-slot {
  display: flex;
  justify-content: center;
}

.happiness-photo-frame {
  position: relative;
  width: 140px;
  height: 140px;
  flex-shrink: 0;
}

.happiness-photo-frame--empty {
  border-radius: 50%;
  border: 4px solid var(--primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
}

.happiness-photo-frame--clickable {
  cursor: pointer;
}

.happiness-photo-img {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 4px solid var(--primary);
  padding: 2px;
  object-fit: cover;
  display: block;
  cursor: pointer;
  background: #f3f4f6;
}

.happiness-photo-upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 50%;
  z-index: 3;
}

.happiness-photo-delete-btn {
  position: absolute !important;
  bottom: 0;
  right: 0;
  z-index: 5;
  width: 44px !important;
  height: 44px !important;
  min-width: 44px !important;
  padding: 0 !important;
  border-radius: 10px !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  background-color: #82868b !important;
  border-color: #82868b !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
}

.happiness-photo-delete-btn:hover,
.happiness-photo-delete-btn:focus,
.happiness-photo-delete-btn:active {
  background-color: #6e7378 !important;
  border-color: #6e7378 !important;
}

.sticky {
  position: fixed;
  /* top: 0; */
  right: 2rem;
  /* margin-bottom: 30px; */
  /* position: fixed;
    bottom: 5%;
    z-index: 1031;  */
}

.file-uploader {
  position: relative;
  border: 1px solid #000;
  width: 100%;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
  font-family: "Helvetica", sans-serif;
  height: 100px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.file_upload {
  opacity: 0;

  /* IE 8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";

  /* IE 5-7 */
  filter: alpha(opacity=0);

  /* Netscape or and older firefox browsers */
  -moz-opacity: 0;

  /* older Safari browsers */
  -khtml-opacity: 0;

  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.file {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.file-type {
  background-color: #e62e2d;
  font-family: "Helvetica", sans-serif;
  color: white;
  border-radius: 10px;
  margin-right: 15px;
  height: 50px;
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.file-name {
  font-family: "Helvetica", sans-serif;
  margin: 0px;
}

.file-delete i {
  color: #e62e2d;
  font-size: 2rem;
  cursor: pointer;
}

.modal-header {
  display: none;
}

/* File Upload Area Styles */
.file-upload-area {
  border: 2px dashed #6c5ce7;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-upload-area:hover {
  border-color: #5f3dc4;
  background: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.15);
}

.file-upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.upload-icon {
  color: #6c5ce7;
  transition: all 0.3s ease;
}

.file-upload-area:hover .upload-icon {
  color: #5f3dc4;
  transform: scale(1.1);
}

.upload-text {
  color: #666;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s ease;
}

.file-upload-area:hover .upload-text {
  color: #5f3dc4;
}

/* ── Sibling student search ── */
.search-section {
  margin-bottom: 0;
}
.search-input {
  border-radius: 8px !important;
  border: 1.5px solid #e0d8ff !important;
  padding: 8px 12px;
  font-size: 14px;
  width: 100%;
}
.search-input:focus {
  border-color: #7c5dfa !important;
  box-shadow: 0 0 0 0.2rem rgba(124, 93, 250, 0.2) !important;
}
.search-results {
  position: relative;
  z-index: 1000;
  background: #fff;
  border: 1px solid #e0d8ff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(115, 103, 240, 0.12);
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 6px;
}
.student-options {
  max-height: none;
  overflow: visible;
}
.student-option {
  padding: 10px 14px;
  border-bottom: 1px solid #f3f0ff;
  cursor: pointer;
  transition: background 0.15s ease, border-left 0.15s ease,
    transform 0.15s ease;
  overflow: visible;
}
.student-option:last-child {
  border-bottom: none;
}
.student-option:hover {
  background: #f5f2ff;
  border-left: 3px solid #7c5dfa;
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(124, 93, 250, 0.1);
}
.student-option:active {
  background: #ede9ff;
  transform: translateX(1px);
}
.empty-state {
  padding: 32px 20px;
  text-align: center;
  color: #9ca3af;
}
.empty-state p {
  margin-top: 10px;
  font-size: 13px;
}
.loading-state {
  padding: 18px;
  text-align: center;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
}
.search-results::-webkit-scrollbar {
  width: 5px;
}
.search-results::-webkit-scrollbar-track {
  background: #f3f0ff;
  border-radius: 4px;
}
.search-results::-webkit-scrollbar-thumb {
  background: #c4b5fd;
  border-radius: 4px;
}
.search-results::-webkit-scrollbar-thumb:hover {
  background: #7c5dfa;
}
.search-results * {
  overflow: visible !important;
}
.student-options * {
  overflow: visible !important;
}
.selected-student {
  padding: 9px 12px;
  background: linear-gradient(135deg, #f5f2ff 0%, #ede9ff 100%);
  border: 1px solid #ddd6fe;
  border-left: 3px solid #7c5dfa;
  border-radius: 8px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
.back-btn {
  &:hover {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%) !important;
    color: #ffffff !important;
    border-color: transparent;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(124, 93, 250, 0.2) !important;
  }
}

#modal-happiness-dropdown___BV_modal_outer_ .modal-backdrop {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.25) !important;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.happiness-dropdown-modal-wrapper {
  .modal-dialog {
    max-width: 560px;
    box-shadow: none !important;
  }

  .happiness-dropdown-modal-content {
    border: 1px solid rgba(115, 103, 240, 0.12);
    border-radius: 16px;
    box-shadow: none !important;
    max-height: 90vh;
    overflow: hidden;
  }

  .happiness-dropdown-modal-header {
    background: linear-gradient(
      135deg,
      rgba(115, 103, 240, 0.1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    border-bottom: 1px solid rgba(115, 103, 240, 0.1);
    padding: 1.15rem 3.25rem 1.15rem 1.35rem;
    border-radius: 16px 16px 0 0;
    position: relative;
    overflow: visible;

    .close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 0;
      padding: 0;
      width: 46px;
      height: 46px;
      opacity: 1;
      text-shadow: none;
      float: none;
      border: none;
      border-radius: 0 16px 0 14px;
      background: #7367f0;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.35rem;
      transition: transform 0.2s ease, background 0.2s ease;

      &:hover,
      &:focus {
        opacity: 1;
        outline: none;
        background: #6254e8;
        transform: scale(1.08);
      }
    }
  }

  .happiness-dropdown-modal-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    h5 {
      font-weight: 600;
      color: #4b465c;
      font-size: 1.05rem;
    }
  }

  .happiness-dropdown-modal-title-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.35);
    flex-shrink: 0;
  }

  .happiness-dropdown-modal-subtitle {
    color: #a8aaae;
    font-size: 0.78rem;
  }

  .happiness-dropdown-modal-body {
    padding: 1.15rem 1.35rem 1.35rem;
    background: #f8f7fc;
    overflow: hidden;
  }

  .happiness-dropdown-modal-add-panel {
    display: flex;
    gap: 0.65rem;
    padding: 0.85rem;
    background: #fff;
    border: 1px solid rgba(115, 103, 240, 0.1);
    border-radius: 12px;
    margin-bottom: 0.85rem;
  }

  .happiness-dropdown-modal-input {
    border-radius: 10px;
    border-color: #e4e1f0;

    &:focus {
      border-color: rgba(115, 103, 240, 0.45);
      box-shadow: 0 0 0 0.15rem rgba(115, 103, 240, 0.12);
    }
  }

  .happiness-dropdown-modal-add-btn {
    border-radius: 10px;
    padding-left: 1rem;
    padding-right: 1rem;
    white-space: nowrap;
  }

  .happiness-dropdown-modal-search {
    position: relative;
    margin-bottom: 0.85rem;
  }

  .happiness-dropdown-modal-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #b9b9c3;
    z-index: 2;
    pointer-events: none;
  }

  .happiness-dropdown-modal-search-input {
    padding-left: 2.25rem;
    background: #fff;
  }

  .happiness-dropdown-modal-table-wrap {
    max-height: 50vh;
    overflow-y: auto;
    background: #fff;
    border: 1px solid rgba(115, 103, 240, 0.1);
    border-radius: 12px;
    scrollbar-width: thin;
    scrollbar-color: rgba(115, 103, 240, 0.28) transparent;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(115, 103, 240, 0.22);
      border-radius: 999px;
    }

    table {
      margin-bottom: 0;
    }

    .table thead th {
      position: sticky;
      top: 0;
      z-index: 1;
      background: #f3f2f8;
      border-bottom: 1px solid rgba(115, 103, 240, 0.08);
      color: #6e6b7b;
      font-size: 0.72rem;
      font-weight: 600;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }
  }
}

.happiness-dropdown-add-btn {
  // width: 28px;
  // height: 28px;
  // min-width: 28px;
  padding: 0.25rem !important;
}

/* History Timeline Logs Styles */
.history-timeline-wrap {
  position: relative;
  padding: 0.5rem 0 1rem 3.5rem;
}

.history-timeline-wrap::before {
  content: "";
  position: absolute;
  top: 1.5rem;
  bottom: 2rem;
  left: 1.35rem;
  width: 2px;
  background: #e2e8f0;
  border-radius: 999px;
}

.history-timeline-item {
  position: relative;
  margin-bottom: 1.75rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.history-timeline-point {
  position: absolute;
  left: -3.5rem;
  top: 1.15rem;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
  border: 2px solid #7367f0;
  transition: all 0.2s ease;
}

.history-timeline-point--transfer {
  border-color: #7367f0;
  color: #7367f0;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.22);
}

.history-timeline-point--class {
  border-color: #00cfe8;
  color: #00cfe8;
  box-shadow: 0 4px 14px rgba(0, 207, 232, 0.22);
}

.history-timeline-point--section {
  border-color: #28c76f;
  color: #28c76f;
  box-shadow: 0 4px 14px rgba(40, 199, 111, 0.22);
}

.history-timeline-point--session {
  border-color: #ff9f43;
  color: #ff9f43;
  box-shadow: 0 4px 14px rgba(255, 159, 67, 0.22);
}

.history-timeline-point--status {
  border-color: #ea5455;
  color: #ea5455;
  box-shadow: 0 4px 14px rgba(234, 84, 85, 0.22);
}

.history-timeline-point--promote {
  border-color: #28c76f;
  color: #28c76f;
  box-shadow: 0 4px 14px rgba(40, 199, 111, 0.22);
}

.history-timeline-point--primary {
  border-color: #7367f0;
  color: #7367f0;
}

.history-log-card {
  background: #ffffff;
  border: 1.5px solid #f0edff;
  border-radius: 18px;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 4px 20px rgba(115, 103, 240, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #d4c7ff;
    box-shadow: 0 8px 26px rgba(115, 103, 240, 0.1);
  }
}

.history-card-header {
  gap: 0.75rem;
  margin-bottom: 1.15rem;
}

.history-category-chip {
  display: inline-flex;
  align-items: center;
  font-size: 0.8125rem;
  font-weight: 700;
  padding: 0.38rem 0.85rem;
  border-radius: 999px;
  letter-spacing: 0.01em;
}

.history-category-chip--transfer {
  background: #ede9fe;
  color: #6d28d9;
}

.history-category-chip--class {
  background: #e0f7fa;
  color: #00838f;
}

.history-category-chip--section {
  background: #e8f5e9;
  color: #2e7d32;
}

.history-category-chip--session {
  background: #fff3e0;
  color: #ef6c00;
}

.history-category-chip--status {
  background: #ffebee;
  color: #c62828;
}

.history-category-chip--promote {
  background: #e8f5e9;
  color: #2e7d32;
}

.history-category-chip--primary {
  background: #ede9fe;
  color: #6d28d9;
}

.history-date-chip {
  display: inline-flex;
  align-items: center;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #4b5563;
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
}

.history-card-body {
  padding: 0.25rem 0;
}

.history-change-row {
  margin-bottom: 0.65rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.history-field-label {
  font-size: 0.85rem;
  min-width: 100px;
}

.history-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0.45rem 1rem;
  border-radius: 10px;
  line-height: 1.3;
}

.history-pill--prev {
  background: #fdf2f2;
  color: #991b1b;
  border: 1px solid #fde2e2;
}

.history-pill--muted {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
}

.history-pill--next-transfer {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #d1fae5;
}

.history-pill--next-class {
  background: #e0f2fe;
  color: #0369a1;
  border: 1px solid #bae6fd;
}

.history-pill--next-section {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #d1fae5;
}

.history-pill--next-session {
  background: #fffbeb;
  color: #92400e;
  border: 1px solid #fef3c7;
}

.history-pill--next-status {
  background: #fdf2f2;
  color: #991b1b;
  border: 1px solid #fde2e2;
}

.history-pill--next-promote {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #d1fae5;
}

.history-pill--next-primary {
  background: #ede9fe;
  color: #5b21b6;
  border: 1px solid #ddd6fe;
}

.history-arrow-icon {
  color: #9ca3af;
}

.history-plain-text {
  font-size: 0.95rem;
  color: #374151;
  line-height: 1.5;
}

.history-card-divider {
  border-top: 1px dashed #e5e7eb;
  margin: 1.15rem 0 0.85rem 0;
}

.history-card-footer {
  gap: 0.5rem;
}

.history-meta-pill {
  display: inline-flex;
  align-items: center;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #4b5563;
  padding: 0.35rem 0.85rem;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.history-empty-state {
  border-radius: 14px;
  border: 2px dashed #e5e7eb;
  background: #fafafa;
  margin: 1rem 0;
}
</style>
